{
    "'0 sec' means unlimited time": "'0 sec' means unlimited time",
    "'0 Second(s)' means unlimited time": "'0 Second(s)' means unlimited time",
    "\"Date From\" must be Before then the \"Date To\"": "\"Date From\" must be Before then the \"Date To\"",
    "\"Time To\" must be Greater than the \"Time From\"": "\"Time To\" must be Greater than the \"Time From\"",
    "(SLA Calls + Abandoned in SLA) / Total Calls": "(SLA Calls + Abandoned in SLA) / Total Calls",
    "{count} error(s) occurred": "{count} error(s) occurred",
    "{count} node(s) not connected to any trigger": "{count} node(s) not connected to any trigger",
    "{count} others": "1 other | {count} others",
    "{field} must be at least {count} characters": "{field} must be at least {count} characters",
    "{field} must not exceed {count} characters": "{field} must not exceed {count} characters",
    "{field} should be number": "{field} should be number",
    "{n} Seconds": "{n} Seconds",
    "{quantity} seats have been added to your account.": "{quantity} seats have been added to your account.",
    "{quantity} seats have been removed from your account.": "{quantity} seats have been removed from your account.",
    "+ Add": "+ Add",
    "+ Create": "+ Create",
    "$25 minimum": "$25 minimum",
    "Choose messages to forward!": "Choose messages to forward!",
    "Voice note rejected": "Voice note rejected",
    "{count} new message": "{count} new message",
    "{count} new messages": "{count} new messages",
    "Search user": "Search user",
    "Select Type": "Select Type",
    "Image": "Image",
    "{ext} file": "{ext} file",
    "Something went wrong, please try again later": "Something went wrong, please try again later",
    "+ Add:": "+ Add:",
    "Link Preview Image": "Link Preview Image",
    "Template not yet supported": "Template not yet supported",
    "Drop here": "Drop here",
    "Upload failed": "Upload failed",
    "Click to retry": "Click to retry",
    "Image (JPEG or PNG)": "Image (JPEG or PNG)",
    "Video (MP4)": "Video (MP4)",
    "Animated (MP4)": "Animated (MP4)",
    "Document (PDF only)": "Document (PDF only)",
    "An approved A2P 10DLC brand and campaign are required to send SMS from this number. Please contact your administrator or complete setup under Settings › Channels.": "An approved A2P 10DLC brand and campaign are required to send SMS from this number. Please contact your administrator or complete setup under Settings › Channels.",
    "An approved A2P 10DLC brand and campaign are required to send SMS from this number. Please contact your administrator.": "An approved A2P 10DLC brand and campaign are required to send SMS from this number. Please contact your administrator.",
    "$10 minimum": "$10 minimum",
    "$100000 maximum": "$100,000 maximum",
    "0-5": "0 - 5 Team Members",
    "1 Day": "1 Day",
    "1 hour": "1 hour",
    "1 Hour": "1 Hour",
    "1 Minute": "1 Minute",
    "1 month": "1 month",
    "1 or more participants": "1 or more participants",
    "1 Week": "1 Week",
    "1/1: Charge per second": "1/1: Charge per second",
    "10 seconds": "10 seconds",
    "10-19": "10 - 19 Team Members",
    "12 Hours": "12 Hours",
    "15 minutes": "15 minutes",
    "2 Factor Authentication": "2 Factor Authentication",
    "2 Factor Authentication has been successfully enabled": "2 Factor Authentication has been successfully enabled",
    "2 Factor Authentication: ": "2 Factor Authentication: ",
    "2 or more participants": "2 or more participants",
    "20+": "20 or more",
    "24 / 7 + SLA Commitment": "24 / 7 + SLA Commitment",
    "24 hours": "24 hours",
    "24 Hours": "24 Hours",
    "2FA": "2FA",
    "2FA has been successfully set up": "2FA has been successfully set up",
    "30 minutes": "30 minutes",
    "5 minutes": "5 minutes",
    "5-10": "5 - 10 Team Members",
    "60 seconds": "60 seconds",
    "60/1: Minimum 60 seconds, 1 second increment": "60/1: Minimum 60 seconds, 1 second increment",
    "60/60: Minimum 60 seconds, 60 second increment": "60/60: Minimum 60 seconds, 60 second increment",
    "A detailed description is required to help us assist you.": "A detailed description is required to help us assist you.",
    "A file was skipped because it": "A file was skipped because it",
    "A list of announcements": "A list of announcements",
    "A list of conference rooms": "A list of conference rooms",
    "A list of contacts associated with your account": "A list of contacts associated with your account",
    "A list of default Caller IDs used to make calls": "A list of default Caller IDs used to make calls.",
    "A list of team members for this account": "A list of team members for this account",
    "A list of users for this account and their assigned roles": "A list of users for this account and their assigned roles.",
    "A new user will add $25 to your next invoice. Once activated, a prorated charge will apply for the rest of this [month/year].": "A new user will add $25 to your next invoice. Once activated, a prorated charge will apply for the rest of this [month/year].",
    "A reset password email has been successfully sent to": "A reset password email has been successfully sent to {email}.",
    "A server error occurred during request execution": "A server error occurred during request execution",
    "A telephone designed to work with SIP technology for making and receiving calls": "A telephone designed to work with SIP technology for making and receiving calls.",
    "A title is required to describe your issue.": "A title is required to describe your issue.",
    "A transcription is being generated for this call.": "A transcription is being generated for this call.",
    "A valid phone number": "A valid phone number",
    "A verified Meta Business Account": "A verified Meta Business Account.",
    "A webphone allows making and receiving phone calls directly from the web browser using a dial panel": "A webphone allows making and receiving phone calls directly from the web browser using a dial panel.",
    "A WhatsApp business profile": "A WhatsApp business profile",
    "A2P 10DLC Campaigns": "A2P 10DLC Campaigns",
    "A2P 10DLC Registration": "A2P 10DLC Registration",
    "A2P 10DLC registration approved for Campaign ID: {id}": "A2P 10DLC registration approved for Campaign ID: {id}",
    "A2P 10DLC registration needed to send SMS messages": "A2P 10DLC registration needed to send SMS messages",
    "A2P Campaign": "A2P Campaign",
    "A2P campaign created successfully": "A2P campaign created successfully",
    "A2P campaign submitted successfully": "A2P campaign submitted successfully",
    "A2P campaign updated successfully": "A2P campaign updated successfully",
    "abandoned": "Abandoned",
    "Abandoned": "Abandoned",
    "abandoned calls": "abandoned calls",
    "Abandoned Calls": "Abandoned Calls",
    "Abandoned Calls Configuration": "Abandoned Calls Configuration",
    "Abandoned Calls Ignored": "Abandoned Calls Ignored",
    "Abandoned Calls Ignored: SLA Calls / (Total Calls - Abandoned in SLA)": "Abandoned Calls Ignored: SLA Calls / (Total Calls - Abandoned in SLA)",
    "Abandoned Calls Negative Impact": "Abandoned Calls Negative Impact",
    "Abandoned Calls Negative Impact:": "Abandoned Calls Negative Impact:",
    "Abandoned Calls Negative Impact: SLA Calls / Total Calls": "Abandoned Calls Negative Impact: SLA Calls / Total Calls",
    "Abandoned Calls Positive Impact": "Abandoned Calls Positive Impact",
    "Abandoned Calls Positive Impact:": "Abandoned Calls Positive Impact:",
    "Abandoned Calls Positive Impact: (SLA Calls + Abandoned in SLA) / Total Calls": "Abandoned Calls Positive Impact: (SLA Calls + Abandoned in SLA) / Total Calls",
    "abandoned calls tooltip kpi": "The percentage of calls that were disconnected before being answered by an agent. A higher percentage may indicate long wait times or caller dissatisfaction.",
    "Abort Cancellation": "Abort Cancellation",
    "Accent": "Accent",
    "accept phone policy": "I agree to receive verification and service messages from PBX.IM at my number. Standard rates may apply. Reply STOP to unsubscribe.",
    "Accept TOC and PP": "By continuing you accept our <terms>Terms & Conditions</terms> and <privacy>Privacy Policy</privacy>.",
    "Access code": "Access code",
    "Access code must be 1 to 10 digits": "Access code must be 1 to 10 digits",
    "Access Code": "Access Code",
    "Access to all PBX communication features": "Access to all PBX.IM communication features",
    "Account": "Account",
    "Account Address": "Account Address",
    "Account balance": "Account balance",
    "Account default": "Account default",
    "Account Default": "Account Default",
    "Account has been successfully logged out": "Account has been successfully logged out",
    "Account Notification": "Account Notification",
    "Account security": "Account security",
    "Account Security": "Account Security",
    "Account security description": "Ensure you’re the only one accessing the account.\n Scan the QR code below using the Google Authenticator app.",
    "Account settings updated": "Account settings updated",
    "Account settings updated successfully": "Account settings updated successfully.",
    "Account setup": "Account setup",
    "Account Setup": "Account Setup",
    "Account setup description": "We need a few more details to set up your account.",
    "Account successfully created": "Account successfully created",
    "Account under review. Some features are currently disabled until the account verification is complete.": "Account under review. Some features are currently disabled until the account verification is complete.",
    "Account under review. Some features are disabled. Please complete the identity verification process to activate full access.": "Account under review. Some features are disabled. Please complete the identity verification process to activate full access.",
    "Accounts": "Accounts",
    "ACD": "ACD",
    "ACD, Auto Attendant, Skill-based routing": "ACD, Auto Attendant, Skill-based routing",
    "Action": "Action",
    "Actions": "Actions",
    "Activate SIP phone": "Activate SIP phone",
    "Activate the flow to make a test call.": "Activate the flow to make a test call.",
    "Activate Web Dialer": "Activate Web Dialer",
    "Activate Web Phone": "Activate Web Phone",
    "Activation": "Activation",
    "Activation requirements": "Activation requirements",
    "Active": "Active",
    "Active call in progress. Hang up to start a new test.": "Active call in progress. Hang up to start a new test.",
    "Active chats": "Active chats",
    "Active session detected": "Active session detected",
    "activity time": "activity time",
    "Add": "Add",
    "Add a custom plan": "Add a custom plan",
    "Add a Phone Number or Extension to start the flow": "Add a Phone Number or Extension to start the flow",
    "Add a TXT record to the domain's DNS records.": "Add a TXT record to the domain's DNS records.",
    "Add a widget to your website and allow customers to call you.": "Add a widget to your website and allow customers to call you.",
    "Add Account": "Add Account",
    "Add Agent Status": "Add Agent Status",
    "Add an FQDN for the SBC": "Add an FQDN for the SBC",
    "Add announcement": "Add announcement",
    "Add Auto Attendant": "Add Auto Attendant",
    "Add Auto Dialer": "Add Auto Dialer",
    "Add Auto Dialer Campaign": "Add Auto Dialer Campaign",
    "Add call": "Add call",
    "Add Call": "Add Call",
    "Add Call Flow": "Add Call Flow",
    "Add Call List": "+ Add Call List",
    "Add Call Log": "Add Call Log",
    "Add Call Queue": "Add Call Queue",
    "Add Campaign": "Add Campaign",
    "Add card": "Add card",
    "Add Route": "Add Route",
    "Add Channels": "Add Channels",
    "Add conference room": "Add conference room",
    "Add contact": "Add contact",
    "Add Contact": "Add Contact",
    "ADD CONTACT": "ADD CONTACT",
    "Add Custom Plan": "Add Custom Plan",
    "Add delay": "Add delay",
    "Add Delay": "Add Delay",
    "Add destination": "Add {value}",
    "Add Destination": "Add Destination",
    "Add dial rule": "Add dial rule",
    "Add domain": "Add domain",
    "Add Domain": "Add Domain",
    "Add domain to Microsoft Domains": "Add domain to Microsoft Domains",
    "Add endpoint": "Add endpoint",
    "Add extension": "Add extension",
    "Add Extension": "Add Extension",
    "Add flow trigger to get started": "Add flow trigger to get started",
    "Add forward": "Add forward",
    "Add funds as you go, based on usage": "Add funds as you go, based on usage",
    "Add funds automatically when the balance falls below the threshold": "Add funds automatically when the balance falls below the threshold",
    "Add funds by topping up or subscribing": "Add funds by topping up or subscribing",
    "Add inbox": "Add inbox",
    "Add Inbox": "Add Inbox",
    "Add inboxes": "Add inboxes",
    "Add intercept group": "Add intercept group",
    "Add IVR": "Add IVR",
    "Add Lead": "Add Lead",
    "Add media": "Add media",
    "Add media file": "Add media file",
    "Add Microsoft Teams": "Add Microsoft Teams",
    "Add more seats to your subscription to bring more team members on board. Each seat allows one additional team member to access all features": "Add more seats to your subscription to bring more team members on board. Each seat allows one additional team member to access all features.",
    "Add new": "Add new",
    "Add New": "Add New",
    "Add new account": "Add new account",
    "Add new announcement": "Add new announcement",
    "Add new card": "Add new card",
    "Add new conference room": "Add new conference room",
    "Add new media file": "Add new media file",
    "Add new voicemail": "Add new voicemail",
    "Add nodes to the flow first.": "Add nodes to the flow first.",
    "Add Note": "Add Note",
    "Add Number": "Add Number",
    "Add numbers using the form on the left": "Add numbers using the form on the left.",
    "Add payment method": "Add payment method",
    "Add Phone Number": "Add Phone Number",
    "Add Plan": "Add Plan",
    "Add Question": "Add Question",
    "Add Queue": "Add Queue",
    "Add Record": "Add Record",
    "Add Reset": "Add Reset",
    "Add ring group": "Add ring group",
    "Add Role": "Add Role",
    "Add Script Tab": "Add Script Tab",
    "Add SIP Trunk": "Add SIP Trunk",
    "Add SMS Campaign": "Add SMS Campaign",
    "Add SMS Forwarding": "Add SMS Forwarding",
    "Add subdomain *": "Add subdomain *",
    "Add team": "Add team",
    "Add Teams Direct Routing": "Add Teams Direct Routing",
    "Add time condition": "Add Business Hours",
    "Add time group": "Add time group",
    "Add trigger": "Add trigger",
    "Add TXT Record": "Add TXT Record",
    "Add User": "Add User",
    "Add voicemail": "Add voicemail",
    "Add Voicemail": "Add Voicemail",
    "Add Wallboard": "Add Wallboard",
    "Add WhatsApp to your Inbox for faster support": "Add WhatsApp to your Inbox for faster support",
    "Add Widget": "Add Widget",
    "Added from question library.": "Added from question library.",
    "Added to question library.": "Added to question library.",
    "Additional call limit": "Additional call limit",
    "Additional calls in time period": "Additional calls in time period",
    "Additional calls to the same destination": "Additional calls to the same destination",
    "Additional information is required to activate the numbers": "Additional information is required to activate the numbers",
    "Additional information is required to activate the numbers. Please send the required documentation to our support at ": "Additional information is required to activate the numbers. Please send the required documentation to our support at ",
    "Additional Users": "Additional Users",
    "address": "address",
    "Address": "Address",
    "adds + to a number not starting with 0": "adds + to a number not starting with 0",
    "adds the 123 prefix to the number": "adds the 123 prefix to the number",
    "adds the 789 suffix to the number": "adds the 789 suffix to the number",
    "Admin": "Admin",
    "admin email": "admin email",
    "Admin Email": "Admin Email",
    "Admin Pin": "Admin Pin",
    "Administrator": "Administrator",
    "advanced": "enterprise",
    "Advanced": "Advanced",
    "Advanced Mode": "Advanced Mode",
    "advanced settings": "advanced settings",
    "After Hours": "After Hours",
    "After level wait time, move to next level": "After level wait time, move to next level",
    "After Media": "After Media",
    "Age": "Age",
    "agent": "Agent",
    "Agent": "Agent",
    "Agent Availability": "Agent Availability",
    "Agent Calls": "Agent Calls",
    "Agent Name": "Agent Name",
    "Agent Number": "Agent Number",
    "Agent Pre-Answer": "Agent Pre-Answer",
    "Agent ring settings": "Agent ring settings",
    "Agent ring time": "Agent ring time",
    "Agent Status": "Agent Status",
    "Agent status created": "Agent status created",
    "Agent status updated": "Agent status updated",
    "Agent With Fewest Calls": "Agent With Fewest Calls",
    "Agent With Least Talk Time": "Agent With Least Talk Time",
    "agent_no_answer": "Agent Timeout",
    "Agents": "Agents",
    "Agents in call": "Agents in call",
    "Agents In Queues": "Agents In Queues",
    "Agents Ready": "Agents Ready",
    "Agriculture": "Agriculture",
    "AI analytics": "AI analytics",
    "ai_first_message": "Hi {name}! How can I help you?",
    "Alert dialog description": "This action cannot be undone. This will permanently delete data from our servers.",
    "All": "All",
    "All countries": "All countries",
    "All groups": "All groups",
    "All integrations": "All integrations",
    "All message types have been selected": "All message types have been selected",
    "All methods must disclose: brand name, message type, frequency, “Message and data rates may apply,” help info, and stop instructions": "All methods must disclose: brand name, message type, frequency, “Message and data rates may apply,” help info, and stop instructions",
    "All Queues": "All Queues",
    "All selected files are unsupported": "All selected files are unsupported",
    "All teams": "All teams",
    "All the features of our plans": "All the features of our plans",
    "All users": "All users",
    "All your SMS enabled numbers are currently in use by existing or draft campaigns": "All your SMS enabled numbers are currently in use by existing or draft campaigns",
    "Allow": "Allow",
    "Allow Access From IP Whitelist Only": "Allow Access From IP Whitelist Only",
    "Allow Call Waiting": "Allow Call Waiting",
    "Allow calls waiting": "Allow calls waiting",
    "Allow inbound calls": "Allow inbound calls",
    "Allow outbound calls": "Allow outbound calls",
    "Allow Outbound Calls": "Allow Outbound Calls",
    "Allowed": "Allowed",
    "Allowed characters: letters, digits, spaces, dot, underscore, hyphen": "Allowed characters: letters, digits, spaces, dot, underscore, hyphen",
    "allowed countries": "allowed countries",
    "Allowed Extensions": "Allowed Extensions",
    "Allowed pauses": "Allowed pauses",
    "Allowed Pauses": "Allowed Pauses",
    "Allowed statuses": "Allowed statuses",
    "Already have a number? Start porting your number after sign-up.": "Already have a number? Start porting your number after sign-up.",
    "Always": "Always",
    "Already have an account?": "Already have an account?",
    "AM": "AM",
    "AMEX": "AMEX",
    "Amount": "Amount",
    "Amount billed monthly per user": "Amount billed monthly per user:",
    "AMX": "AMX",
    "An audio played to the caller upon entering the queue": "An audio played to the caller upon entering the queue",
    "An error occurred while saving the intercept group.": "An error occurred while saving the intercept group.",
    "An error occurred while saving the inbox.": "An error occurred while saving the inbox.",
    "An error occurred while sending the invite": "An error occurred while sending the invite",
    "An error occurred while trying to increase the number of seats": "An error occurred while trying to increase the number of seats",
    "An extension created for Chrome and Edge allowing you to manage calls from anywhere in the browser": "An extension created for Chrome and Edge allowing you to manage calls from anywhere in the browser.",
    "An invitation email has been sent to ": "An invitation email has been sent to {email}.",
    "An invite email has been send to the entered email": "An invite email has been send to the entered email",
    "An invite email has been sent to the entered email": "An invite email has been sent to the entered email",
    "An unexpected error occurred": "An unexpected error occurred",
    "and": "and",
    "and choose": "and choose",
    "Announcement": "Announcement",
    "Announcement description": "Play pre-recorded messages to incoming callers no matter where they are in their waiting process.",
    "Announcements": "Announcements",
    "Anonymous": "Anonymous",
    "Answer": "Answer",
    "Answered": "Answered",
    "Answered and Unanswered": "Answered and Unanswered",
    "answered calls": "answered calls",
    "Answered calls": "Answered calls",
    "Answered Calls": "Answered Calls",
    "Answered Calls (%)": "Answered Calls (%)",
    "Answered Calls + Answered %": "Answered Calls + Answered %",
    "Answered Calls Ignored:": "Answered Calls Ignored:",
    "answered calls tooltip calls report kpi": "The percentage of calls answered. Higher percentages are often better.",
    "answered calls tooltip kpi": "The percentage of calls answered by agents. Higher percentages indicate better response rates and efficient handling of calls.",
    "Answers (%)": "Answers (%)",
    "ANZAC": "ANZAC",
    "API": "API",
    "API Key": "API Key",
    "API key generated successfully": "API key generated successfully",
    "Applicable Disclaimers": "Applicable Disclaimers",
    "Apply": "Apply",
    "Apply for A2P": "Apply for A2P",
    "Apply the policy and assign the DID to a Teams user": "Apply the policy and assign the DID to a Teams user",
    "AppTitle": "PBX.IM",
    "are listening": "are listening",
    "Are there any additional features available with the Auto Attendant service?": "Are there any additional features available with the Auto Attendant service?",
    "are whispering": "are whispering",
    "Are you absolutely sure?": "Are you absolutely sure?",
    "Are you collecting and processing consumer opt-in?": "Are you collecting and processing consumer opt-in?",
    "Are you collecting and processing consumer opt-out?": "Are you collecting and processing consumer opt-out?",
    "Are you sure you want to cancel creating this campaign? Your campaign will be saved as a draft.": "Are you sure you want to cancel creating this campaign? Your campaign will be saved as a draft.",
    "Are you sure you want to cancel?": "Are you sure you want to cancel?",
    "Are you sure you want to change this node?": "Are you sure you want to change this node?",
    "Are you sure you want to check out and leave all queues?": "Are you sure you want to check out and leave all queues?",
    "Are you sure you want to close this conversation?": "Are you sure you want to close this conversation?",
    "Are you sure you want to delete": "Are you sure you want to delete",
    "Are you sure you want to delete account?": "Are you sure you want to delete account?",
    "Are you sure you want to delete this agent status?": "Are you sure you want to delete this agent status?",
    "Are you sure you want to delete this automatic top-up": "Are you sure you want to delete this automatic top-up",
    "Are you sure you want to delete this call queue?": "Are you sure you want to delete this call queue?",
    "Are you sure you want to delete this campaign?": "Are you sure you want to delete this campaign?",
    "Are you sure you want to delete this card": "Are you sure you want to delete this card",
    "Are you sure you want to delete this contact?": "Are you sure you want to delete this contact?",
    "Are you sure you want to delete this dial rule?": "Are you sure you want to delete this dial rule?",
    "Are you sure you want to delete this integration": "Are you sure you want to delete this integration?",
    "Are you sure you want to delete this invitation?": "Are you sure you want to delete this invitation?",
    "Are you sure you want to delete this media?": "Are you sure you want to delete this media?",
    "Are you sure you want to delete this plan?": "Are you sure you want to delete this plan?",
    "Are you sure you want to delete this SIP trunk?": "Are you sure you want to delete this SIP trunk?",
    "Are you sure you want to delete this user?": "Are you sure you want to delete this user?",
    "Are you sure you want to discard invalid numbers": "Are you sure you want to discard invalid numbers?",
    "Are you sure you want to disconnect this account?": "Are you sure you want to disconnect this account?",
    "Are you sure you want to leave the": "Are you sure you want to leave the",
    "Are you sure you want to leave this conversation?": "Are you sure you want to leave this conversation?",
    "Are you sure you want to log out?": "Are you sure you want to log out?",
    "Are you sure you want to top up your account with {amount}": "You are about to add <amount>{value}</amount> to your balance.",
    "Are you sure?": "Are you sure?",
    "Are you sure? This action cannot be undone.": "Are you sure? This action cannot be undone.",
    "Are you using an embedded link of any kind?": "Are you using an embedded link of any kind?",
    "Are you using any embedded phone number beyond the contact number in the HELP response?": "Are you using any embedded phone number beyond the contact number in the HELP response?",
    "Area Code": "Area Code",
    "as a starting point": "as a starting point",
    "As an extra security measure we need to add your phone number": "As an extra security measure we need to add your phone number.",
    "Ascending": "Ascending",
    "Asia": "Asia",
    "Ask a question": "Ask a question",
    "Ask anything": "Ask anything",
    "Ask PBX.IM Assistant or open a support ticket": "Ask PBX.IM Assistant or open a support ticket",
    "ask your AI assistant": "Ask your AI Assistant",
    "ASR": "ASR",
    "Assign agent status": "Assign agent status",
    "Assign Agent Status": "Assign Agent Status",
    "Assign Chat to Agent": "Assign Chat to Agent",
    "Assign to": "Assign to",
    "Assign to Agent": "Assign to Agent",
    "Assign to me": "Assign to me",
    "Assign unique short codes for easy communication": "Assign unique short codes for easy communication.",
    "Assigned": "Assigned",
    "Assigned agents": "Assigned agents",
    "Assigned Agents": "Assigned Agents",
    "Assigned Inboxes": "Assigned Inboxes",
    "Assigned Queues": "Assigned Queues",
    "Assigned to": "Assigned to",
    "Assigned To": "Assigned To",
    "Assigned to queues": "Assigned to queues",
    "Assigned users": "Assigned users",
    "Assigned Users": "Assigned Users",
    "ASX": "ASX",
    "At least 8 characters": "At least 8 characters",
    "At least one route is required": "At least one route is required",
    "At least one email address is required": "At least one email address is required",
    "At least one of IP Authentication Host / ACL or Destination Host is required": "At least one of IP Authentication Host / ACL or Destination Host is required",
    "At least one sample message is required": "At least one sample message is required",
    "at the bottom": "at the bottom",
    "at the bottom of the form": "at the bottom of the form",
    "At the moment, PBX.IM does not accept customers from your area. We will notify you if this changes in the future.": "At the moment, PBX.IM does not accept customers from your area. We will notify you if this changes in the future.",
    "Attach file": "Attach file",
    "Attach File": "Attach File",
    "Attach Message File": "Attach Message File",
    "Attach Voicemail Recording": "Attach Voicemail Recording",
    "Attachments": "Attachments",
    "Attempts": "Attempts",
    "Audio": "Audio",
    "Audio Playback": "Audio Playback",
    "Audio played after the selected media file": "Audio played after the selected media file",
    "Audio played before the selected media file": "Audio played before the selected media file",
    "Audio played once at the start of a call": "Audio played once at the start of a call",
    "Audio played when an invalid key is pressed": "Audio played when an invalid key is pressed",
    "Audio that plays repeatedly after the main message": "Audio that plays repeatedly after the main message",
    "Audio that plays repeatedly after the main message It repeats instructions without the welcome message": "Audio that plays repeatedly after the main message. It repeats instructions without the welcome message.",
    "Audio that plays when the caller is directed to the exit destination": "Audio that plays when the caller is directed to the exit destination",
    "Audio that plays when the caller reaches the limit of options or doesn't input anything, then directs to the exit": "Audio that plays when the caller reaches the limit of options or doesn't input anything, then directs to the exit.",
    "Authentication": "Authentication",
    "Authentication App": "Authentication App",
    "Authentication Required": "Authentication Required",
    "Authentication settings": "Authentication settings",
    "Authenticator app enabled": "Authenticator app enabled",
    "Auto": "Auto",
    "Auto Answer": "Auto Answer",
    "Auto Attendant": "Auto Attendant",
    "Auto Attendant was successfully saved": "Auto Attendant was successfully saved.",
    "Auto dialer": "Auto dialer",
    "Auto Dialer": "Auto Dialer",
    "Auto gain level": "Auto gain level",
    "Auto Gain Level": "Auto Gain Level",
    "Auto record": "Auto record",
    "Auto Record": "Auto Record",
    "Auto top-up": "Auto top-up",
    "Auto Top-up deleted": "Auto Top-up deleted",
    "Auto Top-up saved": "Auto Top-up saved",
    "Auto Top-up successful": "Auto Top-up successful",
    "Auto-answer calls for available agents": "Auto-answer calls for available agents",
    "Auto-Arrange Flow": "Auto-Arrange Flow",
    "Auto-detect": "Auto-detect",
    "Auto-Detect (Recommended)": "Auto-Detect (Recommended)",
    "Auto-detect: if more than 60% of calls are from a region, we automatically move the record to that region.": "Auto-detect: if more than 60% of calls are from a region, we automatically move the record to that region.",
    "Auto-layout": "Auto-layout",
    "Auto-pause on unanswered queue calls": "Auto-pause on unanswered queue calls",
    "Auto: An agent joins a queue automatically on check in": "Auto: An agent joins a queue automatically on check in",
    "Automatic logout": "Automatic logout",
    "Automatically top up balance with <b>{upTo}</b> when it falls below <b>{below}</b>": "Automatically top up balance with <b>{upTo}</b> when it falls below <b>{below}</b>",
    "Available": "Available",
    "Available agents": "Available agents",
    "Available Extensions": "Available Extensions",
    "Available queues": "Available queues",
    "Available SBC": "Available SBC",
    "Available User Seats": "Available User Seats",
    "Available users": "Available users",
    "avatar": "avatar",
    "Average": "Average",
    "Average Call Duration": "Average Call Duration",
    "Average call length": "Average call length",
    "Average caller wait time": "Average caller wait time",
    "Average Calls Duration": "Average Calls Duration",
    "Average time per call": "Average time per call",
    "Average Wait Time": "Average Wait Time",
    "Average: {value}": "Average: {value}",
    "avg call duration": "avg. call duration",
    "Avg call duration": "Avg. call duration",
    "avg call duration tooltip kpi": "The Average duration of calls for the selected period and type.",
    "Avg Hold": "Avg. Hold",
    "Avg Talk": "Avg. Talk",
    "avg talk time": "avg. talk time",
    "Avg talk time": "Avg. talk time",
    "avg talk time tooltip kpi": "The average duration of calls handled by agents. This metric can help evaluate the efficiency and effectiveness of call handling.",
    "Avg Wait": "Avg. Wait",
    "avg wait time": "avg. wait time",
    "Avg wait time": "Avg. wait time",
    "avg wait time tooltip kpi": "The average duration that callers waited before being answered. Lower values indicate shorter wait times and quicker response from agents.",
    "AWS": "AWS",
    "B3": "B3",
    "Back": "Back",
    "Back to chat": "Back to chat",
    "Back To Dashboard": "Back To Dashboard",
    "Back to login": "Back to login",
    "Back to mapping": "Back to mapping",
    "Background": "Background",
    "Balance": "Balance",
    "Balance / Credit Limit": "Balance / Credit Limit",
    "Balance Below Threshold": "Balance Below Threshold",
    "Balance is too low": "Balance is too low",
    "Bar chart": "Bar chart",
    "Barged in": "Barged in",
    "Barged In": "Barged In",
    "Base Role": "Base Role",
    "Basic Info": "Basic Info",
    "Basic phone features": "Basic phone features",
    "Basic Phone Features": "Basic Phone Features",
    "Before connecting, make sure you have:": "Before connecting, make sure you have:",
    "Before Media": "Before Media",
    "Begins with": "Begins with",
    "Best viewed on desktop screens": "Best viewed on desktop screens",
    "Billable": "Billable",
    "billing": "billing",
    "Billing": "Billing",
    "Billing address": "Billing address",
    "Billing Address": "Billing Address",
    "Billing city name": "Billing city name",
    "Billing country name": "Billing country name",
    "billing email": "billing email",
    "Billing Email": "Billing Email",
    "Billing email updated successfully": "Billing email updated successfully!",
    "Billing Incr": "Billing Incr",
    "Billing Increments": "Billing Increments",
    "Billing info": "Billing info",
    "Billing Info": "Billing Info",
    "Billing Information": "Billing Information",
    "Billing is based on usage": "Billing is based on usage",
    "Billing Notification": "Billing Notification",
    "Billing period": "Billing period:",
    "Billing Period": "Billing Period",
    "Billing state name": "Billing state name",
    "BLF Extension": "BLF Extension",
    "Block Calls To Countries": "Block Calls To Countries",
    "Blocked": "Blocked",
    "Blocked countries": "Blocked countries",
    "BME": "BME",
    "bottom background": "bottom background",
    "Bottom Left": "Bottom Left",
    "Bottom Right": "Bottom Right",
    "Brand": "Brand",
    "Brand name": "Brand name",
    "Branding": "Branding",
    "Break": "Break",
    "Break Allocation": "Break Allocation",
    "Breaks": "Breaks",
    "Browse": "Browse",
    "Browse Call Rates": "Browse Call Rates",
    "Browse file": "Browse file",
    "Browser Check-in": "Browser Check-in",
    "Browser Extension": "Browser Extension",
    "Browser Notifications": "Browser Notifications",
    "Browser session": "Browser session",
    "Browser session disabled": "Browser session disabled",
    "Browser session enabled": "Browser session enabled",
    "BSE": "BSE",
    "Build the voice routing policy": "Build the voice routing policy",
    "business": "business",
    "Business": "Business",
    "business address": "business address",
    "Business contact email": "Business contact email",
    "Business details": "Business details",
    "Business Details": "Business Details",
    "Business Hours": "Business Hours",
    "Business Name": "Business Name",
    "Business Name *": "Business Name *",
    "Business Phone": "Business Phone",
    "Business Phone *": "Business Phone *",
    "Business Registration No": "Business Registration No.",
    "Business Size": "Business Size",
    "Business URL": "Business URL",
    "Businesses that trust PBX": "Businesses that trust PBX.IM",
    "busy": "Busy",
    "Busy": "Busy",
    "Busy delay": "Busy delay",
    "Busy Delay": "Busy Delay",
    "button at the bottom": "button at the bottom",
    "button at the top of the table": "button at the top of the table",
    "Buy Now": "Buy Now",
    "By canceling you will lose access to the advanced features": "By canceling you will lose access to the advanced features",
    "By canceling your plan you will lose access to these features:": "By canceling your plan you will lose access to these features:",
    "By downgrading you plan you will lose access to these features": "By downgrading you plan you will lose access to these features:",
    "by paying yearly": "by paying yearly.",
    "By proceeding, you consent to receive verification and service messages from PBX.IM. Standard rates may apply. Reply STOP to unsubscribe.": "By proceeding, you consent to receive verification and service messages from PBX.IM. Standard rates may apply. Reply STOP to unsubscribe.",
    "C2C through the browser is disabled": "C2C through the browser is disabled.",
    "c2c_card_description": "Turn phone numbers in your CRM and web applications into clickable links, eliminating the need for manual dialing. Once clicked, PBX will seamlessly connect the call.",
    "Calculating recipients…": "Calculating recipients…",
    "Call": "Call",
    "Call {Company Name}": "Call {Company Name}",
    "Call {name}": "Call {name}",
    "Call & Chat": "Call & Chat",
    "Call & Chat — coming soon": "Call & Chat — coming soon",
    "Call Capacity": "Call Capacity",
    "Call center": "Call center",
    "Call Center": "Call Center",
    "Call Center Agent": "Call Center Agent",
    "Call center API": "Call center API",
    "Call Center Manager": "Call Center Manager",
    "Call distribution": "Call distribution",
    "Call ended...": "Call ended...",
    "Call failed": "Call failed",
    "Call Failed": "Call Failed",
    "Call Flow": "Call Flow",
    "Call Flow Name": "Call Flow Name",
    "Call for as low as": "Call for as low as",
    "Call forwarding": "Call forwarding",
    "Call forwarding created": "Call forwarding created",
    "Call forwarding updated": "Call forwarding updated",
    "Call Forwarding": "Call Forwarding",
    "Call forwarding description": "Redirect calls to another number or service.",
    "Call from any browser tab.": "Call from any browser tab.",
    "Call handling": "Call handling",
    "Call Handling": "Call Handling",
    "Call History": "Call History",
    "Call limit": "Call limit",
    "Call limits": "Call limits",
    "Call list": "Call list",
    "Call List": "Call List",
    "Call List Field": "Call List Field",
    "Call logs": "Call logs",
    "Call Logs": "Call Logs",
    "Call Me Widget": "Call Me Widget",
    "Call Now": "Call Now",
    "Call number or contact": "Call Number or Contact",
    "Call Panel": "Call Panel",
    "Call queue": "Call queue",
    "call queues": "call queues",
    "Call queues": "Call queues",
    "Call Queues": "Call Queues",
    "Call rates": "Call rates",
    "call recording": "call recording",
    "Call recording": "Call recording",
    "Call Recording": "Call Recording",
    "Call recordings are stored by default for the amount of time corresponding to a plan": "Call recordings are stored by default for the amount of time corresponding to a plan.",
    "Call recordings storage": "Call recordings storage",
    "Call routing": "Call routing",
    "Call Routing": "Call Routing",
    "Call Screen": "Call Screen",
    "Call Stats": "Call Stats",
    "call talk time": "call talk time",
    "Call timeout": "Call timeout",
    "Call Timeout": "Call Timeout",
    "call transcription": "call transcription",
    "Call Transcription": "Call Transcription",
    "Call type": "Call type",
    "Call types": "Call types",
    "Call Types": "Call Types",
    "call volume": "call volume",
    "Call Volume": "Call Volume",
    "call volume tooltip kpi": "The total number of calls received during the selected period. This metric helps gauge the overall workload and call traffic volume.",
    "Call waiting": "Call waiting",
    "Call waiting in queue": "Call waiting in queue",
    "Call waiting settings": "Call waiting settings",
    "Call Waiting Tone": "Call Waiting Tone",
    "Caller": "Caller",
    "Caller ID": "Caller ID",
    "Caller ID (ANI)": "Caller ID (ANI)",
    "Caller ID by country": "Caller ID by country",
    "Caller ID by Destination Country": "Caller ID by Destination Country",
    "Caller ID Configuration": "Caller ID Configuration",
    "Caller ID is required": "Caller ID is required",
    "Caller ID Name": "Caller ID Name",
    "Caller ID Number": "Caller ID Number",
    "Caller IDs": "Caller IDs",
    "Caller IDs set by country take priority over the default caller ID listed above": "Caller IDs set by country take priority over the default caller ID listed above.",
    "Caller Information": "Caller Information",
    "Caller Pre-Join": "Caller Pre-Join",
    "CallerID Num": "CallerID Num",
    "Calling From": "Calling From",
    "callRateMinTooltip": "<b>Min Duration</b>: Minimum duration for the charge being applied<br />Even if your call is shorter than this, you will be charged for the whole duration<br /><br /><b>Increment</b>: After the Min Duration the charge will increase in chunks equal to this duration, <br />even if it’s been partially used<br /><br />Example:<br />Min Duration: 45s (0.75 mins)<br />Increment: 30s (0.5 mins)<br />Rate: $0.25/min<br />For a call duration of 20s you will still be charged the Min Duration cost.<br />That is $0.25 * 0.75 mins = $0.1875<br />For a call duration of 60s you will be charged the Min Duration cost, plus the Increments used.<br />That is $0.1875 + $0.25 * 0.5 mins = $0.3125<br />",
    "calls": "calls",
    "Calls": "Calls",
    "Calls Caller ID": "Calls Caller ID",
    "Calls Duration": "Calls Duration",
    "Calls in Queues": "Calls in Queues",
    "Calls made using premium rate sheets have superior call quality.": "Calls made using premium rate sheets have superior call quality.",
    "Calls Recordings Access Restriction by Countries and/or IP Ranges": "Calls Recordings Access Restriction by Countries and/or IP Ranges",
    "Calls Report": "Calls Report",
    "calls stats": "calls stats",
    "calls tooltip kpi": "The total number of calls made during the selected period and type.",
    "calls within sla": "calls within SLA",
    "calls within sla tooltip kpi": "The percentage of calls that were answered within the predefined Service Level Agreement (SLA) time. It reflects the efficiency of response times.",
    "Campaign": "Campaign",
    "Campaign attributes": "Campaign attributes",
    "Campaign Caller ID": "Campaign Caller ID",
    "Campaign created successfully": "Campaign created successfully",
    "Campaign deleted successfully": "Campaign deleted successfully",
    "Campaign Description": "Campaign Description",
    "Campaign ID": "Campaign ID",
    "Campaign ID: {id}, use case: {message}": "Campaign ID: {id}, use case: {message}",
    "Campaign Name": "Campaign Name",
    "Campaign saved as draft": "Campaign saved as draft",
    "Campaign stats": "Campaign stats",
    "Campaign submitted successfully": "Campaign submitted successfully",
    "Campaign updated successfully": "Campaign updated successfully",
    "Campaign will be sent to <b>{n} Contacts</b>.": "Campaign will be sent to <b>{n} Contacts</b>.",
    "Campaigns": "Campaigns",
    "Can a deactivated user be reactivated?": "Can a deactivated user be reactivated?",
    "Can agents set up their own status?": "Can agents set up their own status?",
    "Can announcements help reduce the wait time?": "Can announcements help reduce the wait time?",
    "Can I apply dial rules only to certain users or groups, instead of everyone?": "Can I apply dial rules only to certain users or groups, instead of everyone?",
    "Can I automatically record my conference calls?": "Can I automatically record my conference calls?",
    "Can I create dial rules specific to different countries or regions?": "Can I create dial rules specific to different countries or regions?",
    "Can I customize how my caller ID shows up when forwarding calls?": "Can I customize how my caller ID shows up when forwarding calls?",
    "Can I export the list of endpoints? What formats are available?": "Can I export the list of endpoints? What formats are available?",
    "Can I limit the number of simultaneous calls for my team?": "Can I limit the number of simultaneous calls for my team?",
    "Can I set a time limit for how long the phone rings before going to voicemail?": "Can I set a time limit for how long the phone rings before going to voicemail?",
    "Can I turn an extension on or off?  What does that mean?": "Can I turn an extension on or off?  What does that mean?",
    "Can I use extensions to set up separate phone lines for different departments?": "Can I use extensions to set up separate phone lines for different departments?",
    "Can one person be part of multiple teams?": "Can one person be part of multiple teams?",
    "Can only be removed by a manager": "Can only be removed by a manager",
    "Cancel": "Cancel",
    "Cancel Import": "Cancel Import",
    "cancel import confirmation": "Cancelling will remove all added numbers. Are you sure you want to proceed?",
    "Cancel Number": "Cancel Number",
    "Cancel Phone Number": "Cancel Phone Number",
    "cancel plan": "cancel plan",
    "Cancel Plan": "Cancel Plan",
    "Cancel SMS Campaign": "Cancel SMS Campaign",
    "Cancel the test call.": "Cancel the test call.",
    "Cancellation Pending": "Cancellation Pending",
    "Cannot exceed Messages Per Day": "Cannot exceed Messages Per Day",
    "Cannot log out during user creation": "Cannot log out during user creation",
    "Card": "Card",
    "Card added successfully": "Card added successfully",
    "Card deleted successfully": "Card deleted successfully",
    "Card name": "Card name",
    "Card number": "Card number",
    "Cart": "Cart",
    "Categories": "Categories",
    "Categories — coming soon": "Categories — coming soon",
    "Route name": "Route name",
    "CDR": "CDR",
    "Change 2FA": "Change 2FA",
    "Change Own Password": "Change Own Password",
    "Change password": "Change password",
    "Change Password": "Change Password",
    "Change phone": "Change phone",
    "Change plan": "Change plan",
    "Change your password": "Change your password",
    "Changes have been saved": "Changes have been saved",
    "Channel limits": "Channel limits",
    "Channels": "Channels",
    "Chat": "Chat",
    "Chat Destination": "Chat Destination",
    "Chat ended by": "Chat ended by",
    "chat form": "chat form",
    "Chat history": "Chat history",
    "chat menu": "chat menu",
    "chat menu {name}": "chat menu {name}",
    "Chat Never Expires": "Chat Never Expires",
    "Chat returned to queue (Agent offline)": "Chat returned to queue (Agent offline)",
    "Chat returned to queue by": "Chat returned to queue by",
    "Chat returned to queue by \"{by}\"": "Chat returned to queue by \"{by}\"",
    "Chat room name": "Chat room name",
    "Chat routed by": "Chat routed by",
    "Chat routed by \"{by}\"": "Chat routed by \"{by}\"",
    "Chat Screen": "Chat Screen",
    "Chat Script": "Chat Script",
    "Chat with SIP IO Support": "Chat with SIP.IO Support",
    "Chats": "Chats",
    "Check DNS": "Check DNS",
    "Check In": "Check In",
    "Check Out": "Check Out",
    "Check-in with Browser": "Check-in with Browser",
    "Check-in with Phone": "Check-in with Phone",
    "Check-out": "Check-out",
    "Checking…": "Checking…",
    "Checkout": "Checkout",
    "CheckOut": "CheckOut",
    "Chief Customer Officer": "Chief Customer Officer",
    "Customer waiting duration": "Customer waiting duration",
    "Customer talking duration": "Customer talking duration",
    "Choose A2P Campaign": "Choose A2P Campaign",
    "Choose Call List": "Choose Call List",
    "Choose Call Script": "Choose Call Script",
    "Choose Country": "Choose Country",
    "Choose Date Format": "Choose Date Format",
    "Choose Destination": "Choose Destination",
    "Choose Existing Announcement": "Choose Existing Announcement",
    "Choose Existing Auto Attendant": "Choose Existing Auto Attendant",
    "Choose Existing Business Hours": "Choose Existing Business Hours",
    "Choose Existing Call Forwarding": "Choose Existing Call Forwarding",
    "Choose Existing Ring Group": "Choose Existing Ring Group",
    "Choose Existing Voicemail": "Choose Existing Voicemail",
    "Choose Greeting": "Choose Greeting",
    "Choose Integration Type": "Choose Integration Type",
    "Choose Label": "Choose Label",
    "Choose Pre-bridge announcement": "Choose Pre-bridge announcement",
    "Choose Replacement": "Choose Replacement",
    "Choose SLA Strategy": "Choose SLA Strategy",
    "Choose Script": "Choose Script",
    "Choose Sender ID": "Choose Sender ID",
    "Choose Time Format": "Choose Time Format",
    "Choose Time Group": "Choose Time Group",
    "Choose Type": "Choose Type",
    "Choose Waiting Music": "Choose Waiting Music",
    "Choose a category to get started.": "Choose a category to get started.",
    "Choose a dial rule": "Choose a dial rule",
    "Choose a plan that's right for you": "Choose a plan that's right for you",
    "Choose a prefix": "Choose a prefix",
    "Choose a script to view here": "Choose a script to view here",
    "Choose a user": "Choose a user",
    "Choose a value": "Choose a value",
    "Choose an audio playback": "Choose an audio playback",
    "Choose announcement": "Choose announcement",
    "Choose another method": "Choose another method",
    "Choose approved campaign": "Choose approved campaign",
    "Choose at least one message type": "Choose at least one message type",
    "Choose at least one phone number": "Choose at least one phone number",
    "Choose audio": "Choose audio",
    "Choose call timeout": "Choose call timeout",
    "Choose campaign": "Choose campaign",
    "Choose country preset": "Choose country preset",
    "Choose destination": "Choose destination",
    "Choose digit": "Choose digit",
    "Choose distribution": "Choose distribution",
    "Choose existing conference": "Choose existing conference",
    "Choose existing endpoint": "Choose existing endpoint",
    "Choose existing extension": "Choose existing extension",
    "Choose existing user": "Choose existing user",
    "Choose exit audio": "Choose exit audio",
    "Choose invalid audio": "Choose invalid audio",
    "Choose labels": "Choose labels",
    "Choose main audio": "Choose main audio",
    "Choose media file": "Choose media file",
    "Choose method": "Choose method",
    "Choose music": "Choose music",
    "Choose name": "Choose name",
    "Choose node": "Choose node",
    "Choose number": "Choose number",
    "Choose one extension that you want to monitor from the dropdown menu": "Choose one extension that you want to monitor from the dropdown menu.",
    "Choose or Create Labels": "Choose or Create Labels",
    "Choose outcome": "Choose outcome",
    "Choose payment method": "Choose payment method",
    "Choose placeholder": "Choose {what}",
    "Choose queues": "Choose queues",
    "Choose replay audio": "Choose replay audio",
    "Choose role": "Choose role",
    "Choose site": "Choose site",
    "Choose strategy": "Choose strategy",
    "Choose teams": "Choose teams",
    "Choose time zone": "Choose time zone",
    "Choose tone": "Choose tone",
    "Choose type": "Choose type",
    "Choose user": "Choose user",
    "Choose value": "Choose value",
    "Choose voice": "Choose voice",
    "Choose what": "Choose {what}",
    "Chrome/edge extension": "Chrome/edge extension",
    "Chrome/Edge Extension": "Chrome/Edge Extension",
    "CIDR": "CIDR",
    "city": "city",
    "City": "City",
    "City *": "City *",
    "Clear All": "Clear All",
    "Clear filters": "Clear filters",
    "Clear Filters": "Clear Filters",
    "Clear Search": "Clear Search",
    "Clearly explain all opt-in methods (e.g., keyword, webform, verbal) and include supporting material or a link": "Clearly explain all opt-in methods (e.g., keyword, webform, verbal) and include supporting material or a link",
    "Click": "Click",
    "Click 2 Call": "Click 2 Call",
    "Click 2 Call Integration": "Click 2 Call Integration",
    "Click Add Extension to start assigning": "Click Add Extension to start assigning",
    "Click Add Queue to start assigning": "Click Add Queue to start assigning",
    "Click Add User to start assigning": "Click Add User to start assigning",
    "Click Submit to continue": "Click <bold>Submit</bold> to continue.",
    "Client Context": "Client Context",
    "Close": "Close",
    "Close conversation": "Close conversation",
    "Close Preview": "Close Preview",
    "Closed": "Closed",
    "Closed Conversations": "Closed Conversations",
    "Closed Hours": "Closed Hours",
    "Closed Hours Message": "Closed Hours Message",
    "Cloud Phone System": "Cloud Phone System",
    "CNAME for {host} is not yet pointing to {target}": "CNAME for {host} is not yet pointing to {target}",
    "Code": "Code",
    "Collapse sidebar": "Collapse sidebar",
    "Color": "Color",
    "Comfort noise": "Comfort noise",
    "Coming soon": "Coming soon...",
    "Command sent successfully": "Command sent successfully",
    "Commerce": "Commerce",
    "Communication": "Communication",
    "Communication and Mass Media": "Communication and Mass Media",
    "company": "company",
    "Company": "Company",
    "company address": "company address",
    "Company address": "Company address",
    "Company details": "Company details",
    "Company Details": "Company Details",
    "Company details description": "Relevant information regarding your company.",
    "Company details have been updated succesfully": "Company details have been updated succesfully!",
    "Company details updated": "Company details updated",
    "Company Logo": "Company Logo",
    "company name": "company name",
    "Company name": "Company name",
    "Company Name": "Company Name",
    "Company name *": "Company name *",
    "Company Name *": "Company Name *",
    "Company Phone": "Company Phone",
    "Company Phone *": "Company Phone *",
    "Company registration No": "Company registration No.",
    "Company registration No *": "Company registration No. *",
    "Company role": "Company role",
    "Company Role": "Company Role",
    "Company Role *": "Company Role *",
    "Company size": "Company size",
    "Company type": "Company type",
    "Company URL": "Company URL",
    "Complete": "Complete",
    "Completed": "Completed",
    "Compliance": "Compliance",
    "Concurrent Calls": "Concurrent Calls",
    "Condition": "Condition",
    "Conditional Actions": "Conditional Actions",
    "Conditions": "Conditions",
    "Conference": "Conference",
    "Conference created": "Conference created",
    "Voicemail created": "Voicemail created",
    "Voicemail updated": "Voicemail updated",
    "Remove access code": "Remove access code",
    "Conference Room": "Conference Room",
    "Conference rooms": "Conference rooms",
    "Conference Rooms": "Conference Rooms",
    "Conference rooms description": "Manage all your conference rooms.",
    "Conference updated": "Conference updated",
    "Configuration": "Configuration",
    "Configure business hours and peak times for call routing": "Configure business hours and peak times for call routing.",
    "Configure call menus": "Configure call menus.",
    "Configure wallboards": "Configure wallboards",
    "Configuring the 2FA for your account is required": "Configuring the 2FA for your account is required",
    "Confirm": "Confirm",
    "Confirm code": "Confirm code",
    "Confirm new password": "Confirm new password",
    "Confirm password": "Confirm password",
    "Confirm Purchase": "Confirm Purchase",
    "Confirm Seats": "Confirm Seats",
    "Confirm top-up": "Confirm top-up",
    "Congestion": "Congestion",
    "Connect": "Connect",
    "Connect the webphone to make a test call.": "Connect the webphone to make a test call.",
    "Connect To WhatsApp Business": "Connect To WhatsApp Business",
    "Connect WhatsApp Business": "Connect WhatsApp Business",
    "Connect your WhatsApp Business account and handle conversations directly from your Inbox": "Connect your WhatsApp Business account and handle conversations directly from your Inbox",
    "Connect your WhatsApp business number": "Connect your WhatsApp business number",
    "Connected": "Connected",
    "Connected Phone Numbers": "Connected Phone Numbers",
    "Connected To:": "Connected To:",
    "Connected WhatsApp Business Accounts": "Connected WhatsApp Business Accounts",
    "Connecting": "Connecting",
    "Connecting WhatsApp Business": "Connecting WhatsApp Business",
    "Connection timed out. Please try again.": "Connection timed out. Please try again.",
    "Consider Local Time": "Consider Local Time",
    "Consider Recipient Local Time": "Consider Recipient Local Time",
    "Construction": "Construction",
    "Construction and Materials": "Construction and Materials",
    "Contact": "Contact",
    "Contact Created": "Contact Created",
    "Contact Details": "Contact Details",
    "Contact History": "Contact History",
    "Contact Info": "Contact Info",
    "Contact Person": "Contact Person",
    "Contact Updated": "Contact Updated",
    "Contact Us Web Widget": "Contact Us Web Widget",
    "Contact us web widget created successfully": "Contact us web widget created successfully",
    "Contact us web widget updated successfully": "Contact us web widget updated successfully",
    "contacts": "contacts",
    "Contacts": "Contacts",
    "contacts found in this list.": "contacts found in this list.",
    "Contains": "Contains",
    "Content": "Content",
    "Converting audio...": "Converting audio...",
    "Content Text": "Content Text",
    "Continue": "Continue",
    "Continue with Google": "Continue with Google",
    "Continue with Microsoft": "Continue with Microsoft",
    "This organization requires single sign-on.": "This organization requires single sign-on.",
    "Login is temporarily unavailable. Please try again in a few minutes.": "Login is temporarily unavailable. Please try again in a few minutes.",
    "This account signs in with an email and password. Please use those instead.": "This account signs in with an email and password. Please use those instead.",
    "Single sign-on is not available for this organization.": "Single sign-on is not available for this organization.",
    "Sign-in was cancelled. Please try again.": "Sign-in was cancelled. Please try again.",
    "This account belongs to a different organization.": "This account belongs to a different organization.",
    "This account is disabled. Please contact your administrator.": "This account is disabled. Please contact your administrator.",
    "Your account does not have access. Please contact your administrator.": "Your account does not have access. Please contact your administrator.",
    "Your account is not set up for single sign-on. Please contact your administrator.": "Your account is not set up for single sign-on. Please contact your administrator.",
    "Your organization has no seats available. Please contact your administrator.": "Your organization has no seats available. Please contact your administrator.",
    "We couldn't find an account for that email. Please check which account you used.": "We couldn't find an account for that email. Please check which account you used.",
    "Your organization isn't set up for sign-in yet. Please contact your administrator.": "Your organization isn't set up for sign-in yet. Please contact your administrator.",
    "We couldn't sign you in. Please try again.": "We couldn't sign you in. Please try again.",
    "Continue.": "Continue.",
    "Contrast too low.": "Contrast too low.",
    "Copied": "Copied",
    "Copied to clipboard": "Copied to clipboard",
    "copied_to_clipboard": "Copied to clipboard.",
    "Copy": "Copy",
    "Copy domain": "Copy domain",
    "Copy Link": "Copy Link",
    "Copy Name": "Copy Name",
    "Copy password": "Copy password",
    "Couldn't remove the picture": "Couldn't remove the picture",
    "Copy script": "Copy script",
    "Copy the": "Copy the",
    "Copy Value": "Copy Value",
    "copy_failed": "Copy failed.",
    "core": "core",
    "Core": "Core",
    "Cost": "Cost",
    "Cost Estimation": "Cost Estimation",
    "Could not create account": "Could not create account",
    "Cannot delete row in use": "Cannot be deleted: it is still used by {what}. Remove it there first.",
    "Cannot delete row in use generic": "Cannot be deleted: it is still in use.",
    "Could not delete the table row": "Could not delete the table row",
    "Could not invite user ": "Could not invite user ",
    "Could not load script": "Could not load script",
    "Could not resend invitation": "Could not resend invitation",
    "Could not save company details": "Could not save company details",
    "Could not set up billing information": "Could not set up billing information",
    "Could not setup 2FA": "Could not setup 2FA",
    "Could not start ID verification": "Could not start ID verification",
    "Could not update billing email": "Could not update billing email.",
    "Could not update dial rule settings": "Could not update dial rule settings",
    "Could not update general settings": "Could not update general settings",
    "Could not update media settings": "Could not update media settings.",
    "Could not update number format": "Could not update number format",
    "Could not update the company details": "Could not update the company details",
    "Could not update the default call rate": "Could not update the default call rate.",
    "Could not update the profile": "Could not update the profile",
    "Could not upload list": "Could not upload list",
    "Could not validate the invitation": "Could not validate the invitation",
    "Could not verify the user": "Could not verify the user",
    "Couldn't load setup info — refresh and try again": "Couldn't load setup info — refresh and try again",
    "counter of": "{start} of {end}",
    "Countries": "Countries",
    "Countries are required": "Countries are required",
    "country": "country",
    "Country": "Country",
    "Country *": "Country *",
    "Country preset": "Country preset",
    "Create": "Create",
    "Create a PSTN usage record + voice route": "Create a PSTN usage record + voice route",
    "Create and manage all your media files": "Create and manage all your media files.",
    "Create Label": "Create Label",
    "Create New Field": "Create New Field",
    "Create password": "Create password",
    "Create password *": "Create password *",
    "Create Report": "Create Report",
    "Create ticket": "Create ticket",
    "Create transcription": "Create transcription",
    "Create your account": "Create your account",
    "Creating integration": "Creating integration",
    "Creating Transcription": "Creating Transcription",
    "credit": "credit",
    "Credit card": "Credit card",
    "CRM integration": "CRM integration",
    "CRM Integration": "CRM Integration",
    "CRM integrations": "CRM integrations",
    "CSV Field": "CSV Field",
    "current balance": "current balance",
    "Current Balance": "Current balance:",
    "Current password": "Current password",
    "current plan": "current plan",
    "Current Seats": "Current Seats",
    "Current Status": "Current Status",
    "Current Users": "Current Users",
    "Custom": "Custom",
    "Custom Amount": "Custom Amount",
    "Custom Announcement": "Custom Announcement",
    "Custom Auto Attendant": "Custom Auto Attendant",
    "Custom Business Hours": "Custom Business Hours",
    "Custom Call Forwarding": "Custom Call Forwarding",
    "Custom Conference": "Custom Conference",
    "Custom domain": "Custom domain",
    "Custom Endpoint": "Custom Endpoint",
    "Custom Extension": "Custom Extension",
    "Custom Queue": "Custom Queue",
    "Custom Rate": "Custom Rate",
    "Custom Ring Group": "Custom Ring Group",
    "Custom User": "Custom User",
    "Custom Voicemail": "Custom Voicemail",
    "customer": "Customer",
    "Customer Care": "Customer Care",
    "Customer Domain (SIP URI)": "Customer Domain (SIP URI)",
    "Customer Number": "Customer Number",
    "Customer Service Manager": "Customer Service Manager",
    "Customize": "Customize",
    "Dark": "Dark",
    "Dashboard": "Dashboard",
    "Dashboard description": "Dashboard coming soon...",
    "Dashboard title": "Welcome {name}!",
    "Date": "Date",
    "Date / Time": "Date / Time",
    "Date Format": "Date Format",
    "Date from": "Date from",
    "Date issued": "Date issued",
    "Date to": "Date to",
    "days": "{value} Days",
    "Days": "Days",
    "Days of the week": "Days of the week",
    "Deactivated": "Deactivated",
    "debit": "debit",
    "Decimal Number": "Decimal Number",
    "Decimals not allowed": "Decimals not allowed",
    "Dedicated Account Manager / Email / Chat / Phone": "Dedicated Account Manager / Email / Chat / Phone",
    "default": "default",
    "Default": "Default",
    "Default (Disabled)": "Default (Disabled)",
    "Default account dial rule": "Default account dial rule",
    "Default call rate updated successfully": "Default call rate updated successfully.",
    "A rate plan change is still being applied. Try again in a few minutes.": "A rate plan change is still being applied. Try again in a few minutes.",
    "This rate plan cannot be applied to this account. Contact support.": "This rate plan cannot be applied to this account. Contact support.",
    "Currency": "Currency",
    "Call rates are not available right now.": "Call rates are not available right now.",
    "Connection fee": "Connection fee",
    "This account has custom pricing. Contact support to change it.": "This account has custom pricing. Contact support to change it.",
    "Default Call Rates": "Default Call Rates",
    "Default Call Routing Destination": "Default Call Routing Destination",
    "Default caller IDs": "Default caller IDs",
    "Default CallerID": "Default CallerID",
    "default card": "default card",
    "DEFAULT CARD": "DEFAULT CARD",
    "Default color: White": "Default color: White",
    "Default Country Code": "Default Country Code",
    "Default destination": "Default destination",
    "Default destination type": "Default destination type",
    "Default exit destination": "Default exit destination",
    "Default music": "Default music",
    "Default Routing Destination": "Default Routing Destination",
    "Defaults": "Defaults",
    "Define how outbound calls are processed and formatted": "Define how outbound calls are processed and formatted.",
    "Degraded": "Degraded",
    "Delay": "Delay",
    "Delay before ringing this user": "Delay before ringing this user",
    "Delay time added after the caller inputs their selection": "Delay time added after the caller inputs their selection.",
    "Delete": "Delete",
    "Delete account": "Delete account",
    "Delete Agent Status": "Delete Agent Status",
    "Delete automatic top-up": "Delete automatic top-up",
    "Delete call queue": "Delete call queue",
    "Delete Campaign": "Delete Campaign",
    "Delete card": "Delete card",
    "Delete Route": "Delete Route",
    "Delete contact": "Delete contact",
    "Delete Custom Plan": "Delete Custom Plan",
    "Delete dial rule": "Delete dial rule",
    "Delete inbox": "Delete inbox",
    "Delete integration": "Delete integration",
    "Delete Invitation": "Delete Invitation",
    "Delete media": "Delete Media",
    "Delete Plan": "Delete Plan",
    "Delete row description": "Are you sure you want to delete this row? This action is irreversible.",
    "Delete SIP trunk": "Delete SIP trunk",
    "Delete User": "Delete User",
    "Deleted message": "Deleted message",
    "Delivered": "Delivered",
    "Delivery log": "Delivery log",
    "Delivery Notification": "Delivery Notification",
    "Deny": "Deny",
    "Descending": "Descending",
    "description": "description",
    "Description": "Description",
    "Description is required": "Description is required",
    "Destination": "Destination",
    "Destination - condition Matched": "Destination - condition Matched",
    "Destination - condition NOT Matched": "Destination - condition NOT Matched",
    "Destination Countries": "Destination Countries",
    "Destination Country": "Destination Country",
    "Destination Host": "Destination Host",
    "Destination Host / URL": "Destination Host / URL",
    "Destination name": "Destination name",
    "Destination Name": "Destination Name",
    "Destination type": "Destination type",
    "Destinations": "Destinations",
    "Details": "Details",
    "Detect Timeout": "Detect Timeout",
    "Detected DNS Provider": "Detected DNS Provider",
    "Dial Ahead Factor": "Dial Ahead Factor",
    "Dial rule": "Dial rule",
    "Dial Rule": "Dial Rule",
    "A dial rule with this name already exists": "A dial rule with this name already exists",
    "Dial rule created": "Dial rule created",
    "Dial rule updated": "Dial rule updated",
    "Dial rules": "Dial rules",
    "DID": "DID",
    "Dial Rules": "Dial Rules",
    "Dial rules (override)": "Dial rules (override)",
    "Dial Status": "Dial Status",
    "dial time": "dial time",
    "dial_ahead_tooltip": "Specify how many calls the dialer can make and queue for the agents before the agents are fully available. This helps balance speed with call handling capacity.",
    "Dialed (DNID)": "Dialed (DNID)",
    "Dialer": "Dialer",
    "Dialpad": "Dialpad",
    "Did you scan the QR code?": "Did you scan the QR code?",
    "digit": "digit",
    "Digit": "Digit",
    "Digit length": "Digit length",
    "Digits": "Digits",
    "Direct extensions": "Direct extensions",
    "Direct Extensions": "Direct Extensions",
    "Direct Fax": "Direct Fax",
    "Direct incoming calls to multiple phone numbers or extensions simultaneous or in sequence": "Direct incoming calls to multiple phone numbers or extensions simultaneous or in sequence.",
    "Direct Inward dialing Channels": "Direct Inward dialing Channels",
    "Direction": "Direction",
    "Disable 2FA": "Disable 2FA",
    "Disable Mute": "Disable Mute",
    "Disable Mute Button in WD": "Disable Mute Button in WD",
    "Disabled": "Disabled",
    "Disabled for all users": "Disabled for all users",
    "Disabled two-factor authentication (2FA)": "Disabled two-factor authentication (2FA).",
    "Disallow changing Pause": "Disallow changing Pause",
    "Discard": "Discard",
    "Discard Invalid Numbers": "Discard Invalid Numbers",
    "discard invalid numbers confirmation": "If you proceed, <bold>{callListCount} invalid number from the Call List</bold> and <bold>{doNotCallCount} invalid numbers from the Do Not Call List</bold> will be discarded. <br></br> Are you sure you want to proceed?",
    "discard invalid numbers confirmation single": "If you proceed <bold>{count} invalid numbers from the {listName}</bold> will be discarded. <br></br> Are you sure you want to proceed?",
    "Discard unsaved changes?": "Discard unsaved changes?",
    "Disconnect": "Disconnect",
    "Disconnect WhatsApp Business": "Disconnect WhatsApp Business",
    "Disconnected": "Disconnected",
    "Disconnected nodes": "Disconnected nodes",
    "Dismiss": "Dismiss",
    "Display Name": "Display Name",
    "Display Type": "Display Type",
    "DND": "DND",
    "DNS configured": "DNS configured",
    "DNS not verified": "DNS not verified",
    "DNS Record": "DNS Record",
    "DNS Record verified": "DNS Record verified",
    "DNS records missing": "DNS records missing: {records}",
    "Do Not Call": "Do Not Call",
    "Do Not Call List": "Do Not Call List",
    "Do Not Disturb": "Do Not Disturb",
    "Do you want to add <b>{price}</b> now": "Do you want to add <b>{price}</b> now?",
    "Do you want to close the previous session and continue here": "Do you want to close the previous session and continue here",
    "Do you want to proceed": "Do you want to proceed",
    "Do you want to proceed?": "Do you want to proceed?",
    "Do you want to proceeed?": "Do you want to proceeed?",
    "Do you want to save before leaving?": "Do you want to save before leaving?",
    "Do you want to save this as a draft?": "Do you want to save this as a draft?",
    "Do you want to stay logged in?": "Do you want to stay in?",
    "Do you want to unblock them?": "Do you want to unblock them?",
    "Docs": "Docs",
    "Document": "Document",
    "documentation": "documentation",
    "Documentation": "Documentation",
    "Does not match your password": "Does not match your password.",
    "domain": "domain",
    "Domain": "Domain",
    "Domain already used in another integration": "Domain already used in another integration",
    "Domain description not loaded": "Domain description not loaded",
    "Domain Name": "Domain Name",
    "Domain Suffix": "Domain Suffix",
    "Domain Type": "Domain Type",
    "Don't have access to the web phone": "Don't have access to the web phone",
    "Don't mask": "Don't mask",
    "Don't record": "Don't record",
    "Don't Send To": "Don't Send To",
    "done": "Done",
    "Done": "Done",
    "Down": "Down",
    "Downgrading to {name} on {date}": "Downgrading to {name} on {date}",
    "Download": "Download",
    "Download All Countries' Rates (CSV)": "Download All Countries' Rates (CSV)",
    "Download Call Recording": "Download Call Recording",
    "Download the template": "Download the template",
    "Downloading media...": "Downloading media...",
    "Draft": "Draft",
    "Draft campaign": "Draft campaign",
    "Drag & drop here": "Drag & drop here",
    "Drag & drop here or": "Drag & drop here or",
    "Drop files here": "Drop files here",
    "Dropped before being answered": "Dropped before being answered",
    "Due Later": "Due Later",
    "Due Now": "Due Now",
    "Duplicate": "Duplicate",
    "Duplicate IP address": "Duplicate IP address",
    "Duration": "Duration",
    "During Hours": "During Hours",
    "Dynamic": "Dynamic",
    "Each concurrent call requires one Microsoft Teams channel.": "Each concurrent call requires one Microsoft Teams channel.",
    "Each seat grants access to the PBX system, and any unassigned seats are available for new users": "Each seat grants access to the PBX system, and any unassigned seats are available for new users",
    "Each segment = 1 SMS billed. Messages are split into 150 character segments.": "Each segment = 1 SMS billed. Messages are split into 150 character segments.",
    "Echo Cancelation": "Echo Cancelation",
    "Ecommerce": "Ecommerce",
    "Edit": "Edit",
    "Edit Account": "Edit Account",
    "Edit Agent Status": "Edit Agent Status",
    "Edit announcement": "Edit announcement",
    "Edit Auto Dialer": "Edit Auto Dialer",
    "Edit Auto Dialer Campaign": "Edit Auto Dialer Campaign",
    "Edit Call Queue": "Edit Call Queue",
    "Edit chat": "Edit chat",
    "Edit conference room": "Edit conference room",
    "Edit Contact": "Edit Contact",
    "Edit Contact Us Web Widget": "Edit Contact Us Web Widget",
    "Edit Custom Plan": "Edit Custom Plan",
    "Edit dial rule": "Add dial rule",
    "Edit endpoint": "Edit endpoint",
    "Edit extension": "Edit extension",
    "Edit forward": "Edit forward",
    "Edit inbox": "Edit inbox",
    "Edit Inbox Destination": "Edit Inbox Destination",
    "Edit intercept group": "Edit intercept group",
    "Edit media file": "Edit media file",
    "Edit Microsoft Teams": "Edit Microsoft Teams",
    "Edit Node": "Edit Node",
    "Edit Phone Number": "Edit Phone Number",
    "Edit Plan": "Edit Plan",
    "Edit queue": "Edit queue",
    "Edit ring group": "Edit ring group",
    "Edit Role": "Edit Role",
    "Edit SIP Trunk": "Edit SIP Trunk",
    "Edit SMS Forwarding": "Edit SMS Forwarding",
    "Edit team": "Edit team",
    "Edit time condition": "Edit Business Hours",
    "Edit time group": "Edit time group",
    "Edit User": "Edit User",
    "Edit User Details": "Edit User Details",
    "Edit voicemail": "Edit voicemail",
    "Edit Widget": "Edit Widget",
    "Education": "Education",
    "email": "email",
    "Email": "Email",
    "Email *": "Email *",
    "Email / Chat": "Email / Chat",
    "Email & Chat Support": "Email & Chat Support",
    "Email address": "Email address",
    "Email Address": "Email Address",
    "Email code": "Email code",
    "Email Code": "Email Code",
    "Email Code *": "Email Code *",
    "Email code expired": "Email code expired.",
    "Email enabled": "Email enabled",
    "Email notification": "Email notification",
    "Email Notification": "Email Notification",
    "email or username": "email or username",
    "Email sent successfully": "Email sent successfully",
    "Email Subject": "Email Subject",
    "Email Tfa Item Description": "Get a code by clicking \"Send Code in Email\" during login process.",
    "Email verification Link Sent": "Email verification Link Sent",
    "Emails": "Emails",
    "Embed script": "Embed script",
    "EMEA": "EMEA",
    "Enable": "Enable",
    "Enable 2 Factor Authentication": "Enable 2 Factor Authentication",
    "Enable agent levels": "Enable agent levels",
    "Enable authentication for inbound SIP requests": "Enable authentication for inbound SIP requests",
    "Enable authentication for outbound SIP requests": "Enable authentication for outbound SIP requests",
    "Enable Auto-Top Up to automatically recharge your account balance": "Enable Auto-Top Up to automatically recharge your account balance",
    "Enable by Suspicious Login": "Enable by Suspicious Login",
    "Enable call recording": "Enable call recording",
    "Enable Call Recording": "Enable Call Recording",
    "Enable Caller ID by Destination Country": "Enable Caller ID by Destination Country",
    "Enable Call or Chat for this route": "Enable Call or Chat for this route",
    "Enable Calling": "Enable Calling",
    "Enable Call or Chat on at least one route": "Enable Call or Chat on at least one route",
    "Enable Chat": "Enable Chat",
    "Enable Direct Dial": "Enable Direct Dial",
    "Enable For All Users": "Enable For All Users",
    "Enable Mute": "Enable Mute",
    "Enable Outbound SMS": "Enable Outbound SMS",
    "Enable SMS Routing": "Enable SMS Routing",
    "enable transcriptions": "enable transcriptions",
    "Enable Welcome Message": "Enable Welcome Message",
    "Enabled": "Enabled",
    "enabled count": "Enabled ({count})",
    "Enabled Direct Dial": "Enabled Direct Dial",
    "Enabled for all users": "Enabled for all users",
    "Enabled only on Suspicious Login": "Enabled only on Suspicious Login",
    "Enabled Outside of IP range": "Enabled Outside of IP range",
    "Enabled Outside of IP Range": "Enabled Outside of IP Range",
    "Enabled Outside of Login IP Range": "Enabled Outside of Login IP Range",
    "End call": "End call",
    "End Chat": "End Chat",
    "End Current Call": "End Current Call",
    "End monitoring session?": "End monitoring session?",
    "End on moderator exit": "End on moderator exit",
    "End Test": "End Test",
    "End the test call before saving": "End the test call before saving",
    "End the test call before changing status": "End the test call before changing status",
    "ended the chat": "ended the chat",
    "Endpoint": "Endpoint",
    "Endpoint created": "Endpoint created",
    "Endpoint updated": "Endpoint updated",
    "Endpoint / Flow": "Endpoint / Flow",
    "Endpoint not Available": "Endpoint not Available",
    "Endpoint parameters": "Endpoint parameters",
    "Endpoint Parameters": "Endpoint Parameters",
    "Endpoints": "Endpoints",
    "Ends with": "Ends with",
    "Energy": "Energy",
    "Energy and Utilities": "Energy and Utilities",
    "Enforce 2FA for all users": "Enforce 2FA for all users",
    "English": "English",
    "English (Default)": "English (Default)",
    "Enjoy $5 in free credit to try our service right away": "Enjoy $5 in free credit to try our service right away.",
    "Enter a greeting message for inbound conversations...": "Enter a greeting message for inbound conversations...",
    "Enter a Name": "Enter a Name",
    "Enter a name for the flow before saving": "Enter a name for the flow before saving",
    "Enter a name for this integration. You’ll be able to reuse it across multiple phone numbers.": "Enter a name for this integration. You’ll be able to reuse it across multiple phone numbers.",
    "Enter a PIN": "Enter a PIN",
    "Enter Access Code": "Enter Access Code",
    "Enter Admin Pin": "Enter Admin Pin",
    "Enter an Email Address": "Enter an Email Address",
    "Enter Caller ID Input": "Enter Caller ID Input",
    "Enter comma-separated emails": "Enter comma-separated emails",
    "Enter description": "Enter description",
    "Enter Description": "Enter Description",
    "Enter Dialed Number Input": "Enter Dialed Number Input",
    "Enter email address": "Enter email address",
    "Enter email subject": "Enter email subject",
    "Enter emails separated by comma": "Enter emails separated by comma",
    "Enter extension": "Enter extension",
    "Enter keywords separated by commas": "Enter keywords separated by commas",
    "Enter Label": "Enter Label",
    "Enter Message": "Enter Message",
    "Enter name": "Enter name",
    "Enter Name": "Enter Name",
    "Enter names separated by comma or new line": "Enter names separated by comma or new line",
    "Enter Password": "Enter Password",
    "Enter Pin Retries": "Enter Pin Retries",
    "Enter Sample Message": "Enter Sample Message",
    "Enter SBC domain above": "Enter SBC domain above",
    "Enter target duration in seconds (e.g., 20)": "Enter target duration in seconds (e.g., 20)",
    "Enter target percentage (e.g., 95)": "Enter target percentage (e.g., 95)",
    "Enter the authentication code": "Enter the authentication code",
    "Enter the code that was sent to your new phone number": "Enter the code that was sent to your new phone number.",
    "Enter the six digits displayed in the app": "Enter the six digits displayed in the app",
    "Enter the verification code sent to your email": "Enter the verification code sent to your email",
    "Enter URL": "Enter URL",
    "Enter User Pin": "Enter User Pin",
    "Enter Username": "Enter Username",
    "Enter Value": "Enter Value",
    "Enter your card details and top up your account": "Enter your card details and top up your account.",
    "enterprise": "enterprise",
    "Enterprise": "Enterprise",
    "Entertainment": "Entertainment",
    "Entries": "Entries: ",
    "Error": "Error",
    "Error deleting integration": "Error deleting integration.",
    "Error in reviewing cart, please try again!": "Error in reviewing cart, please try again!",
    "essential": "essential",
    "Essential": "Essential",
    "Estimated": "Estimated",
    "Estimated Transfer Date": "Estimated Transfer Date",
    "Europe": "Europe",
    "Everybody": "Everybody",
    "Everyday": "Everyday",
    "Everything in Advanced, and": "Everything in Advanced, and",
    "Everything in Core, and": "Everything in Core, and",
    "Everything in Essential, and": "Everything in Essential, and",
    "Exact": "Exact",
    "Example": "Example",
    "example mask end": "Example: +44 1234 567 XXX",
    "example mask middle": "Example: +44 1234 XXX 890",
    "Example:": "Example: {example}",
    "Example: [Your Brand]: Contact us for help at [phone number] or [link to help page]. Reply STOP to unsubscribe. Msg & Data rates may apply.": "Example: [Your Brand]: Contact us for help at [phone number] or [link to help page]. Reply STOP to unsubscribe. Msg & Data rates may apply.",
    "Example: [Your Brand]: You have successfully unsubscribed. You will receive no further messages. Reply [Keyword] to resubscribe.": "Example: [Your Brand]: You have successfully unsubscribed. You will receive no further messages. Reply [Keyword] to resubscribe.",
    "Example: [Your Brand]: You opted-in to receive SMS messages. Reply STOP to opt-out. Reply HELP to receive help. Message and data rates may apply.": "Example: [Your Brand]: You opted-in to receive SMS messages. Reply STOP to opt-out. Reply HELP to receive help. Message and data rates may apply.",
    "Examples": "Examples",
    "exceeded the file size": "exceeded the file size",
    "exceeded the file size or was unsupported": "exceeded the file size or was unsupported",
    "exceeded the file size or were unsupported": "exceeded the file size or were unsupported",
    "Exclude Groups": "Exclude Groups",
    "Exhausted": "Exhausted",
    "Existing Announcement": "Existing Announcement",
    "Existing Auto Attendant": "Existing Auto Attendant",
    "Existing Business Hours": "Existing Business Hours",
    "Existing Call Forwarding": "Existing Call Forwarding",
    "Existing Conference": "Existing Conference",
    "Existing Endpoint": "Existing Endpoint",
    "Existing Extension": "Existing Extension",
    "Existing Plan": "Existing Plan",
    "Existing Queue": "Existing Queue",
    "Existing embeds will stop working.": "Existing embeds will stop working.",
    "Existing Ring Group": "Existing Ring Group",
    "Existing User": "Existing User",
    "Existing Voicemail": "Existing Voicemail",
    "Exit": "Exit",
    "Exit audio": "Exit audio",
    "Exit Audio": "Exit Audio",
    "Exit by digit": "Exit by digit",
    "Exit destination": "Exit destination",
    "Exit destination type": "Exit destination type",
    "Exit Destinations": "Exit Destinations",
    "Exit full screen": "Exit full screen",
    "Exit sound": "Exit sound",
    "Expand": "Expand",
    "Expand sidebar": "Expand sidebar",
    "Expiration": "Expiration",
    "Expiration date": "Expiration date",
    "Expires After": "Expires After",
    "Export": "Export",
    "Export Logs": "Export Logs",
    "Expression used for replacing matches in the regex pattern": "Expression used for replacing matches in the regex pattern.",
    "Expression used to find a match in the input text": "Expression used to find a match in the input text.",
    "ext_card_description": "Install the extension to instantly start calls from any browser tab.",
    "Extend account settings": "Extend account settings",
    "Extension": "Extension",
    "Extension created": "Extension created",
    "Extension currently available for Chrome and Edge only": "Extension currently available for Chrome and Edge only",
    "Extension is required": "Extension is required",
    "Extension must be at least 3 digits long": "Extension must be at least 3 digits long",
    "Extension should be number": "Extension should be number",
    "Extension updated": "Extension updated",
    "Extensions": "Extensions",
    "External chats": "External chats",
    "external ID": "external ID",
    "External ID": "External ID",
    "Failed": "Failed",
    "Failed to copy": "Failed to copy",
    "Failed to delete campaign": "Failed to delete campaign",
    "Failed to delete template": "Failed to delete template",
    "Failed to generate API key": "Failed to generate API key.",
    "Failed to initiate monitoring": "Failed to initiate monitoring",
    "Failed to load health status": "Failed to load health status",
    "Failed to load integration": "Failed to load integration",
    "Failed to save the widget": "Failed to save the widget",
    "Failed to save wallboard": "Failed to save wallboard",
    "Failed to Send Test Email": "Failed to Send Test Email",
    "Failed to switch mode. Please try again.": "Failed to switch mode. Please try again.",
    "Failed to sync phone numbers": "Failed to sync phone numbers",
    "Failed to update inbox": "Failed to update inbox",
    "Failed to update integration": "Failed to update integration",
    "Failed to update template": "Failed to update template",
    "FAQ": "FAQ",
    "Favorites": "Favorites",
    "fax": "fax",
    "Fax": "Fax",
    "Fax option": "Fax option",
    "FaxBox": "FaxBox",
    "female": "female",
    "field and click": "field and click",
    "Field contains invalid characters": "{field} must contain only: alphanumeric characters, spaces, .,-_()",
    "File": "File",
    "File is required": "File is required",
    "File size must be under 4MB": "File size must be under 4MB",
    "Filter": "Filter",
    "FILTERED BY": "FILTERED BY",
    "Finance": "Finance",
    "Finance and banking": "Finance and banking",
    "finance-tour-step-1": "Welcome to PBX.IM!",
    "finance-tour-step-2": "Here, you'll find your profile picture, your name and company name. Click here to access more options.",
    "finance-tour-step-3": "Click on 'My Business'.",
    "finance-tour-step-4": "Click on the 'Billing' tab.",
    "finance-tour-step-5": "This section covers all your billing needs. Top up your account, view invoices, manage payment methods, and more.{br} If you'd like to learn more about other features, please refer to our {documentation}.",
    "Financial": "Financial",
    "Financial user": "Financial user",
    "Financial User": "Financial User",
    "Finish": "Finish",
    "Finish & Submit": "Finish & Submit",
    "Finish Purchase": "Finish Purchase",
    "first name": "first name",
    "First name": "First name",
    "First Name": "First Name",
    "First name *": "First Name *",
    "First Name *": "First Name *",
    "First name can only contain letters": "First name can only contain letters",
    "FIXED_LINE": "Fixed Line",
    "FIXED_LINE_OR_MOBILE": "Fixed Line or Mobile",
    "Flow name is required": "Flow name is required",
    "Flow name must be {max} characters or less": "Flow name must be {max} characters or less",
    "Flow name too long": "Flow name too long",
    "Flow saved successfully": "Flow saved successfully",
    "Flow start": "Flow start",
    "Flow sync failed - changes saved locally": "Flow sync failed - changes saved locally",
    "Flows Using Node": "Flows Using Node",
    "Flush registration": "Flush registration",
    "Flush Registration": "Flush Registration",
    "Flush registration command sent": "Flush registration command sent",
    "Follow me 10s delay": "Follow me 10s delay",
    "Follow me 15s delay": "Follow me 15s delay",
    "Follow me 20s delay": "Follow me 20s delay",
    "Follow me 30s delay": "Follow me 30s delay",
    "Follow me 40s delay": "Follow me 40s delay",
    "Follow me 50s delay": "Follow me 50s delay",
    "Follow me 5s delay": "Follow me 5s delay",
    "Follow me 60s delay": "Follow me 60s delay",
    "Follow me 70s delay": "Follow me 70s delay",
    "Follow me 80s delay": "Follow me 80s delay",
    "Follow me 90s delay": "Follow me 90s delay",
    "For added security, we need to verify your phone": "For added security, we need to verify your phone.",
    "For example, 60/1 means a minimum charge of 60 seconds, then billed in 1-second increments": "For example, 60/1 means a minimum charge of 60 seconds, then billed in 1-second increments",
    "Forbidden": "Forbidden",
    "Force password change": "Force password change",
    "Force Password Reset": "Force Password Reset",
    "Forced": "Forced",
    "forced sso": "Forced SSO",
    "Forced: An agent joins a queue automatically on check in": "Forced: An agent joins a queue automatically on check in",
    "Forgot password description": "Enter the email associated with your account and get a link to reset your password.",
    "Forgot Password?": "Forgot Password?",
    "Forgot your password?": "Forgot your password?",
    "Form for {nodeType} coming soon...": "Form for {nodeType} coming soon...",
    "Format": "Format",
    "Forward": "Forward",
    "Forward inbound SMS to email, phone, or another system": "Forward inbound SMS to email, phone, or another system.",
    "Forward SMS to": "Forward SMS to",
    "Forwarded message": "Forwarded message",
    "Found group chats": "Found group chats",
    "Found numbers": "{count, plural, one {# number found} other {# numbers found}}",
    "Found Users": "Found Users",
    "FRA": "FRA",
    "Fraud Alert Messaging": "Fraud Alert Messaging",
    "Fraud Prevention": "Fraud Prevention",
    "Fraud Prevention Plan": "Fraud Prevention Plan",
    "Free": "Free",
    "Free plan available for up to 5 users": "Free plan available for up to 5 users",
    "French": "French",
    "Frequently": "Frequently",
    "Fri": "Fri",
    "From": "From",
    "From No": "From No",
    "From now": "From now",
    "from the chat": "from the chat",
    "FS Domain": "FS Domain",
    "Gambling": "Gambling",
    "Gambling Lottery": "Gambling Lottery",
    "general": "general",
    "General": "General",
    "General information": "General information",
    "Generate password": "Generate password",
    "GEOGRAPHIC": "Geographic",
    "German": "German",
    "Get a code in your email at every login": "Get a code in your email at every login.",
    "Get a New Number": "Get a New Number",
    "get answer": "get answer",
    "Get Started": "Get Started",
    "Get Started For Free": "Get Started For Free",
    "Get started with Inbox": "Get started with Inbox",
    "Get started with your new number ": "Get started with your new number ",
    "Get Verified": "Get Verified",
    "Getting number...": "Getting number...",
    "Go Back": "Go Back",
    "Go back to Microsoft admin and click": "Go back to Microsoft admin and click",
    "Go to": "Go to",
    "Go to Dashboard": "Go to Dashboard",
    "Go to first page": "Go to first page",
    "Go to last page": "Go to last page",
    "Go to next page": "Go to next page",
    "go to numbers": "Go to <links>Call Routing > Phone Numbers</links> to add a new number",
    "Go to previous page": "Go to previous page",
    "Google": "Google",
    "Google Authenticator": "Google Authenticator",
    "Google Authenticator code": "Google Authenticator code",
    "Government": "Government",
    "Greeting": "Greeting",
    "Greeting is required": "Greeting is required",
    "Greeting long": "Greeting long",
    "Greeting Message": "Greeting Message",
    "Greeting short": "Greeting short",
    "Group": "Group",
    "Group name": "Group name",
    "Group Name": "Group Name",
    "Groups": "Groups",
    "Hang up": "Hang up",
    "Hangup": "Hangup",
    "Hangup Cause": "Hangup Cause",
    "has joined": "has joined",
    "Hash is required": "Hash is required",
    "have joined": "have joined",
    "Have you implemented a response to the HELP keyword informing customers of how they can contact the message sender?": "Have you implemented a response to the HELP keyword informing customers of how they can contact the message sender?",
    "He": "He",
    "Header": "Header",
    "Header Title": "Header Title",
    "Health": "Health",
    "Health Probe": "Health Probe",
    "Healthcare": "Healthcare",
    "Hebrew": "Hebrew",
    "Hello": "Hello",
    "Hello, Victor.": "Hello, Victor.",
    "Help us minimize the risk of fraud on your account": "Help us minimize the risk of fraud on your account.",
    "Here’s the ticket:": " Here’s the ticket:",
    "Hey there! Hope you're having a good one.": "Hey there! Hope you're having a good one.",
    "Hide filters": "Hide filters",
    "Hide keypad": "Hide keypad",
    "Hide Login with credentials": "Hide Login with credentials",
    "Hide QR Code": "Hide QR Code",
    "High": "High",
    "High risk": "High risk",
    "Higher Education": "Higher Education",
    "Hold": "Hold",
    "Hold on while we re-check the new domain": "Hold on while we re-check the new domain",
    "Hospitality": "Hospitality",
    "Hospitality and Travel": "Hospitality and Travel",
    "Host ACL": "Host ACL",
    "hours": "{value} hours",
    "Hours": "{value} Hours",
    "How calls are distributed in the queue to available agents": "How calls are distributed in the queue to available agents.",
    "How can I end my subscription?": "How can I end my subscription?",
    "How can I let callers know how long the wait might be in a queue?": "How can I let callers know how long the wait might be in a queue?",
    "How can I use call forwarding to handle after-hours calls or when I'm traveling?": "How can I use call forwarding to handle after-hours calls or when I'm traveling?",
    "How can I use conference rooms for project team meetings or remote training sessions?": "How can I use conference rooms for project team meetings or remote training sessions?",
    "How can I use Time Conditions to handle after-hours customer support?": "How can I use Business Hours to handle after-hours customer support?",
    "How can we help you?": "How can we help you?",
    "How could call queues help my business during peak hours or holiday seasons?": "How could call queues help my business during peak hours or holiday seasons?",
    "How do I assign an endpoint to a specific user?": "How do I assign an endpoint to a specific user?",
    "How do I change a user's role?": "How do I change a user's role?",
    "How do I create a professional voicemail greeting for my business?": "How do I create a professional voicemail greeting for my business?",
    "How do I integrate it?": "How do I integrate it?",
    "How do I purchase a phone number?": "How do I purchase a phone number?",
    "How do I select which calls should hear a specific announcement?": "How do I select which calls should hear a specific announcement?",
    "How do I set my security features?": "How do I set my security features?",
    "How do I set up call forwarding to a different number?": "How do I set up call forwarding to a different number?",
    "How does a Conference Room work?": "How does a Conference Room work?",
    "How does the Auto Attendant improve customer service?": "How does the Auto Attendant improve customer service?",
    "How does the Auto Attendant work?": "How does the Auto Attendant work?",
    "How long will the system try to reach the forwarded number before it gives up?": "How long will the system try to reach the forwarded number before it gives up?",
    "How many people can I add to an intercept group, and how many groups can a user be added to?": "How many people can I add to an intercept group, and how many groups can a user be added to?",
    "How many team members can I add under each billing plan?": "How many team members can I add under each billing plan?",
    "How many users with the same role can there be?": "How many users with the same role can there be?",
    "How to add contacts?": "How to add contacts?",
    "How to edit or delete a contact?": "How to edit or delete a contact?",
    "How to generate a report?": "How to generate a report?",
    "How to set up email notifications for voicemails?": "How to set up email notifications for voicemails?",
    "How to use the insights from the Dashboard?": "How to use the insights from the Dashboard?",
    "How to view the details of a call?": "How to view the details of a call?",
    "https://": "https://",
    "https://example.com": "https://example.com",
    "https://example.com/privacy": "https://example.com/privacy",
    "https://example.com/terms": "https://example.com/terms",
    "Hub": "Hub",
    "ICEX": "ICEX",
    "ID": "ID",
    "ID Verification": "ID Verification",
    "ID Verification coming soon": "ID Verification coming soon...",
    "ID Verification description": "Help us minimize the risk of fraud on your account.",
    "ID Verification full description": "We use Stripe Identity for ID Verification. In order to prevent fraud, we require ID verification if you want to make or receive phone calls. You can also set up this later on your profile page.",
    "ID Verification:": "ID Verification:",
    "Verify Your ID": "Verify Your ID",
    "Start New Verification": "Start New Verification",
    "Resume Verification": "Resume Verification",
    "Processing": "Processing",
    "Verified person:": "Verified person:",
    "Verification was cancelled or checks failed.": "Verification was cancelled or checks failed.",
    "Contact Support": "Contact Support",
    "ID Verification Failed — Account Unable to Complete Identity Check": "ID Verification Failed — Account Unable to Complete Identity Check",
    "id_verification_failed_ticket_description": "My identity verification was unsuccessful. The system returned a failed status after I completed or attempted the Stripe Identity verification flow. I need assistance resolving this so my account can be verified and upgraded from Limited Capacity.",
    "Your verification is being reviewed. This usually takes a few minutes.": "Your verification is being reviewed. This usually takes a few minutes.",
    "Idle": "Idle",
    "idle time": "idle time",
    "Idle time": "Idle time",
    "If “Embedded Link” is set to Yes, include a link in at least one sample": "If “Embedded Link” is set to Yes, include a link in at least one sample",
    "If a match is found, stop applying the next rules": "If a match is found, stop applying the next rules.",
    "If donations are collected, it must be clearly stated": "If donations are collected, it must be clearly stated",
    "If multiple use cases are registered, describe all use cases in the description (i.e., 2FA and Marketing use cases should both be mentioned in the campaign description.)": "If multiple use cases are registered, describe all use cases in the description (i.e., 2FA and Marketing use cases should both be mentioned in the campaign description.)",
    "If Replay greeting is missing it will be played multiple times": "If Replay greeting is missing it will be played multiple times",
    "If the agent goes over the time limit, the manager is notified, and the agent's timer gets highlighted in red": "If the agent goes over the time limit, the manager is notified, and the agent's timer gets highlighted in red",
    "If you don't set up your two-factor authentication (TFA) now, you will need to do it the next time you log in": "If you don't set up your two-factor authentication (TFA) now, you will need to do it the next time you log in!",
    "If you regenerate the QR you will need to set up Google Authenticator again": "If you regenerate the QR you will need to set up Google Authenticator again",
    "Immediately": "Immediately",
    "Import": "Import",
    "Import existing": "Import existing",
    "Import Existing Plan": "Import Existing Plan",
    "In order to keep your account secure we recommend setting up Two-Factor Authentication.": "In order to keep your account secure we recommend setting up Two-Factor Authentication.",
    "In Progress": "In Progress",
    "In Review": "In Review",
    "In the": "In the",
    "In the meantime, find us on": "In the meantime, find us on",
    "In the sidebar go to": "In the sidebar go to",
    "In the sidebar navigate to": "In the sidebar navigate to",
    "In the verification step, click": "In the verification step, click",
    "in this window to proceed": "in this window to proceed",
    "Inactive": "Inactive",
    "Inactivity Timeout": "Inactivity Timeout",
    "inactivity timeout notification": "You'll be logged out in 60s",
    "inbound": "inbound",
    "Included": "Included",
    "Inbound": "Inbound",
    "Inbound calls": "Inbound calls",
    "Inbound Calls": "Inbound Calls",
    "Inbound Cost": "Inbound Cost",
    "Inbound external": "Inbound external",
    "Inbound Inbox Notifications": "Inbound Inbox Notifications",
    "Inbound internal": "Inbound internal",
    "Inbound queue": "Inbound queue",
    "Inbound SMS": "Inbound SMS",
    "Inbound SMS messages will be forwarded to the email address you specify below": "Inbound SMS messages will be forwarded to the email address you specify below",
    "Inbound Trunk": "Inbound Trunk",
    "Inbox": "Inbox",
    "Inbox Destination": "Inbox Destination",
    "Inbox Number": "Inbox Number",
    "Inbox updated successfully": "Inbox updated successfully",
    "Inboxes": "Inboxes",
    "Include in reports": "Include in reports",
    "Incoming call": "Incoming call",
    "Incoming Call": "Incoming Call",
    "Incoming Call From": "Incoming Call From",
    "incoming call notification": "{caller} is calling",
    "incoming call notification queue": "Incoming Call for {queue}",
    "Incoming Calls": "Incoming Calls",
    "Incoming Internal Call": "Incoming Internal Call",
    "Incr": "Incr",
    "Increase team capacity": "Increase team capacity",
    "Increment": "Increment",
    "Increments": "Increments",
    "Industry": "Industry",
    "Industry *": "Industry *",
    "Info": "Info",
    "Information Required": "Information Required",
    "Information Technology": "Information Technology",
    "Init Incr": "Init. Incr.",
    "Initial fees": "Initial fees",
    "Initial Increment": "Initial Increment",
    "Initial increment / Increment": "Initial increment / Increment",
    "Input": "Input",
    "Input chat name": "Input chat name",
    "Insert Token": "Insert Token",
    "Instantly add funds to your account": "Instantly add funds to your account",
    "Insurance": "Insurance",
    "Integrates with some of the most popular CRMs": "Integrates with some of the most popular CRMs.",
    "Integration": "Integration",
    "Integration name": "Integration name",
    "Integration Script": "Integration Script",
    "Integration updated": "Integration updated",
    "Integrations": "Integrations",
    "Inter digit": "Inter digit",
    "Inter digit timeout": "Inter digit timeout",
    "Intercept Groups": "Intercept Groups",
    "Intercept other groups": "Intercept other groups",
    "Internal": "Internal",
    "Internal call": "Internal call",
    "Internal calls": "Internal calls",
    "Internal Calls": "Internal Calls",
    "Internal Chat": "Internal Chat",
    "Internal chats": "Internal chats",
    "Internal Chats": "Internal Chats",
    "International": "International",
    "Interval": "Interval",
    "into the": "into the",
    "into the top field called": "into the top field called",
    "Intro audio": "Intro audio",
    "Invalid amount": "Invalid amount",
    "Invalid audio": "Invalid audio",
    "Invalid Audio": "Invalid Audio",
    "Invalid callback parameters": "Invalid callback parameters",
    "Invalid code": "Invalid code",
    "Invalid color": "Invalid color",
    "Invalid email address": "Invalid email address",
    "Invalid email code": "Invalid email code.",
    "Invalid file type. Allowed types:": "Invalid file type. Allowed types: {ext}.",
    "Invalid IP address in ACL list": "Invalid IP address in ACL list",
    "Invalid IP address or hostname": "Invalid IP address or hostname",
    "Invalid IP address or hostname.": "Invalid IP address or hostname.",
    "Invalid leads": "Invalid leads",
    "Invalid number": "Invalid number",
    "Invalid Number": "Invalid Number",
    "invalid number error": "Invalid number",
    "invalid numbers": "invalid numbers",
    "Invalid phone code": "Invalid phone code.",
    "Invalid phone number": "Invalid phone number.",
    "Invalid selection audio": "Invalid selection audio",
    "Invalid sound": "Invalid sound",
    "Invalid type for number": "Invalid type for number",
    "Invalid verification code": "Invalid verification code.",
    "Invitation 2FA description": "The person who invited required you to have 2FA enabled. Scan the QR code below using the Google Authenticator app to enhance security",
    "Invitation expired": "Invitation expired",
    "Invitation Expired": "Invitation Expired",
    "Invitation sent successfully.": "Invitation sent successfully.",
    "Invitations": "Invitations",
    "Invitations description": "Manage invited users and their status",
    "Invite people to chat": "Invite people to chat",
    "Invite Sent": "Invite Sent",
    "Invite sent successfully": "Invite sent successfully",
    "Invite created, email not sent": "Invite created, email not sent",
    "Invite Sent Successfully": "Invite Sent Successfully",
    "Invited": "Invited",
    "Invited At": "Invited At",
    "Invoice": "Invoice",
    "Invoice number": "Invoice number",
    "Invoice Total": "Invoice Total",
    "Invoices": "Invoices",
    "IP": "IP",
    "IP Authentication Host / ACL": "IP Authentication Host / ACL",
    "IP range": "IP range",
    "IP Range": "IP Range",
    "ip_invalid": "Invalid IP address.",
    "IP, IP Range or CIDR": "IP, IP Range or CIDR",
    "IP:port": "IP:port",
    "IPv4": "IPv4",
    "IPv4 range": "IPv4 range",
    "IPv4, Range or CIDR": "IPv4, Range or CIDR",
    "Is agent": "Is agent",
    "Is it possible to schedule different greetings for different times of the day?": "Is it possible to schedule different greetings for different times of the day?",
    "is listening": "is listening",
    "is required": "is required",
    "Is required": "{field} is required.",
    "Is there a way to automatically answer calls if an agent from a queue is free?": "Is there a way to automatically answer calls if an agent from a queue is free?",
    "Is there a way to limit the number of people who can join a conference at one time?": "Is there a way to limit the number of people who can join a conference at one time?",
    "Is there a way to test my dial rules?": "Is there a way to test my dial rules?",
    "is too long": "{what} is too long",
    "is typing": "is typing",
    "is typing...": "is typing...",
    "is whispering": "is whispering",
    "It can repeat instructions, without the welcome message": "It can repeat instructions, without the welcome message",
    "It might take some time for the DNS records to apply.": "It might take some time for the DNS records to apply.",
    "It uses a high-speed internet connection to connect to a VoIP service provider": "It uses a high-speed internet connection to connect to a VoIP service provider.",
    "It's paid until <b>{date}</b> and can be reactivated at any time before then.": "It's paid until <b>{date}</b> and can be reactivated at any time before then.",
    "It's used in multiple flows, so the changes will affect all of them": "It's used in multiple flows, so the changes will affect all of them.",
    "Item": "Item",
    "Items": "Items",
    "Join": "Join",
    "Join / leave by time group": "Join / leave by time group",
    "Join chat": "Join chat",
    "Join Chat": "Join Chat",
    "Join option": "Join option",
    "Join Option": "Join Option",
    "Join Queue": "Join Queue",
    "Join this chat to start messaging": "Join this chat to start messaging",
    "Join/leave queue": "Join/leave queue",
    "Join/Leave Time Group": "Join/Leave Time Group",
    "joined the chat": "joined the chat",
    "JPX": "JPX",
    "JSE": "JSE",
    "Jump to": "Jump to",
    "Keep Alive": "Keep Alive",
    "Keep editing": "Keep editing",
    "Keep Local File": "Keep Local File",
    "Key": "Key",
    "Keypad": "Keypad",
    "KPI": "KPI",
    "KRX": "KRX",
    "Label": "Label",
    "Labels": "Labels",
    "Labels or keywords for easier management, sorting, or categorization": "Labels or keywords for easier management, sorting, or categorization.",
    "Lang": "Lang",
    "Language": "Language",
    "Language of the dynamic audio": "Language of the dynamic audio",
    "Last 200 OK from Hub": "Last 200 OK from Hub",
    "Last 30 days": "Last 30 days",
    "Last 7 days": "Last 7 days",
    "Last Edited By": "Last Edited By",
    "Last Inbound Options": "Last Inbound Options",
    "Last Login": "Last Login",
    "Last message": "Last message",
    "Last month": "Last month",
    "last name": "last name",
    "Last name": "Last name",
    "Last Name": "Last Name",
    "Last name *": "Last Name *",
    "Last Name *": "Last Name *",
    "Last name can only contain letters": "Last name can only contain letters",
    "Last Reg": "Last Reg",
    "Last sync: {date}": "Last sync: {date}",
    "Last Update": "Last Update",
    "Last week": "Last week",
    "Launch": "Launch",
    "Leave empty to keep the current value": "Leave empty to keep the current value",
    "Leave empty to remove the PIN": "Leave empty to remove the PIN",
    "View": "View",
    "Lead ID": "Lead ID",
    "Lead Link Url": "Lead Link Url",
    "Learn more about messaging registration": "Learn more about messaging registration",
    "Leave": "Leave",
    "Leave conversation": "Leave conversation",
    "Leave Queue": "Leave Queue",
    "Leave your number for exclusive updates:": "Leave your number for exclusive updates:",
    "left the chat": "left the chat",
    "Legal": "Legal",
    "Legal company name": "Legal company name",
    "Length": "Length",
    "Length of the digit inputs": "Length of the digit inputs",
    "Less filters": "Less filters",
    "Let's talk": "Let's talk",
    "Let’s verify your email": "Let’s verify your email",
    "Letters Only": "Letters Only",
    "Level": "Level",
    "Level wait time": "Level wait time",
    "Light": "Light",
    "Line chart": "Line chart",
    "Link copied": "Link copied",
    "Linked Inbox": "Linked Inbox",
    "Linked inbox for inbound replies. Read only — edit via the Inbox phone number settings.": "Linked inbox for inbound replies. Read only — edit via the Inbox phone number settings.",
    "Linked Phone Numbers": "Linked Phone Numbers",
    "Listen": "Listen",
    "Listen to Own Calls Recordings": "Listen to Own Calls Recordings",
    "Listening": "Listening",
    "Live": "Live",
    "Live calls": "Live calls",
    "Live Calls": "Live Calls",
    "Load more": "Load more",
    "Loading": "Loading",
    "Loading...": "Loading...",
    "Localized": "Localized",
    "Location": "Location",
    "Log in": "Log in",
    "Log In": "Log In",
    "Log in to your account": "Log in to your account",
    "Log Out": "Log Out",
    "Log out all users": "Log out all users",
    "Log user out": "Log user out",
    "Log users out": "Log users out",
    "Logging out": "Logging out",
    "Logging you out": "Logging you out",
    "Login": "Login",
    "Login & SIP registration by countries and/or IP ranges": "Login & SIP registration by countries and/or IP ranges",
    "Login Access": "Login Access",
    "Logo": "Logo",
    "Logout": "Logout",
    "Logs": "Logs",
    "Logs for all previous calls": "Logs for all previous calls",
    "LON": "LON",
    "Long Text": "Long Text",
    "Longest Idle Agent": "Longest Idle Agent",
    "Longest waiting call": "Longest waiting call",
    "Longest Waiting Call": "Longest Waiting Call",
    "Longest: {value}": "Longest: {value}",
    "Low": "Low",
    "Low balance threshold": "Low balance threshold",
    "Lower than Range Start": "Lower than Range Start.",
    "Lowercase letters (a-z)": "Lowercase letters (a-z)",
    "LTR": "LTR",
    "Mac": "Mac",
    "Mail": "Mail",
    "Main audio": "Main audio",
    "Main Audio": "Main Audio",
    "Main greeting": "Main greeting",
    "Make default": "Make default",
    "Make default card": "Make default card",
    "Makes and receives calls": "Makes and receives calls.",
    "Making calls, receiving calls, voicemail, email, ring groups, class-5 telephone switch": "Making calls, receiving calls, voicemail, email, ring groups, class-5 telephone switch.",
    "male": "male",
    "Manage accounts": "Manage accounts",
    "Manage all the users for this account": "Manage all the users for this account.",
    "Manage all your auto dialer": "Manage all your auto dialer",
    "Manage all your phones (softphones or physical) in one place": "Manage all your phones (softphones or physical) in one place.",
    "Manage incoming calls when all lines are busy or agents are unavailable": "Manage incoming calls when all lines are busy or agents are unavailable.",
    "Manage IVRs": "Manage IVRs",
    "Manage numbers, check details, and define call routing per number.": "Manage numbers, check details, and define call routing per number.",
    "Manage Seats": "Manage Seats",
    "Manage teams": "Manage teams.",
    "Manage the account's general settings": "Manage the account's general settings.",
    "Manage the company info and settings": "Manage the company info and settings.",
    "Manage the list of dial rules affecting the calls": "Manage the list of dial rules affecting the calls",
    "Manage the list of statuses an agent can have": "Manage the list of statuses an agent can have",
    "Manage the profile info and settings": "Manage the profile info and settings.",
    "Manage the SIP trunk settings.": "Manage the SIP trunk settings.",
    "Manage timegroups and their destinations": "Manage timegroups and their destinations",
    "Manage user data and settings": "Manage user data and settings.",
    "Manage your account's communication channels": "Manage your account's communication channels",
    "Manage your account’s communication channels": "Manage your account’s communication channels",
    "Manage your auto-dialer campaigns": "Manage your auto-dialer campaigns.",
    "Manage your business profile, payment plans and call rates": "Manage your business profile, payment plans and call rates",
    "Manage your company profile, payment plans and call rates": "Manage your company profile, payment plans and call rates.",
    "Manage your company profile, payment plans and security": "Manage your company profile, payment plans and security.",
    "Managed SBC Domain": "Managed SBC Domain",
    "Managed subdomain": "Managed subdomain",
    "Management Emails": "Management Emails",
    "Manages most financial aspects": "Manages most financial aspects.",
    "Manages the account": "Manages the account.",
    "Manange inboxes assigned to users and teams.": "Manange inboxes assigned to users and teams.",
    "Manual": "Manual",
    "Manual: An agent joins a queue manually": "Manual: An agent joins a queue manually",
    "Manufacturing": "Manufacturing",
    "Manufacturing and Logistics": "Manufacturing and Logistics",
    "Marketing": "Marketing",
    "Mask All calls": "Mask All calls",
    "mask digits at the end": "mask digits at the end",
    "mask digits in the middle": "mask digits in the middle",
    "Mask Inbound calls": "Mask Inbound calls",
    "Mask Outbound calls": "Mask Outbound calls",
    "Mask phone number": "Mask phone number",
    "Masking Format": "Masking Format",
    "Masking Options": "Masking Options",
    "Mastercard": "Mastercard",
    "Mastercard Test Card Name": "Mastercard Test Card Name",
    "match": "match",
    "Match destination": "Match destination",
    "Match Value": "Match Value",
    "Match value is required": "Match value is required",
    "Matched": "Matched",
    "Max": "Max",
    "Max Attempts": "Max Attempts",
    "Max Channels": "Max Channels",
    "Max characters": "Maximum is {number} characters",
    "Max characters: 100": "Max characters: 100",
    "Max Concurrent Calls": "Max Concurrent Calls",
    "Max digit length": "Max digit length",
    "Max digits": "Max digits",
    "Max Digits": "Max Digits",
    "Max duration must be greater than min": "Max duration must be greater than min",
    "Max failures": "Max failures",
    "Max Failures": "Max Failures",
    "Max members": "Max members",
    "Max Members": "Max Members",
    "Max N": "Max {n}",
    "Max N chars": "Must be at most {n} characters",
    "Max N for US/CA": "Max {n} for US/CA",
    "Max N labels": "You can add at most {n} labels",
    "Max number of users for this account": "Max number of users for this account.",
    "Max Ring Duration": "Max Ring Duration",
    "Max Simultaneous Calls": "Max Simultaneous Calls",
    "Max Simultaneous Calls For The Dialer": "Max Simultaneous Calls For The Dialer",
    "Max Simultaneous calls per user": "Max Simultaneous calls per user",
    "Max snooze number": "Max snooze number",
    "Max Snooze Number": "Max Snooze Number",
    "Max time a caller will wait in the queue before being directed to the exit destination": "Max time a caller will wait in the queue before being directed to the exit destination.",
    "Max value": "Max value is {max}",
    "Max Wait": "Max Wait",
    "max wait time": "max wait time",
    "Max wait time": "Max wait time",
    "Max Wait Time": "Max Wait Time",
    "Customer max waiting duration": "Customer max waiting duration",
    "Max wait time - no agents": "Max wait time - no agents",
    "max wait time tooltip kpi": "The longest wait time experienced by any caller within the selected period. This helps identify peak congestion and response time issues.",
    "Maximum 10 files per upload. The extra files were not included.": "Maximum 10 files per upload. The extra files were not included.",
    "Maximum 5 routes allowed": "Maximum 5 routes allowed",
    "Maximum call wait time": "Maximum call wait time",
    "Maximum simultaneous calls per agent": "Maximum simultaneous calls per agent.",
    "Maximum time range is 90 days.": "Maximum time range is 90 days.",
    "maximum_files": "You can upload a maximum of {max} files.",
    "MB": "MB",
    "Media": "Media",
    "Media could not be delivered.": "Media could not be delivered.",
    "Media could not be retrieved.": "Media could not be retrieved.",
    "Media expired — no longer available.": "Media expired — no longer available.",
    "media file": "media file",
    "Media file": "Media file",
    "Media File": "Media File",
    "Media file created": "Media file created",
    "Media file is in use": "This media file is in use and cannot be deleted.",
    "Media file is in use by": "This media file cannot be deleted — it is still used by {entities}.",
    "Media file is not used": "Media file is not used",
    "Media file updated": "Media file updated",
    "Media Files": "Media Files",
    "Media is not available.": "Media is not available.",
    "Medium": "Medium",
    "Member authentication": "Member authentication",
    "Members": "Members",
    "Merge": "Merge",
    "Merge Calls": "Merge Calls",
    "Message": "Message",
    "Message could not be delivered.": "Message could not be delivered.",
    "Message Count": "Message Count",
    "Message Flow": "Message Flow",
    "Message Flow describes how a consumer opts in and gives consent to receive messages": "Message Flow describes how a consumer opts in and gives consent to receive messages",
    "Message Flow must be between 40 and 2048 characters": "Message Flow must be between 40 and 2048 characters",
    "Message is too long. Maximum is 2000 characters.": "Message is too long. Maximum is 2000 characters.",
    "Message Logs": "Message Logs",
    "Message shown when closed": "Message shown when closed",
    "Message types": "Message types",
    "Message...": "Message...",
    "Messages allocated disk space": "Messages allocated disk space",
    "Messages confirmed as delivered to the recipient's device.": "Messages confirmed as delivered to the recipient's device.",
    "Messages Per Day": "Messages Per Day",
    "Messages Per Hour": "Messages Per Hour",
    "Messages submitted to the carrier.": "Messages submitted to the carrier.",
    "Messages that could not be delivered (invalid number, carrier rejection, etc.).": "Messages that could not be delivered (invalid number, carrier rejection, etc.).",
    "Messaging blocked": "Messaging blocked",
    "Method": "Method",
    "Method is required": "Method is required",
    "Methods used for two-factor authentication": "Methods used for two-factor authentication.",
    "mic permission denied": "Microphone permission has been denied. Please allow microphone access in your browser settings to proceed.",
    "Microphone": "Microphone",
    "Microphone and output endpoint are not connected to this computer.": "Microphone and output endpoint are not connected to this computer.",
    "Microphone is not connected.": "Microphone is not connected.",
    "Microsoft": "Microsoft",
    "Microsoft 365": "Microsoft 365",
    "Microsoft Teams": "Microsoft Teams",
    "Microsoft Teams channels:": "Microsoft Teams channels:",
    "microsoft_teams_card_description": "Connect your Microsoft Teams and use your PBX.IM numbers and server to make calls.",
    "microsoft_teams_wizard_placeholder": "Setup wizard coming soon.",
    "microsoftTeams.setup.managed.sbcDomainTaken": "SBC Domain already used in another integration",
    "middle name": "middle name",
    "Middle name": "Middle name",
    "Min": "Min",
    "MIN": "MIN",
    "Min Dur": "Min Dur",
    "Min duration to consider call resolved": "Min duration to consider call resolved",
    "Min N chars": "Must be at least {n} characters",
    "Min value": "Min value is {min}",
    "Min. Available Agents": "Min. Available Agents",
    "Min. Billing Increment": "Min. Billing Increment",
    "Min. Subscription Period": "Min. Subscription Period",
    "minimum charge seconds": "{seconds, plural, =1 {Minimum charge of 1 second, then charged in {increment}‑second increments.} other {Minimum charge of # seconds, then charged in {increment}‑second increments.}}",
    "Minute": "Minute",
    "Minute Cost (Inbound)": "Minute Cost (Inbound)",
    "Minutes": "{value} Minutes",
    "Missed": "Missed",
    "Missed Call": "Missed Call",
    "Missed Calls": "Missed Calls",
    "missed calls notification": "{count, plural, =1{You have 1 missed call} other{You have # missed calls}}",
    "Missed inbound": "Missed inbound",
    "Missed outbound": "Missed outbound",
    "Missing flow name": "Missing flow name",
    "Missing trigger": "Missing trigger",
    "MOBILE": "Mobile",
    "Mobile phone number should be in international format (e164)": "Mobile phone number should be in international format (e164)",
    "Module": "Module",
    "Module permissions": "Module permissions",
    "Mon": "Mon",
    "Monitoring": "Monitoring",
    "Monitoring not available": "Monitoring not available",
    "Monitors information without making changes": "Monitors information without making changes.",
    "Mono": "Mono",
    "Mono playback": "Mono playback",
    "month": "month",
    "Month": "Month",
    "Month / User": "Month / User",
    "monthly": "monthly",
    "Monthly": "Monthly",
    "Monthly cost": "Monthly cost",
    "Monthly Cost": "Monthly Cost",
    "Monthly invoice": "Monthly invoice",
    "Monthly Price": "Monthly Price",
    "Monthly Recurring": "Monthly Recurring",
    "months": "{number} Months",
    "Months": "{number} Months",
    "Months count": "{count} Months",
    "More actions": "More actions",
    "more count": "+ {count} more",
    "More filters": "More filters",
    "More options": "More options",
    "MP3 Call Recording": "MP3 Call Recording",
    "MP3 call recordings Storage": "MP3 call recordings Storage",
    "MS TXT record created": "MS TXT record created",
    "MS=ms12345678": "MS=ms12345678",
    "multiple channels": "multiple channels",
    "Multiple keywords are comma separated without space": "Multiple keywords are comma separated without space",
    "Music": "Music",
    "Music on hold": "Music on hold",
    "Must be a positive integer": "Must be a positive integer",
    "Must be between 20 and 320 characters long": "Must be between 20 and 320 characters long",
    "Must be either 'email' or 'phone'": "Must be either 'email' or 'phone'",
    "Mute": "Mute",
    "Mute microphone": "Mute microphone",
    "Mute on join": "Mute on join",
    "Mute on Join": "Mute on Join",
    "Mute Toggle": "Mute Toggle",
    "My Business": "My Business",
    "My Caller ID": "My Caller ID",
    "My Company": "My Company",
    "My Inbox": "My Inbox",
    "My Profile": "My Profile",
    "My Queues": "My Queues",
    "N / N Characters": "{n} / {max} Characters",
    "N SEGMENT": "{n} {n, plural, one {SEGMENT} other {SEGMENTS}}",
    "N/A": "N/A",
    "name": "name",
    "Name": "Name",
    "NAME": "NAME",
    "Name can only contain letters": "Name can only contain letters",
    "Name cannot be empty.": "Name cannot be empty.",
    "Name is required": "Name is required",
    "Name of the Auto Attendant": "Name of the Auto Attendant",
    "Name's inbox": "{name}'s Inbox",
    "NASDAQ": "NASDAQ",
    "NATIONAL": "National",
    "Need an Account?": "Need an Account?",
    "Need help registering?": "Need help registering?",
    "Need help?": "Need help?",
    "Need to add another card?": "Need to add another card?",
    "never": "never",
    "New": "New",
    "New Route": "New Route",
    "New chat": "New chat",
    "New Chat": "New Chat",
    "New chat in queue": "New chat in queue",
    "New contact has been saved": "New contact has been saved",
    "New contact has been updated": "New contact has been updated",
    "New endpoint": "New endpoint",
    "New extension": "New extension",
    "New forward": "New forward",
    "New intercept group": "New intercept group",
    "New password": "New password",
    "New password must be different from current password": "New password must be different from current password.",
    "New Preset": "New Preset",
    "New queue": "New queue",
    "New time condition": "New Business Hours",
    "New time group": "New time group",
    "New voicemail - {vm_box_name} [{datetime}]": "New voicemail - {vm_box_name} [{datetime}]",
    "Next": "Next",
    "Next billing": "Next billing:",
    "Next Invoice Date": "Next Invoice Date",
    "NGO": "NGO",
    "No": "No",
    "No A2P-approved numbers": "No A2P-approved numbers",
    "no agent answer timeout": "no agent answer timeout",
    "No agents assigned": "No agents assigned",
    "No answer": "No answer",
    "No Answer": "No Answer",
    "No answer delay": "No answer delay",
    "No Answer Delay": "No Answer Delay",
    "No campaigns registered yet": "No campaigns registered yet",
    "No chat history, yet": "No chat history, yet",
    "No chats available": "No chats available",
    "No chats match your search": "No chats match your search",
    "No closed conversations": "No closed conversations",
    "No contacts found": "No contacts found",
    "No conversations": "No conversations",
    "No conversations found": "No conversations found",
    "No countries found": "No countries found",
    "No credit card needed to get started": "No credit card needed to get started",
    "No data available": "No data available",
    "No data to show": "No Data To Show",
    "No data yet": "No data yet",
    "No Delay": "No Delay",
    "No endpoint": "No endpoint",
    "No filters or search applied": "No filters or search applied",
    "No hardware and maintenance costs": "No hardware and maintenance costs.",
    "No Inbox Chosen": "No Inbox Chosen",
    "No input max": "No input max",
    "No Input Max": "No Input Max",
    "No input threadshold": "No input threadshold",
    "No input wait time": "No input wait time",
    "No Input Wait Time": "No Input Wait Time",
    "No items": "No items",
    "No live calls": "No live calls",
    "No match destination": "No match destination",
    "no message timeout": "no message timeout",
    "No nodes found": "No nodes found",
    "No Numbers Available": "No Numbers Available",
    "No numbers found": "No numbers found",
    "no of users": "{numberOfSeats} users",
    "No payment method on record": "No payment method on record",
    "No people match your search": "No people match your search",
    "No phone numbers attached yet": "No phone numbers attached yet",
    "No Presets": "No Presets",
    "No queues": "No queues",
    "No queues joined yet": "No queues joined yet.",
    "No recent calls": "No recent calls",
    "No relevant information could be found in the documentation about this topic": "No relevant information could be found in the documentation about this topic",
    "No Repeat": "No Repeat",
    "No results": "No results",
    "No results found": "No results found",
    "No scripts available": "No scripts available",
    "No SLA": "No SLA",
    "No SMS-enabled numbers": "No SMS-enabled numbers",
    "No SMS-enabled phone numbers available": "No SMS-enabled phone numbers available",
    "No speech was found in the audio": "No speech was found in the audio.",
    "No state found": "No state found",
    "No templates found": "No templates found",
    "No timeout": "No timeout",
    "No wallboard hash provided": "No wallboard hash provided",
    "no_agent": "No Agent",
    "no_answer": "No Answer",
    "no-limits music on hold": "no-limits music on hold",
    "no-match": "No Match",
    "Nobody": "Nobody",
    "Node Used In Multiple Flows": "Node Used In Multiple Flows",
    "Node used in multiple flows. Changes will apply to all flows": "Node used in multiple flows. Changes will apply to all flows.",
    "Nodes": "Nodes",
    "Noise Suppression": "Noise Suppression",
    "Non Billable": "Non Billable",
    "Non Government Organization": "Non Government Organization",
    "Non-Billable": "Non-Billable",
    "None": "None",
    "Nonprofit organization": "Nonprofit organization",
    "North America": "North America",
    "Not available": "Not available",
    "Not checked-in": "Not checked-in",
    "Not connected": "Not connected",
    "Not detected yet": "Not detected yet",
    "Not in use": "Not in use",
    "Not In Use": "Not In Use",
    "Not Matched": "Not Matched",
    "Not Verified": "Not Verified",
    "Note": "Note",
    "notes": "notes",
    "Notes": "Notes",
    "Notification Email": "Notification Email",
    "now": "now",
    "NSE": "NSE",
    "number": "number",
    "Number": "Number",
    "Number Format": "Number Format",
    "Number format updated": "Number format updated",
    "Number is required": "Number is required",
    "Number of Agents In Queues": "Number of Agents In Queues",
    "Number of agents ready for calls": "Number of agents ready for calls",
    "Number of answered calls": "Number of answered calls",
    "Number of calls": "Number of calls",
    "Number Of Calls": "Number Of Calls",
    "Number of calls answered by agents": "Number of calls answered by agents",
    "Number of calls received": "Number of calls received",
    "Number Of Pauses": "Number Of Pauses",
    "Number of unanswered calls": "Number of unanswered calls",
    "Number of unique calls": "Number of unique calls",
    "Number of users": "Number of users:",
    "Number of Users": "Number of Users",
    "Number Range": "Number Range",
    "Number transformation rules": "Number transformation rules",
    "Numbers": "Numbers",
    "Numbers in certain countries require end user details for activation based on the country's telecom regulations.": "Numbers in certain countries require end user details for activation based on the country's telecom regulations.",
    "numbers max": "{count} numbers max.",
    "Numbers Only": "Numbers Only",
    "NYSE": "NYSE",
    "Occupation": "Occupation",
    "Occupation time": "Occupation time",
    "of": "of",
    "of {amount}": "of {amount}",
    "offline": "offline",
    "Offline": "Offline",
    "Offline / Not check-in": "Offline / Not check-in",
    "Ok": "Ok",
    "Ok, got it": "Ok, got it",
    "Ok, let me know then if I can help you with any other issue": "Ok, let me know then if I can help you with any other issue",
    "OMX": "OMX",
    "ON / OFF": "ON / OFF",
    "on call": "on call",
    "On call": "On call",
    "On Call": "On Call",
    "on hold": "on hold",
    "On hold": "On hold",
    "On Hold": "On Hold",
    "On low balance": "On low balance",
    "On Pause": "On Pause",
    "On Phone": "On Phone",
    "On save the browser session will be disabled for all integrations": "On save the browser session will be disabled for all integrations.",
    "On save the browser session will be enabled for all integrations": "On save the browser session will be enabled for all integrations.",
    "onboarding-tour-flow-step-1": "Welcome to PBX.IM! Follow the next steps to make your first test call.",
    "onboarding-tour-flow-step-10": "The IP address through which your endpoint is connected to PBX.IM",
    "onboarding-tour-flow-step-11": "Details about the device type or software version.",
    "onboarding-tour-flow-step-12": "Media Access Control address of the endpoint.",
    "onboarding-tour-flow-step-13": "The last time the endpoint connected to PBX.IM",
    "onboarding-tour-flow-step-14": "Displays the endpoint status.",
    "onboarding-tour-flow-step-15": "Review your balance. We have added $5 to your account for test calls.",
    "onboarding-tour-flow-step-16": "Click on the Webphone.",
    "onboarding-tour-flow-step-17": "Make sure your microphone is connected.",
    "onboarding-tour-flow-step-18": "Type in the phone number you want to call.",
    "onboarding-tour-flow-step-19": "Press call.",
    "onboarding-tour-flow-step-2": "Go to the side menu.",
    "onboarding-tour-flow-step-3": "Click on \"Settings\".",
    "onboarding-tour-flow-step-4": "Click on \"Endpoints\".",
    "onboarding-tour-flow-step-5": "The icon will indicate the type of endpoint. The globe icon represents a webphone.",
    "onboarding-tour-flow-step-6": "Your Endpoint name.",
    "onboarding-tour-flow-step-7": "The username associated with the endpoint.",
    "onboarding-tour-flow-step-8": "The phone extension assigned to the endpoint.",
    "onboarding-tour-flow-step-9": "The user the endpoint is assigned to.",
    "Once activated, a prorated charge will apply for the rest of this {period}": "Once activated, a prorated charge will apply for the rest of this {period}",
    "Once saved, click": "Once saved, click",
    "Once the record is checked you can move to the next step.": "Once the record is checked you can move to the next step.",
    "Once verified, click": "Once verified, click",
    "One or more email addresses are invalid": "One or more email addresses are invalid",
    "One or more names are invalid": "One or more names are invalid",
    "One seat has been allocated to the new user": "One seat has been allocated to the new user",
    "One time password": "One time password",
    "One Time Password": "One Time Password",
    "One Time Password *": "One Time Password *",
    "One time password is required": "One time password is required",
    "One time password must be 6 characters": "One time password must be 6 characters",
    "One time password must be 6 characters long": "One time password must be 6 characters long",
    "One-time": "One-time",
    "One-time charges include the setup cost, prorated charge for the current month, and charges for the minimum subscription period": "One-time charges include the setup cost, prorated charge for the current month, and charges for the minimum subscription period",
    "One-time password": "One-time password",
    "Online": "Online",
    "Online and Working": "Online and Working",
    "Only A2P approved numbers are shown. Numbers without approval are not eligible for bulk SMS campaigns to US or Canadian numbers.": "Only A2P approved numbers are shown. Numbers without approval are not eligible for bulk SMS campaigns to US or Canadian numbers.",
    "Only numbers with an approved A2P Campaign are shown here. If a number isn’t listed, ensure it is associated with an approved A2P Campaign. <link>Apply for A2P →</link>": "Only numbers with an approved A2P Campaign are shown here. If a number isn’t listed, ensure it is associated with an approved A2P Campaign. <link>Apply for A2P →</link>",
    "Only one browser session is allowed You’ve already enabled it in another C2C integration": "Only one browser session is allowed. You’ve already enabled it in another C2C integration.",
    "onlyLetters": "{field} can only contain letters",
    "Oops! This page does not exist": "Oops! This page does not exist",
    "Open": "Open",
    "Open Hours": "Open Hours",
    "Open in new tab": "Open in new tab",
    "Open menu": "Open menu",
    "Open support ticket": "Open support ticket",
    "Operating time": "Operating time",
    "Opt-Out Keywords": "Opt-Out Keywords",
    "Opt-Out Message": "Opt-Out Message",
    "Opted-out": "Opted-out",
    "Optional Call List Field": "Optional Call List Field",
    "Optional CSV Field": "Optional CSV Field",
    "Options": "Options",
    "or": "or",
    "Organization admin": "Organization admin",
    "Organization owner": "Organization owner",
    "Origin": "Origin",
    "Other": "Other",
    "Other Industry": "Other Industry",
    "otp expired warning": "You have been redirected to the login page due to inactivity on the authentication page. Please log in again to continue.",
    "Our customer service will email you to get the required details and documents": "Our customer service will email you to get the required details and documents",
    "Our team will contact you shortly with next steps on the port-in request": "Our team will contact you shortly with next steps on the port-in request.",
    "Out of Schedule": "Out of Schedule",
    "Out of SLA": "Out of SLA",
    "outbound": "outbound",
    "Outbound": "Outbound",
    "Outbound call": "Outbound call",
    "Outbound calls": "Outbound calls",
    "Outbound Calls": "Outbound Calls",
    "Outbound calls are allowed to countries set to On and blocked for countries set to Off.": "Outbound calls are allowed to countries set to On and blocked for countries set to Off.",
    "Outbound calls start only when this number of agents in the queue are idle": "Outbound calls start only when this number of agents in the queue are idle.",
    "Outbound external": "Outbound external",
    "Outbound internal": "Outbound internal",
    "Outbound SMS": "Outbound SMS",
    "Outbound Trunk": "Outbound Trunk",
    "Outbund calls": "Outbound calls",
    "Outcome": "Outcome",
    "Output Endpoint": "Output Endpoint",
    "Output endpoint is not connected": "Output endpoint is not connected.",
    "Outro audio": "Outro audio",
    "Override Caller ID by country": "Override Caller ID by country",
    "Override endpoint parameters": "Override endpoint parameters",
    "Overrides": "Overrides",
    "overview": "overview",
    "Overwrite account settings": "Overwrite account settings",
    "owner email": "owner email",
    "Owner Email": "Owner Email",
    "owner-tour-step-1": "Welcome to PBX.IM. Let's quickly go through how to add your team members and make your first call!",
    "owner-tour-step-2": "Click on \"Settings\" from the side panel.",
    "owner-tour-step-3": "Click here to open user settings. Alternately you can also search for users through quick search.",
    "owner-tour-step-4": "Click here to add a new user.",
    "owner-tour-step-5": "To add a user, simply enter the required information and click 'Save'. If you prefer to skip this step, click 'Next' to proceed.",
    "owner-tour-step-6": "Awesome! Now you've learned how to invite a team member! Would you now like to learn how to make your first call?",
    "owner-tour-step-7": "If you have any questions, feel free to use our AI chat to get your answers quickly. Thank you for choosing PBX.IM!",
    "Page Not Found": "Page Not Found",
    "PAGER": "Pager",
    "Pages": "Pages",
    "Pagination message": "{current_page} of {last_page}",
    "Paid Until": "Paid Until",
    "Parameters": "Parameters",
    "Part": "Part {index}",
    "Passthrough": "Passthrough",
    "Password": "Password",
    "Password *": "Password *",
    "Password can't be empty": "Password can't be empty.",
    "password change dialog disabled description": "It seems you've used social media to create your account. Unfortunately we don't allow changing passwords for accounts created with social media.",
    "Password confirmation": "Password confirmation",
    "Password confirmation doesn’t match the new password": "Password confirmation doesn’t match the new password.",
    "Password Expiration": "Password Expiration",
    "Password expiration period": "Password expiration period",
    "Password must be at least 6 characters": "Password must be at least 6 characters",
    "Password must be at least 8 characters long": "Password must be at least 8 characters long",
    "Password must be at most 25 characters long": "Password must be at most 25 characters long",
    "Password must be minimum 8 characters and should contain numbers letters and uppercase letters": "Password must be minimum 8 characters and should contain numbers letters and uppercase letters",
    "Password must contain at least 1 digit": "Password must contain at least 1 digit",
    "Password must contain at least 1 lowercase letter": "Password must contain at least 1 lowercase letter",
    "Password must contain at least 1 special symbol": "Password must contain at least 1 special symbol",
    "Password must contain at least 1 uppercase letter": "Password must contain at least 1 uppercase letter",
    "Password must contain at least one special character from the following list: !@#$%^&*_-": "Password must contain at least one special character from the following list: !@#$%^&*_-",
    "Password must include": "Password must include:",
    "Password must include:": "Password must include:",
    "Password must not contain spaces": "Password must not contain spaces",
    "password repeat": "password repeat",
    "Password repeat": "Password repeat",
    "Password Reset Confirmation": "Password Reset Confirmation",
    "Password Reset Successfully": "Password Reset Successfully",
    "Password successfully changed": "Password successfully changed",
    "Password was copied": "Password was copied",
    "Passwords do not match": "Passwords do not match",
    "Paste it below and click": "Paste it below and click",
    "Paste the script in your HTML just before the closing </body> tag": "Paste the script in your HTML just before the closing </body> tag",
    "Paste your domain name": "Paste your domain name",
    "pause": "pause",
    "Pause": "Pause",
    "pause time": "pause time",
    "Pause time": "Pause time",
    "Pause Time": "Pause Time",
    "Pause Type": "Pause Type",
    "Pauses": "Pauses",
    "Pay": "Pay",
    "Payment method": "Payment method",
    "Payment methods": "Payment methods",
    "Payment methods associated with your account": "Payment methods associated with your account.",
    "Payments": "Payments",
    "PBX generates these commands for your specific tenant. Run them in an admin PowerShell session after Connect-MicrosoftTeams.": "PBX generates these commands for your specific tenant. Run them in an admin PowerShell session after Connect-MicrosoftTeams.",
    "PBX Studio": "PBX Studio",
    "Pending": "Pending",
    "PENDING": "PENDING",
    "Pending email": "Pending email",
    "Pending Removal": "Pending Removal",
    "People": "People",
    "People in chat": "People in chat",
    "Per 15 min": "Per 15 min",
    "Per day": "Per day",
    "Per hour": "Per hour",
    "per page": "per page",
    "Per-hub probe status and inbound options heartbeat will appear here once the backend exposes them.": "Per-hub probe status and inbound options heartbeat will appear here once the backend exposes them.",
    "Percentage of Answered Calls": "Percentage of Answered Calls",
    "Period": "Period",
    "Period ends": "Period ends",
    "Periodically sends SIP keep-alive requests to ensure the SIP trunk stays active and the remote side is responding.": "Periodically sends SIP keep-alive requests to ensure the SIP trunk stays active and the remote side is responding.",
    "Permission": "Permission",
    "Personal": "Personal",
    "Personal Inboxes": "Personal Inboxes",
    "PERSONAL_NUMBER": "Personal Number",
    "phone": "phone",
    "Phone": "Phone",
    "Phone (optional)": "Phone (optional)",
    "Phone *": "Phone *",
    "Phone Call Extension": "Phone Call Extension",
    "Phone Check-in": "Phone Check-in",
    "Phone code": "Phone code",
    "Phone Code": "Phone Code",
    "Phone Code *": "Phone Code *",
    "Phone code expired": "Phone code expired.",
    "Phone inactivity": "Phone inactivity",
    "Phone List": "Phone List",
    "Phone Masking": "Phone Masking",
    "Phone No": "Phone No",
    "phone number": "phone number",
    "Phone number": "Phone number",
    "Phone Number": "Phone Number",
    "Phone Number *": "Phone Number *",
    "Phone number ID is required": "Phone number ID is required",
    "Phone number is required": "Phone number is required",
    "Phone number not provided": "Phone number not provided",
    "Phone numbers": "Phone numbers",
    "Phone Numbers": "Phone Numbers",
    "Phone numbers are used only for authentication and security. They're never shared with third-parties or used for marketing.": "Phone numbers are used only for authentication and security. They're never shared with third-parties or used for marketing.",
    "Photo": "Photo",
    "Photos": "Photos",
    "Pie chart": "Pie chart",
    "Pin": "Pin",
    "PIN": "PIN",
    "Pin Retries": "Pin Retries",
    "Placeholder": "Placeholder",
    "plan": "plan",
    "Plan canceled": "Plan canceled",
    "Plan Details": "Plan Details",
    "Plan upgraded": "Plan upgraded",
    "Plan User Limit Reached": "Plan User Limit Reached",
    "Play": "Play",
    "Play Name": "Play Name",
    "Play Ringtones to Caller": "Play Ringtones to Caller",
    "Play ringtones to caller until they hangup": "Play ringtones to caller until they hangup",
    "Play sound on call connection": "Play sound on call connection",
    "Play sound on call disconnection": "Play sound on call disconnection",
    "Play sound when the call is connected": "Play sound when the call is connected",
    "Play sound when the call is disconnected": "Play sound when the call is disconnected",
    "Playback speed": "Playback speed",
    "Please add a payment method!": "Please add a payment method!",
    "Please add at least one node": "Please add at least one node",
    "Please add at least one rule": "Please add at least one rule",
    "Please allow popups to connect WhatsApp Business": "Please allow popups to connect WhatsApp Business",
    "Please apply filters or click search to view results": "Please apply filters or click search to view results",
    "Please check in to WebDialer first to make calls": "Please check in to WebDialer first to make calls",
    "Please choose a new password for your account": "Please choose a new password for your account",
    "Please choose one of the methods below": "Please choose one of the methods below",
    "Please choose the columns you want to export": "Please choose the columns you want to export.",
    "Please choose user or groups": "Please choose user or groups",
    "Please complete the captcha by ticking the checkbox": "Please complete the captcha by ticking the checkbox.",
    "Please describe the issue you’re encountering": "Please describe the issue you’re encountering",
    "Please enable microphone permission in order to initiate a call": "Please enable microphone permission in order to initiate a call.",
    "Please ensure the link from the email is valid": "Please ensure the link from the email is valid",
    "Please enter a low balance threshold amount": "Please enter a low balance threshold amount.",
    "Please enter a valid": "Please enter a valid {what}.",
    "Please enter a valid credit card": "Please enter a valid credit card",
    "Please enter a valid email": "Please enter a valid email.",
    "Please enter a valid email or username": "Please enter a valid email or username.",
    "Please enter a valid hex color (e.g., #FF0000 or #F00)": "Please enter a valid hex color (e.g., #FF0000 or #F00)",
    "Please enter a valid mobile number. Landline or virtual numbers cannot be used for verification.": "Please enter a valid mobile number. Landline or virtual numbers cannot be used for verification.",
    "Please enter a valid URL": "Please enter a valid URL, e.g. 'https://www.example.com'",
    "Please enter a valid username or email": "Please enter a valid username or email",
    "Please enter an username": "Please enter an username",
    "Please enter the code sent to email": "Please enter the code sent to <email>{value}</email>.",
    "Please enter the company name": "Please enter the company name.",
    "Please enter the subdomain": "Please enter the subdomain.",
    "Please enter valid comma-separated email addresses": "Please enter valid comma-separated email addresses",
    "Please enter your company address": "Please enter your company address",
    "Please enter your company city": "Please enter your company city",
    "Please enter your company country": "Please enter your company country",
    "Please enter your company postal code": "Please enter your company postal code",
    "Please enter your country": "Please enter your country",
    "Please enter your first name": "Please enter your first name.",
    "Please enter your last name": "Please enter your last name.",
    "Please enter your name": "Please enter your name",
    "Please fill in this field": "Please fill in this field.",
    "Please fill in time row(s)": "Please fill in time row(s)",
    "Please indicate that you have read and agree to the Privacy Policy": "Please indicate that you have read and agree to the Privacy Policy.",
    "Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy": "Please indicate that you have read and agree to the Terms and Conditions and Privacy Policy",
    "Please insert a number": "Please insert a number",
    "Please let me know what I can help with, I’ll do my best to answer based on the documentation.": "Please let me know what I can help with, I’ll do my best to answer based on the documentation.",
    "Please log in": "Please log in",
    "Please make your browser window wider or open this page on a desktop for the best experience": "Please make your browser window wider or open this page on a desktop for the best experience",
    "Please note that once you submit, no further edits can be made": "Please note that once you submit, no further edits can be made.",
    "Please provide a valid phone number": "Please provide a valid phone number!",
    "Please register your brand and campaign prior to sending SMS messages in the United States": "Please register your brand and campaign prior to sending SMS messages in the United States",
    "Please Search again": "Please Search again",
    "Please search phone numbers": "Please search phone numbers",
    "Please select a script in the current tab": "Please select a script in the current tab",
    "Please select a conversation": "Please select a conversation",
    "Please select a role": "Please select a role",
    "Please select a top up amount": "Please select a top up amount.",
    "Please select a value": "Please select a value",
    "Please select a value first": "Please select a value first",
    "Please select an SSO service": "Please select an SSO service",
    "Please select another plan to replace it": "Please select another plan to replace it",
    "Please select any row first": "Please select any row first",
    "Please select at least 1 user": "Please select at least 1 user",
    "Please select at least one endpoint": "Please select at least one endpoint",
    "Please select at least one user": "Please select at least one user",
    "Please select at least one value": "Please select at least one value",
    "Please select destination type": "Please select destination type",
    "Please select the phone numbers you’ll be using for this campaign": "Please select the phone numbers you’ll be using for this campaign",
    "Please select the role": "Please select the role",
    "Please select the strategy": "Please select the strategy",
    "Please select time group": "Please select time group",
    "Please set up a payment method": "Please set up a payment method!",
    "Please set up the queue to initiate the autodialer": "Please set up the queue to initiate the autodialer.",
    "Please set up Two-Factor Authentication (TFA) to continue using the application": "Please set up Two-Factor Authentication (TFA) to continue using the application",
    "Please set up Two-Factor Authentication (TFA) to continue using the application Scan the QR code below using the Google Authenticator app to enhance security": "Please set up Two-Factor Authentication (TFA) to continue using the application. Scan the QR code below using the Google Authenticator app to enhance security",
    "Please sign in again to resume your session": "Please sign in again to resume your session",
    "Please tell us where your company is located": "Please tell us where your company is located",
    "please top-up to proceed": "please top-up to proceed",
    "Please try again": "Please try again.",
    "Please try again later": "Please try again later",
    "Please try again later.": "Please try again later.",
    "Please try different filters": "Please try different filters",
    "Please upload a valid CSV file": "Please upload a valid CSV file.",
    "Please upload list of phone numbers to call": "Please upload list of phone numbers to call.",
    "Please validate your authentication code": "Please validate your authentication code.",
    "Please verify your phone number": "Please verify your phone number",
    "Please wait a moment and try again": "Please wait a moment and try again",
    "Please wait while we complete your WhatsApp Business connection": "Please wait while we complete your WhatsApp Business connection",
    "PM": "PM",
    "Point a domain (e.g., sbc.acme.com) to our managed endpoint.": "Point a domain (e.g., sbc.acme.com) to our managed endpoint.",
    "Point SBC domain to our managed endpoint record.": "Point SBC domain to our managed endpoint record.",
    "Point your custom domain (e.g., sbc.acme.com) to our SBC.": "Point your custom domain (e.g., sbc.acme.com) to our SBC.",
    "Polling and Voting": "Polling and Voting",
    "Pop back in": "Pop back in",
    "Pop out": "Pop out",
    "Port": "Port",
    "Port-in is limited to N phone numbers": "Port-in is limited to {count} phone numbers.",
    "Port-In Limit Exceeded": "Port-In Limit Exceeded",
    "Port-In Number": "Port-In Number",
    "Port-In Numbers": "Port-In Numbers",
    "Port-in request Submitted": "Port-in request Submitted",
    "Position": "Position",
    "Position On Page": "Position On Page",
    "Post format": "Post format",
    "Post Format": "Post Format",
    "Postal Code": "Postal Code",
    "powered by": "powered by",
    "powered by PBX": "powered by PBX",
    "PowerShell CLI": "PowerShell CLI",
    "PowerShell setup": "PowerShell setup",
    "Pre-Bridge Announcement": "Pre-Bridge Announcement",
    "Pre-Bridge Announcement is required": "Pre-Bridge Announcement is required",
    "Preferred Region": "Preferred Region",
    "Prefix": "Prefix",
    "Prefix/Number": "Prefix/Number",
    "Premium Rate": "Premium Rate",
    "premium support": "premium support",
    "PREMIUM_RATE": "Premium Rate",
    "prepaid": "prepaid",
    "Preset: Adds CODE prefix": "Preset: Adds {country_code} prefix",
    "Presets": "Presets",
    "Prev": "Prev",
    "Preview": "Preview",
    "Previous": "Previous",
    "previous value": "Previous: {value}",
    "Price": "Price",
    "PRICE": "PRICE",
    "Price / Seat": "Price / Seat",
    "Price / user": "Price / user:",
    "Price / User": "Price / User",
    "Price Sheet": "Price Sheet",
    "pricing": "pricing",
    "Priority": "Priority",
    "Privacy Policy": "Privacy Policy",
    "Privacy Policy must include a disclaimer that no mobile opt-in will be shared with third parties for marketing purposes": "Privacy Policy must include a disclaimer that no mobile opt-in will be shared with third parties for marketing purposes",
    "Privacy Policy URL": "Privacy Policy URL",
    "Private": "Private",
    "Private contact": "Private contact",
    "Private Contact": "Private Contact",
    "Privately help company": "Privately help company",
    "Profile Details": "Profile Details",
    "Profile updated": "Profile updated",
    "Progress": "Progress",
    "Progressive / Preview": "Progressive / Preview",
    "Progressive / Preview / Predictive": "Progressive / Preview / Predictive",
    "Prorated": "Prorated",
    "Prorated Cost": "Prorated Cost",
    "Prorated Total": "Prorated Total",
    "Provide one for each message type, include the brand name, and ensure at least one has opt-out language": "Provide one for each message type, include the brand name, and ensure at least one has opt-out language",
    "Provide your answer here": "Provide your answer here",
    "Province": "Province",
    "Provision": "Provision",
    "Public Service Announcement": "Public Service Announcement",
    "Publicly traded company": "Publicly traded company",
    "Publish": "Publish",
    "Published": "Published",
    "Purchase Successful": "Purchase Successful",
    "Put Caller on Hold Forever": "Put Caller on Hold Forever",
    "quantity": "quantity",
    "Quantity": "Quantity",
    "Quantity must be greater than 0": "Quantity must be greater than 0",
    "Quantity must be less than or equal to": "Quantity must be less than or equal to",
    "Quantity must be less than or equal to stock": "Quantity must be less than or equal to stock",
    "Question": "Question {number}",
    "Question label": "Question label",
    "Question Library": "Question Library",
    "queue": "queue",
    "Remove from library": "Remove from library",
    "Queue": "Queue",
    "Queue call": "Queue call",
    "queue calls": "queue calls",
    "Queue Calls": "Queue Calls",
    "Queue greeting": "Queue greeting",
    "Queue Membership": "Queue Membership",
    "Queue Monitoring": "Queue Monitoring",
    "queue timeout": "queue timeout",
    "Queued": "Queued",
    "queues": "queues",
    "Queues": "Queues",
    "Queues Report": "Queues Report",
    "Quick KPI Preview": "Quick Preview",
    "Quote": "Quote",
    "Random": "Random",
    "Range": "Range",
    "range end": "range end",
    "Range End": "Range End",
    "range start": "range start",
    "Range Start": "Range Start",
    "Rate": "Rate",
    "Rate Group": "Rate Group",
    "rate sheet": "rate sheet",
    "Rates are displayed per minute": "Rates are displayed per minute",
    "Rates charged for making and receiving calls on this account": "Rates charged for making and receiving calls on this account.",
    "Raw": "Raw",
    "Read": "Read",
    "Read / Write": "Read / Write",
    "Read only": "Read only",
    "ready": "ready",
    "Ready": "Ready",
    "Ready Idle": "Ready Idle",
    "Ready to submit your A2P 10DLC application?": "Ready to submit your A2P 10DLC application?",
    "Real Estate": "Real Estate",
    "Reapply": "Reapply",
    "Reason": "Reason",
    "Reason for rejection": "Reason for rejection",
    "Reboot": "Reboot",
    "Reboot command sent": "Reboot command sent",
    "Recent Calls": "Recent Calls",
    "Recents": "Recents",
    "Recipient": "Recipient",
    "Recipients": "Recipients",
    "Recipients who replied STOP and were removed from this campaign.": "Recipients who replied STOP and were removed from this campaign.",
    "Record": "Record",
    "Record again": "Record again",
    "Record calls": "Record calls",
    "Record Calls": "Record Calls",
    "Record status": "Record status",
    "Record stereo": "Record stereo",
    "Record voice note": "Record voice note",
    "Recording failed. Please try again.": "Recording failed. Please try again.",
    "Regenerate": "Regenerate",
    "Regenerate hash": "Regenerate hash",
    "Regenerate QR Code": "Regenerate QR Code",
    "Regex rules": "Regex rules",
    "RegExp": "RegExp",
    "Region": "Region",
    "Register brand & campaign": "Register brand & campaign",
    "Register invite description": "Thanks for accepting the invitation. Help us set up your account.",
    "Register PBX's managed SBC as a Teams PSTN gateway": "Register PBX's managed SBC as a Teams PSTN gateway",
    "Register your brand and campaign to enable messaging. See our 10DLC registration guide for more information": "Register your brand and campaign to enable messaging. See our <links>10DLC registration guide</links> for more information",
    "Registered": "Registered",
    "Registration domain": "Registration domain",
    "Registration Domain": "Registration Domain",
    "Registration domain was copied": "Registration domain was copied",
    "Registration Guide": "Registration Guide",
    "Regular expression": "Regular expression",
    "Reject delay": "Reject delay",
    "Reject Delay": "Reject Delay",
    "rejected": "Rejected",
    "Rejected": "Rejected",
    "Reload Studio": "Reload Studio",
    "Remove": "Remove",
    "Remove attachment": "Remove attachment",
    "Remove from question library.": "Remove from question library.",
    "Remove admin pin": "Remove admin pin",
    "Remove user pin": "Remove user pin",
    "removed": "removed",
    "Removed message": "Removed message",
    "Rename": "Rename",
    "Repeat": "Repeat",
    "Repeat Password": "Repeat Password",
    "Replace": "Replace",
    "Replace / Insert": "Replace / Insert",
    "Replace / Insert value is required": "Replace / Insert value is required",
    "Replace / Type": "Replace / Type",
    "Replace & Delete": "Replace & Delete",
    "Replace Plan": "Replace Plan",
    "replace prefix 44 with 0 in a number with length of 8-15 digits": "replace prefix 44 with 0 in a number with length of 8-15 digits",
    "Replay audio": "Replay audio",
    "Replay Audio": "Replay Audio",
    "Replay greeting": "Replay greeting",
    "Reports": "Reports",
    "Require 2FA": "Require 2FA",
    "Require 2FA description": "When enabled, the user will be required to set up 2FA when they create their account.",
    "Require answer confirmation": "Require answer confirmation",
    "Require Authentication": "Require Authentication",
    "Require Two-Factor Authentication": "Require Two-Factor Authentication",
    "Require two-Factor Authentication for all users": "Require two-Factor Authentication for all users",
    "Required": "Required",
    "Required documents": "Required documents",
    "Required information": "Required information",
    "required_field_error": "This field is required.",
    "Reschedule Rules": "Reschedule Rules",
    "Resend": "Resend",
    "Resend Code": "Resend Code{seconds}",
    "Resend Invitation": "Resend Invitation",
    "Resend Invitation ?": "Resend Invitation ?",
    "Resend invitation description": "By resending, the user will receive a new invitation email. Are you sure you want to resend?",
    "Resend seconds": "Resend ({seconds})",
    "Resend Verification Link": "Resend Verification Link",
    "resend_in_minutes": "Resend in {minutes} minutes",
    "resend_in_minutes_and_seconds": "Resend in {minutes} minutes and {seconds} seconds",
    "resend_in_seconds": "Resend in {seconds} seconds",
    "Reserve": "Reserve",
    "Reserved: A manager adds/removes an agent from a queue that is only visible to the manager": "Reserved: A manager adds/removes an agent from a queue that is only visible to the manager",
    "Reset password": "Reset password",
    "Reset Password": "Reset Password",
    "Reset password description": "Please choose a new password for your account.",
    "Reset password sent successfully": "Reset password sent successfully",
    "Reset your password": "Reset your password",
    "Response type": "Response type",
    "Restore Phone Number": "Restore Phone Number",
    "Restrict by Countries and IP Ranges": "Restrict by Countries and IP Ranges",
    "Restrict calls to chosen hours in the phone number's time zone": "Restrict calls to chosen hours in the phone number's time zone",
    "Restrict Login to SSO": "Restrict Login to SSO",
    "Restricted": "Restricted",
    "Result": "Result",
    "Resume": "Resume",
    "Retail": "Retail",
    "Retries cannot exceed Max Attempts": "Retries cannot exceed Max Attempts ({count})",
    "Retry": "Retry",
    "Access Denied": "Access Denied",
    "You don't have permission to view this page.": "You don't have permission to view this page.",
    "Failed to load report data": "Failed to load report data",
    "Retry After": "Retry After",
    "Return to login": "Return to login",
    "Review": "Review",
    "Review cart": "Review cart",
    "Review info": "Review info",
    "Ring": "Ring",
    "Ring & Endpoints": "Ring & Endpoints",
    "Ring All": "Ring All",
    "Ring Endpoint": "Ring Endpoint",
    "Ring Group": "Ring Group",
    "Ring Group name": "Ring Group name",
    "Ring groups": "Ring groups",
    "Ring Groups": "Ring Groups",
    "Ringback Tone": "Ringback Tone",
    "ringing": "ringing",
    "Ringing": "Ringing",
    "Ringtone": "Ringtone",
    "Role": "Role",
    "Roles": "Roles",
    "Roles & Permissions": "Roles & Permissions",
    "Roles available in the application": "Roles available in the application",
    "Round Robin": "Round Robin",
    "Routes": "Routes",
    "Routing": "Routing",
    "row(s) selected": "row(s) selected.",
    "Rows per page": "Rows per page",
    "RTL": "RTL",
    "Rule is not valid": "Rule is not valid",
    "Rules": "Rules",
    "Rules are applied from top to bottom. Drag to change the order": "Rules are applied from top to bottom. Drag to change the order",
    "Rules are applied from top to bottom. Drag to change the order.": "Rules are applied from top to bottom. Drag to change the order.",
    "Run Report": "Run Report",
    "Russian": "Russian",
    "s": "s",
    "same as business address": "same as business address",
    "same as company address": "same as company address",
    "Same as contact info": "Same as contact info",
    "Sample 1": "Sample 1",
    "Sample 2": "Sample 2",
    "Sample 3": "Sample 3",
    "Sample 4": "Sample 4",
    "Sample 5": "Sample 5",
    "Sample Data": "Sample Data",
    "Sample Messages": "Sample Messages",
    "Sample messages must match the registered use case(s)": "Sample messages must match the registered use case(s)",
    "Sat": "Sat",
    "Save": "Save",
    "Save & Continue": "Save & Continue",
    "Save Contact": "Save Contact",
    "Save draft": "Save draft",
    "Save Email": "Save Email",
    "Save failed": "Save failed",
    "Save flow to make a test call.": "Save flow to make a test call.",
    "Save to question library for reuse.": "Save to question library for reuse.",
    "Saved": "Saved",
    "Saved to question library.": "Saved to question library.",
    "Saving...": "Saving...",
    "Say hello to your new PBX number!": "Say hello to your new PBX number!",
    "SBC Domain": "SBC Domain",
    "SBC Domain already used in another integration": "SBC Domain already used in another integration",
    "SBC Domain Suffix": "SBC Domain Suffix",
    "sbc.example.com": "sbc.example.com",
    "sbc.pbx.im": "sbc.pbx.im",
    "SBCs": "SBCs",
    "Scan QR code warning": "Please confirm that you scanned the QR code with your authenticator app. You can always setup 2FA later in your profile.",
    "Scan the QR code and enter the authentication code to save": "Scan the QR code and enter the authentication code to save",
    "Scan the QR code below using the Google Authenticator app to enhance security": "Scan the QR code below using the Google Authenticator app to enhance security.",
    "Schedule": "Schedule",
    "Scheduled": "Scheduled",
    "Script": "Script",
    "search": "search",
    "Search": "Search",
    "Search chats or people": "Search chats or people",
    "Search SMS": "Search SMS",
    "Search templates": "Search templates",
    "Search Templates": "Search Templates",
    "Search phone number": "Search phone number",
    "Search...": "Search...",
    "seats": "seats",
    "Seats": "Seats",
    "Seats Added Successfully": "Seats Added Successfully",
    "Seats Removed Successfully": "Seats Removed Successfully",
    "sec": "sec",
    "Second(s)": "Second(s)",
    "Seconds": "{value} Seconds",
    "seconds label": "seconds",
    "security": "security",
    "Security": "Security",
    "Security Alert": "Security Alert",
    "security email": "security email",
    "Security Email": "Security Email",
    "Security validation failed. Please try again": "Security validation failed. Please try again",
    "See full requirements": "See full requirements",
    "See QR Code": "See QR Code",
    "See Requirements & Disclaimers": "See Requirements & Disclaimers",
    "See transcription": "See transcription",
    "Segments": "Segments",
    "SEHK": "SEHK",
    "Select": "Select",
    "Select \"Yes\" to checkout from Call Center and leave all queues": "Select \"Yes\" to checkout from Call Center and leave all queues",
    "Select a chat to start messaging": "Select a chat to start messaging",
    "Select a plan": "Select a plan",
    "Select a plan to import": "Select a plan to import",
    "Select a question": "Select a question",
    "Select a replacement plan before deleting the current one.": "Select a replacement plan before deleting the current one.",
    "Select a service to save the settings": "Select a service to save the settings.",
    "Select a template": "Select a template",
    "Select All": "Select All",
    "Select call type": "Select call type",
    "Select country": "Select country",
    "Select date": "Select date",
    "Select date to simulate": "Select date to simulate",
    "Select days": "Select days",
    "Select destination": "Select destination",
    "Select Destination Route": "Select Destination Route",
    "Select direction": "Select direction",
    "Select display type": "Select display type",
    "Select existing": "Select existing",
    "Select Greeting": "Select Greeting",
    "Select how often the wallboard should switch between pages when there are more agents than can fit on screen. For example, if set to 10 seconds, the board will automatically switch every 10 seconds.": "Select how often the wallboard should switch between pages when there are more agents than can fit on screen. For example, if set to 10 seconds, the board will automatically switch every 10 seconds.",
    "Select inbox": "Select inbox",
    "Select industry": "Select industry",
    "Select interval": "Select interval",
    "Select join option": "Select join option",
    "Select language": "Select language",
    "Select Number": "Select Number",
    "Select or Create Labels": "Select or Create Labels",
    "Select rate sheet": "Select rate sheet",
    "Select Role": "Select Role",
    "Select Site": "Select Site",
    "Select smt": "Select smt",
    "Select state": "Select state",
    "Select Statuses": "Select Statuses",
    "Select Strategy": "Select Strategy",
    "Select time format": "Select time format",
    "Select time group": "Select time group",
    "Select time interval": "Select time interval",
    "Select transport": "Select transport",
    "Select type": "Select type",
    "selected": "selected",
    "Selected": "Selected",
    "Send": "Send",
    "Send a message to start the conversation.": "Send a message to start the conversation.",
    "Send an SMS starting at": "Send an SMS starting at",
    "Send Code": "Send Code",
    "Send code in email": "Send code in email",
    "Send Code Via SMS": "Send Code Via SMS",
    "Send Code Via WhatsApp": "Send Code Via WhatsApp",
    "Send From:": "Send From:",
    "Send Invite": "Send Invite",
    "Send message": "Send message",
    "Send recovery email": "Send recovery email",
    "Send Reset Password": "Send Reset Password",
    "Send SMS": "Send SMS",
    "Send Template": "Send Template",
    "Send test email": "Send test email",
    "Send Test Email": "Send Test Email",
    "Send To": "Send To",
    "Send to queue": "Send to queue",
    "Send, receive messages and keep all conversations in one place.": "Send, receive messages and keep all conversations in one place.",
    "Sender": "Sender",
    "Sender ID": "Sender ID",
    "Sending Rate": "Sending Rate",
    "Sending rate format": "{perHour}/hour → {perDay}/day",
    "Sending SMS in the US & Canada": "Sending SMS in the US & Canada",
    "Sending…": "Sending…",
    "Sent": "Sent",
    "Sent at": "Sent at",
    "Sent Count": "Sent Count",
    "Sequentially By Agent Order": "Sequentially By Agent Order",
    "Sequentially By Next Agent Order": "Sequentially By Next Agent Order",
    "Server Error": "Server Error",
    "Service Level Agreement (SLA)": "Service Level Agreement (SLA)",
    "Service level for a selected strategy": "Service level for a selected strategy",
    "Session": "Session",
    "Session time": "Session time",
    "Set": "Set",
    "Set by agent": "Set by agent",
    "Set Inbox": "Set Inbox",
    "Set mapping": "Set mapping",
    "Set Mapping": "Set Mapping",
    "Set New Password": "Set New Password",
    "Set password expiration": "Set password expiration",
    "Set the group members who will receive calls when they ring for another user in the group": "Set the group members who will receive calls when they ring for another user in the group.",
    "Set Up 2FA": "Set Up 2FA",
    "Set up later": "Set up later",
    "Set Up Two-Factor Authentication": "Set Up Two-Factor Authentication",
    "Set up your Two-Factor Authentication": "Set up your Two-Factor Authentication",
    "Set your password": "Set your password",
    "Settings": "Settings",
    "Settings → Domains": "Settings → Domains",
    "Settings applied to the whole account": "Settings applied to the whole account",
    "Setup": "Setup",
    "Setup cost": "Setup cost",
    "Setup Your new password": "Setup Your new password",
    "Setup Your New Password": "Setup Your New Password",
    "Setup your security questions": "Setup your security questions",
    "Share": "Share",
    "SHARED_COST": "Shared Cost",
    "should be a minimum length of": "{what} should be a minimum length of {length}.",
    "Should be a number": "{field} should be a number",
    "Should be a number between": "Should be a number between {min} and {max}",
    "Should be a number with max digits": "Should be a number with max {digits} digits",
    "Show Deactivated Users": "Show Deactivated Users",
    "Show Draft Users": "Show Draft Users",
    "Show Estimated Wait Time": "Show Estimated Wait Time",
    "Show filters": "Show filters",
    "Show Inputs From Other Flows": "Show Inputs From Other Flows",
    "Show Invited Users": "Show Invited Users",
    "Show Keypad": "Show Keypad",
    "Show password": "Show password",
    "Show Webphone On Tab Change": "Show Webphone On Tab Change",
    "Show Webphone Only During Calls": "Show Webphone Only During Calls",
    "Show Welcome Message After": "Show Welcome Message After",
    "Shown once a route has Call enabled.": "Shown once a route has Call enabled.",
    "Sign out": "Sign out",
    "Sign Up": "Sign Up",
    "Sign Up and Start Calling": "Sign Up and Start Calling",
    "Sign Up for PBX.IM – Cloud PBX Phone System Solutions": "Sign Up for PBX.IM – Cloud PBX Phone System Solutions",
    "Sign Up Verify email subtitle": "Keep your account secure and verify your email. Please enter the code sent to {email}",
    "Sign up with Google": "Sign up with Google",
    "Sign up with Microsoft": "Sign up with Microsoft",
    "Simulate password expiration": "Simulate password expiration",
    "Simultaneous": "Simultaneous",
    "Simultaneous calls": "Simultaneous calls",
    "Simultaneous Calls count": "{count} Simultaneous Calls",
    "Single File": "Single File",
    "Single Sign-On (SSO)": "Single Sign-On (SSO)",
    "SIP Desk Phones": "SIP Desk Phones",
    "SIP Domain": "SIP Domain",
    "SIP Domain hint": "Put this in your phone's Domain or Registrar field.",
    "SIP Server": "SIP Server",
    "SIP Server hint": "Put this in your phone's Outbound Proxy or Server field.",
    "SIP IP": "SIP IP",
    "SIP Signaling Port": "SIP Signaling Port",
    "Sip term status": "Sip term status",
    "SIP Trunk": "SIP Trunk",
    "SIP Trunks": "SIP Trunks",
    "Sites": "Sites",
    "Skip": "Skip",
    "Skip empty tokens tooltip": "Enabled: if the token values are empty we skip from sending this message.\n\nDisabled: We send the message with an empty value.",
    "Skip greeting": "Skip greeting",
    "Skip greeting tooltip": "Skip the greeting message and send callers straight to the recording tone. Turn on if you don't want callers to hear a greeting before leaving their message.",
    "Skip if variable is empty": "Skip if variable is empty",
    "Skip levels with no available agents": "Skip levels with no available agents",
    "Skip Sending Messages With Any Empty Tokens": "Skip Sending Messages With Any Empty Tokens",
    "Skip Tiers with no Available Agents": "Skip Tiers with no Available Agents",
    "Skip Voicemail Operation Instructions": "Skip Voicemail Operation Instructions",
    "Skip Voicemail Operation Instructions tooltip": "Skip the automated system prompts (e.g. 'record after the tone, press 1 when finished'). Turn on for a cleaner experience where callers hear only your greeting and the beep.",
    "sla": "sla",
    "SLA": "SLA",
    "SLA Calls / (Total Calls - Abandoned in SLA)": "SLA Calls / (Total Calls - Abandoned in SLA)",
    "SLA Calls / Total Calls": "SLA Calls / Total Calls",
    "SLA Configuration": "SLA Configuration",
    "SLA formula": "SLA formula",
    "SLA Strategy": "SLA Strategy",
    "SLA Strategy Explanation": "SLA Strategy Explanation",
    "SLA target": "SLA target",
    "SMS": "SMS",
    "SMS & MMS": "SMS & MMS",
    "SMS caller ID": "SMS caller ID",
    "SMS Caller ID": "SMS Caller ID",
    "SMS Cost": "SMS Cost",
    "SMS default sender": "SMS default sender",
    "SMS enabled": "SMS enabled",
    "sms failed error": "Failed to send SMS. Please try again.",
    "SMS Forwarding": "SMS Forwarding",
    "SMS FORWARDING -> ": "SMS FORWARDING → {forwardTo}",
    "SMS routing": "SMS routing",
    "SMS sender names": "SMS sender names",
    "SMS Text": "SMS Text",
    "Snooze": "Snooze",
    "Some files were skipped because they": "Some files were skipped because they",
    "Some nodes have validation errors": "Some nodes have validation errors",
    "Some SBC hubs are unreachable; calls still route but redundancy is degraded": "Some SBC hubs are unreachable; calls still route but redundancy is degraded",
    "Some unsupported files were skipped": "Some unsupported files were skipped",
    "Something went wrong": "Something went wrong.",
    "Something went wrong while rendering this call flow. Your unsaved changes may be lost.": "Something went wrong while rendering this call flow. Your unsaved changes may be lost.",
    "Something went wrong, please try again": "Something went wrong, please try again",
    "Sorry, the page you're looking for cannot be found": "Sorry, the page you're looking for cannot be found",
    "Sorry, you have exceeded the number of tries. Please try again in {minutes} minute.": "Sorry, you have exceeded the number of tries. Please try again in {minutes} minute.",
    "Sorry, you have exceeded the number of tries. Please try again in {minutes} minutes.": "Sorry, you have exceeded the number of tries. Please try again in {minutes} minutes.",
    "Sorry, you have exceeded the number of tries. Please try again in {seconds} second.": "Sorry, you have exceeded the number of tries. Please try again in {seconds} second.",
    "Sorry, you have exceeded the number of tries. Please try again in {seconds} seconds.": "Sorry, you have exceeded the number of tries. Please try again in {seconds} seconds.",
    "Sort": "Sort",
    "Sound": "Sound",
    "Sources:": "Sources:",
    "Spanish": "Spanish",
    "Special characters (!@#$%^&*_-)": "Special characters (!@#$%^&*_-)",
    "Special permissions": "Special permissions",
    "Specific exit destinations": "Specific exit destinations",
    "Specifies how long the dialer should try calling the destination before timing out": "Specifies how long the dialer should try calling the destination before timing out.",
    "Specify a subject for the SMS forwarding email.": "Specify a subject for the SMS forwarding email.",
    "Specify an email address that will receive forwarded SMS messages.": "Specify an email address that will receive forwarded SMS messages.",
    "Speech": "Speech",
    "Split": "Split",
    "Spy message": "Spy message",
    "SSE": "SSE",
    "sso authorization failed": "Failed to authorize SSO provider",
    "sso authorization required": "Please authorize a social provider to enable Forced Single Sign-On (SSO).",
    "sso authorization title": "Link social account",
    "sso emails dont match": "The provided account's email address does not match your email address!",
    "sso account already linked": "This Google or Microsoft account is already linked to another user. Choose a different account.",
    "sso provider authorized": "The social account has been authorized successfully!",
    "sso providers": "SSO Providers",
    "sso_password_change": "This account was created using SSO credentials. To disable SSO, you'll need to set a password. Your email will remain unchanged.",
    "Standard": "Standard",
    "Standard Business Hours": "Standard Business Hours",
    "Standard Rate": "Standard Rate",
    "Start a call to test the flow.": "Start a call to test the flow.",
    "Start Chat": "Start Chat",
    "Start conversation": "Start conversation",
    "Start Date": "Start Date",
    "Start registration": "Start registration",
    "Start time": "Start time",
    "Start topping up when the balance falls below this threshold": "Start topping up when the balance falls below this threshold",
    "start_ip_must_be_less_than_end_ip": "Start IP must be less than End IP.",
    "Start-up": "Start-up",
    "Starting": "Starting",
    "startup": "start-up",
    "state": "state",
    "State": "State",
    "state / province": "state / province",
    "State / Province": "State / Province",
    "State/province": "State/province",
    "Stats": "Stats",
    "Stats Reset": "Stats Reset",
    "Status": "Status",
    "STATUS": "STATUS",
    "Status name": "Status name",
    "Step-by-step instructions": "Step-by-step instructions",
    "steps count": "{current_step} of {total_steps}",
    "Stereo playback": "Stereo playback",
    "Sticker": "Sticker",
    "STO": "STO",
    "Stock": "Stock",
    "Stock exchange": "Stock exchange",
    "Stock symbol": "Stock symbol",
    "Stop": "Stop",
    "Stop Rule": "Stop Rule",
    "STOP, CANCEL, UNSUBSCRIBE": "STOP, CANCEL, UNSUBSCRIBE",
    "Stopped": "Stopped",
    "Stopping": "Stopping",
    "Storage": "Storage",
    "Strategy": "Strategy",
    "Street Address": "Street Address",
    "Street Address *": "Street Address *",
    "Stripe V2 top-up failed": "Stripe V2 top-up failed",
    "Stripe V2 top-up successful": "Stripe V2 top-up successful",
    "Stripe verification": "We use Stripe Identity to verify your ID. Please click the button below to start the process.",
    "Studio crashed": "Studio crashed",
    "subdomain": "subdomain",
    "Subdomain can only contain lower case letters and numbers": "Subdomain can only contain lower case letters and numbers",
    "Subdomain must be at least 3 characters": "Subdomain must be at least 3 characters",
    "Subject": "Subject",
    "Submit": "Submit",
    "Submit Port-In Request": "Submit Port-In Request",
    "Subscriber Help Keywords": "Subscriber Help Keywords",
    "Subscriber Help Message": "Subscriber Help Message",
    "Subscriber Opt-In Keywords": "Subscriber Opt-In Keywords",
    "Subscriber Opt-In Message": "Subscriber Opt-In Message",
    "Subscriber Opt-In Message must be between 20 and 320 characters long": "Subscriber Opt-In Message must be between 20 and 320 characters long",
    "Subscriber Opt-Out Keywords": "Subscriber Opt-Out Keywords",
    "Subscriber Opt-Out Message": "Subscriber Opt-Out Message",
    "Subscription Plan": "Subscription Plan",
    "Subscription upgraded to": "Subscription upgraded to {name}",
    "Subscriptions": "Subscriptions",
    "Subtitle": "Subtitle",
    "Success": "Success",
    "Suffix": "Suffix",
    "Suite": "Suite",
    "Summary": "Summary",
    "Sun": "Sun",
    "Supervisor": "Supervisor",
    "supervisor-tour-step-1": "Welcome to PBX.IM! Let’s quickly walk through the dashboard and reports.",
    "supervisor-tour-step-2": "Once you have teams, you can select one or multiple teams.",
    "supervisor-tour-step-3": "Here you have real-time information about the selected teams.",
    "supervisor-tour-step-4": "Similar to real-time information, we can also view past data. To access the reports, click here.",
    "supervisor-tour-step-5": "As you can see, there are different types of reports. For this tour, click on 'Calls Report'",
    "supervisor-tour-step-6": "Here, you can find more detailed information about the calls, such as total talk time, average call duration, and more.",
    "supervisor-tour-step-7": "To explore more details about a particular call, simply check the Call Logs by clicking here.",
    "supervisor-tour-step-8": "Here, you'll be able to see calls made during the selected timeframe. If there are calls, you can click on them to view more detailed information.{br} If you'd like to learn more about other features, please refer to the {documentation}.",
    "Support availability": "Support availability",
    "Support channels": "Support channels",
    "Support channels available to each plan": "Support channels available to each plan.",
    "support email": "support email",
    "Support Email": "Support Email",
    "Supported formats": "Supported formats",
    "Supported: pdf, docx, jpg, png, mp4, mov": "Supported: pdf, docx, jpg, png, mp4, mov",
    "Supports incoming SMS messages": "Supports incoming SMS messages",
    "Supports outgoing SMS messages": "Supports outgoing SMS messages",
    "Suppressed": "Suppressed",
    "Switch Interval": "Switch Interval",
    "Switch to Old UI": "Switch to Old UI",
    "Switching to": "Switching to",
    "SWX": "SWX",
    "Sync Numbers": "Sync Numbers",
    "Sync Templates": "Sync Templates",
    "Synced {count} template(s) from Meta": "Synced {count} template(s) from Meta",
    "System": "System",
    "System wait time for caller input, before prompting for next action": "System wait time for caller input, before prompting for next action.",
    "SZSE": "SZSE",
    "tab click the": "tab click the",
    "Tags": "Tags",
    "Take": "Take",
    "Talk": "Talk",
    "Talk time": "Talk time",
    "talk time tooltip kpi": "The total talk time for the selected period and type.",
    "Target": "Target",
    "Target Destination": "Target Destination",
    "Target Duration (seconds)": "Target Duration (seconds)",
    "Target Percentage (%)": "Target Percentage (%)",
    "Tax Number / ID / EN": "Tax Number / ID / EN",
    "Team": "Team",
    "TEAM": "TEAM",
    "Team Chat": "Team Chat",
    "Team Inboxes": "Team Inboxes",
    "TEAM INBOXES": "TEAM INBOXES",
    "Team Leader": "Team Leader",
    "Team Size": "Team Size",
    "Teams": "Teams",
    "Technical Support Specialist": "Technical Support Specialist",
    "Technologies used in call centers to manage incoming calls and connect them with the most appropriate agent": "Technologies used in call centers to manage incoming calls and connect them with the most appropriate agent.",
    "Technology": "Technology",
    "Tell us a bit about your business": "Tell us a bit about your business.",
    "Tell us a bit about your company": "Tell us a bit about your company.",
    "Tell us a bit more about your company": "Tell us a bit more about your company",
    "Template": "Template",
    "Template deleted successfully": "Template deleted successfully",
    "Template updated successfully": "Template updated successfully",
    "Templates": "Templates",
    "Temporarily Unavailable": "Temporarily Unavailable",
    "Terminate": "Terminate",
    "Terminate call": "Terminate call",
    "Terminate Call": "Terminate Call",
    "Terminate the call for all participants?": "Terminate the call for all participants?",
    "Terms & Conditions URL": "Terms & Conditions URL",
    "Terms and Conditions must have an SMS disclosure that includes the types of messages consumers can expect to receive, texting cadence, message and data rate notices, privacy policy links, HELP information, and opt-out instructions": "Terms and Conditions must have an SMS disclosure that includes the types of messages consumers can expect to receive, texting cadence, message and data rate notices, privacy policy links, HELP information, and opt-out instructions",
    "Test call active in another flow. End it to start a new one.": "Test call active in another flow. End it to start a new one.",
    "Test call failed": "Test call failed",
    "Test call timed out": "Test call timed out",
    "Test Email Sent Successfully": "Test Email Sent Successfully",
    "Test Flow": "Test Flow",
    "Test Input": "Test Input",
    "Test Widget": "Test Widget",
    "Testing area": "Testing area",
    "Text color is used for the text and logo.": "Text color is used for the text and logo.",
    "Text is required for this type of media file": "Text is required for this type of media file",
    "Text to speech": "Text to speech",
    "Text to Speech": "Text to Speech",
    "TFA Code Incorrect": "The 2FA Code entered is incorrect. Please check and re-enter one-time password.",
    "TFA is required by your organization": "TFA is required by your organization",
    "Thank you": "Thank you",
    "Thanks for you order, your phone numbers have been added to the list": "Thanks for you order, your phone numbers have been added to the list.",
    "The \"Increment” defines\" the time units, also in seconds, used for billing after the initial segment": "The \"Increment” defines\" the time units, also in seconds, used for billing after the initial segment",
    "The \"Initial Increment\" refers to the minimum time billed for the first segment of an inbound call, usually in seconds": "The \"Initial Increment\" refers to the minimum time billed for the first segment of an inbound call, usually in seconds.",
    "The 24-hour WhatsApp conversation window has expired. You can only send a pre-approved template message.": "The 24-hour WhatsApp conversation window has expired. You can only send a pre-approved template message.",
    "The account or company name": "The account or company name",
    "The account password has been updated": "The account password has been updated.",
    "The amount of time allotted for an agent to answer a call, before it's transferred to another agent": "The amount of time allotted for an agent to answer a call, before it's transferred to another agent.",
    "The card ending in <b>{last4}</b> will be charged for the prorated amount": "The card ending in <b>{last4}</b> will be charged for the prorated amount.",
    "The card ending in will be charged for this amount": "The card ending in {last4} will be charged for this amount.",
    "The code is invalid, please try again": "The code is invalid, please try again.",
    "The content of the SMS": "The content of the SMS",
    "The cost per minute of inbound calls on this phone number": "The cost per minute of inbound calls on this phone number",
    "The countries below are allowed for outbound calls.": "The countries below are allowed for outbound calls.",
    "The date and time when the SMS was received": "The date and time when the SMS was received",
    "The Date From must be before the Date To": "The Date From must be before the Date To.",
    "The destination DID number that received the SMS": "The destination DID number that received the SMS",
    "The destination the call will be directed to, if any thresholds or limits are exceeded": "The destination the call will be directed to, if any thresholds or limits are exceeded",
    "The email 2FA has been successfully updated": "The email 2FA has been successfully updated",
    "The email has already been taken": "The email has already been taken.",
    "The end date must be after the start date": "The end date must be after the start date.",
    "The expected level of service for a queue defined by the strategy and target interval": "The expected level of service for a queue defined by the strategy and target interval",
    "The file size must not exceed 4 MB": "The file size must not exceed 4 MB",
    "The following phone numbers will be activated after the required information has been reviewed and approved. Please send the required documentation to our support at ": "The following phone numbers will be activated after the required information has been reviewed and approved. Please send the required documentation to our support at ",
    "The FQDN your PBX and Teams will use.": "The FQDN your PBX and Teams will use.",
    "The ID of the account that received the SMS": "The ID of the account that received the SMS",
    "The inbox is currently empty.": "The inbox is currently empty.",
    "The input must be a number within the range of {min} to {max}, or the characters \"#\" or \"*\"": "The input must be a number within the range of {min} to {max}, or the characters \"#\" or \"*\"",
    "The interval when support channels are available": "The interval when support channels are available.",
    "The invoice history for your subscription plan, top-ups, and phone numbers": "The invoice history for your subscription plan, top-ups, and phone numbers",
    "The keywords which subscriber can send to get help": "The keywords which subscriber can send to get help",
    "The keywords which subscriber can send to Opt-In": "The keywords which subscriber can send to Opt-In",
    "The keywords which subscriber can send to Opt-Out": "The keywords which subscriber can send to Opt-Out",
    "The link is valid for 24 hours": "The link is valid for 24 hours",
    "The max number of times without any selection before the call is directed to the exit destination": "The max number of times without any selection before the call is directed to the exit destination",
    "The maximum amount of time a caller waits when no agents are available before being directed to the exit destination": "The maximum amount of time a caller waits when no agents are available before being directed to the exit destination.",
    "The maximum length of this field": "The maximum length of this field is {number}",
    "The maximum length of this field is 6": "The maximum length of this field is 6",
    "The maximum number of times a caller can make an invalid input before being directed to the exit destination": "The maximum number of times a caller can make an invalid input before being directed to the exit destination.",
    "The maximum value is": "The maximum value is {number}.",
    "The message a subscriber will get once they have opted in": "The message a subscriber will get once they have opted in",
    "The message subscriber will get once they have opted out": "The message subscriber will get once they have opted out",
    "The message subscriber will get when they have requested help": "The message subscriber will get when they have requested help",
    "The minimum billable call duration (in seconds) and the increment used for billing": "The minimum billable call duration (in seconds) and the increment used for billing",
    "The minimum commitment duration for which the phone number must be purchased": "The minimum commitment duration for which the phone number must be purchased",
    "The minimum length for this field should be": "The minimum length for this field should be {value}",
    "The minimum value is": "The minimum value is {number}.",
    "The music a caller hears when they are waiting to be connected to a specific destination": "The music a caller hears when they are waiting to be connected to a specific destination",
    "The name of the SMS sender (if available)": "The name of the SMS sender (if available)",
    "The new settings have been successfully saved.": "The new settings have been successfully saved.",
    "The number below must be dialed within two minutes to complete the check-in process": "The number below must be dialed within two minutes to complete the check-in process",
    "The Number could not be Cancelled": "The Number could not be Cancelled",
    "The Number could not be Restored": "The Number could not be Restored",
    "The Number has been Successfully Cancelled": "The Number has been Successfully Cancelled",
    "The Number has been Successfully Restored": "The Number has been Successfully Restored",
    "The number of attempts for status has to be less than or equal to Max Attempts": "The number of attempts for [{status}] status has to be less than or equal to Max Attempts",
    "The number of attempts for status must be positive": "The number of attempts for [{status}] must be positive",
    "The number of concurrent calls can't exceed the number of Microsoft Teams Channels": "The number of concurrent calls can't exceed the number of Microsoft Teams Channels.",
    "The number of seats can’t be lower than the active and invited users in the account.": "The number of seats can’t be lower than the active and invited users in the account.",
    "The number of seats can’t exceed the plan maximum.": "The number of seats can’t exceed the plan maximum.",
    "The number of times a caller can press a wrong option before being directed to the exit destination": "The number of times a caller can press a wrong option before being directed to the exit destination",
    "The numbers will be activated after review and approval": "The numbers will be activated after review and approval",
    "The page you are looking for does not exist or has been moved.": "The page you are looking for does not exist or has been moved.",
    "The password contains unsupported symbols": "The password contains unsupported symbols",
    "The password has been reset successfully": "The password has been reset successfully",
    "The password must meet all requirements": "The password must meet all requirements.",
    "The pause between digit inputs should be less than this value": "The pause between digit inputs should be less than this value",
    "The phone has already been taken": "The phone has already been taken.",
    "The phone number from which the SMS was sent": "The phone number from which the SMS was sent",
    "The phone number is not valid": "The phone number is not valid.",
    "The recording may be silent or unclear for transcription": "The recording may be silent or unclear for transcription.",
    "The reset will happen next time the member logs in": "The reset will happen next time the member logs in",
    "The selected amount will not be enough to cover the low balance threshold": "The selected amount will not be enough to cover the low balance threshold.",
    "The session is now closed": "The session is now closed",
    "The shortest duration of a call that will be billed, measured in seconds, for which billing is charged when a phone number is used for calls": "The shortest duration of a call that will be billed, measured in seconds, for which billing is charged when a phone number is used for calls",
    "The sound an agent hears while waiting for the person they are calling to answer": "The sound an agent hears while waiting for the person they are calling to answer.",
    "The system will automatically dial numbers from uploaded list and connect leads with agents": "The system will automatically dial numbers from uploaded list and connect leads with agents.",
    "The time an agent has to answer a call before it's transferred to another agent": "The time an agent has to answer a call before it's transferred to another agent",
    "The time an agent has to answer a call before it’s transferred to another agent": "The time an agent has to answer a call before it’s transferred to another agent.",
    "The time of day when the wallboard stats reset.": "The time of day when the wallboard stats reset.",
    "The Time To must be later than the Time From": "The Time To must be later than the Time From.",
    "The type of destination the call will be directed to": "The type of destination the call will be directed to",
    "The uploaded file is not an audio file": "The uploaded file is not an audio file.",
    "The uploaded file is not an image": "The selected file is not an image. Please upload a valid image file.",
    "The user has been created": "The user has been created",
    "The user has been notified via email at": "The user has been notified via email at {email}.",
    "This audio file could not be read": "This audio file could not be read. Please try a different file.",
    "This file has already been uploaded": "This file has already been uploaded.",
    "The username and password are automatically generated Use them to connect your phone": "The username and password are automatically generated. Use them to connect your phone.",
    "The uuid was copied:": "The uuid was copied:",
    "Theme": "Theme",
    "Then click": "Then click",
    "There can be only one active session": "There can be only one active session",
    "There is already an account with this email address": "There is already an account with this email address",
    "There was a problem retrieving the numbers": "There was a problem retrieving the numbers",
    "There was an error processing the file": "There was an error processing the file.",
    "There's no transcription available for this call.": "There's no transcription available for this call.",
    "This amount represents the fee incurred for receiving calls on this number, measured in cost per minute": "This amount represents the fee incurred for receiving calls on this number, measured in cost per minute",
    "This balance is available for making phone calls": "This balance is available for making phone calls",
    "This call's transcription is now prioritized": "This call's transcription is now prioritized",
    "This call’s transcription is now prioritized": "This call’s transcription is now prioritized",
    "This chat is currently active with {name}.": "This chat is currently active with {name}.",
    "This context holds the SIP registration (master)": "This context holds the SIP registration (master)",
    "This conversation is blocked because this number cannot send SMS.": "This conversation is blocked because this number cannot send SMS.",
    "This day": "This day",
    "This domain is not registered.": "This domain is not registered.",
    "This field is used to give a clear and detailed description of what the campaign will be used for. Ensure description aligns with the selected message types (i.e., registered as 2FA campaign but campaign description references customer care messages would result in a rejection)": "This field is used to give a clear and detailed description of what the campaign will be used for. Ensure description aligns with the selected message types (i.e., registered as 2FA campaign but campaign description references customer care messages would result in a rejection)",
    "This file format is not supported": "This file format is not supported",
    "This file is too large and is not supported.": "This file is too large and is not supported.",
    "This file was blocked for security reasons.": "This file was blocked for security reasons.",
    "This inbox doesn’t have a phone number linked yet. Please contact your administrator or link a number to enable messaging.": "This inbox doesn’t have a phone number linked yet. Please contact your administrator or link a number to enable messaging.",
    "This is the password used to log into this account": "This is the password used to log into this account.",
    "This is the URL assigned to your account": "This is the URL assigned to your account",
    "This member will need to change their password next time he logs into the app": "This member will need to change their password next time he logs into the app",
    "This message shows up in a bubble above the widget icon, after the delay set here.": "This message shows up in a bubble above the widget icon, after the delay set here.",
    "This month": "This month",
    "This must be disabled if you are migrating an existing profile": "This must be disabled if you are migrating an existing profile.",
    "This option is not available yet": "This option is not available yet",
    "This extension is already in use": "This extension is already in use",
    "This name is already in use": "This name is already in use",
    "This number will be removed on <b>{date}</b>": "This number will be removed on <b>{date}</b>",
    "This number will be removed on <b>{date}</b> if cancellation is not aborted": "This number will be removed on <b>{date}</b> if cancellation is not aborted",
    "This period represents the shortest time frame (usually in months) that you are required to pay for and keep the number active": "This period represents the shortest time frame (usually in months) that you are required to pay for and keep the number active",
    "This queue not available for this Agent": "This queue not available for this Agent",
    "This queue is locked by an admin": "This queue is locked by an admin",
    "This represents the number of users available in the current plan minus total number of account users (in any status)": "This represents the number of users available in the current plan minus total number of account users (in any status)",
    "This subdomain suffix is already taken": "This subdomain suffix is already taken",
    "This text is appended to every message.": "This text is appended to every message.",
    "This text is appended to every message. Required by carriers.": "This text is appended to every message. Required by carriers.",
    "This user has made several incorrect password attempts": "This user has made several incorrect password attempts.",
    "This value is already taken": "This value is already taken",
    "This week": "This week",
    "This will allow the user to set a new password": "This will allow the user to set a new password",
    "This will also remove your current auto top-up": "This will also remove your current auto top-up",
    "This will send verification code to saved mobile": "This will send verification code to saved mobile",
    "This will send verification code to the saved e-mail": "This will send verification code to the saved e-mail",
    "Threshold": "Threshold",
    "Thresholds": "Thresholds",
    "Thu": "Thu",
    "ticket created": "Great! I’ve created your support ticket (#{id}). Our team will get back to you as soon as we have an update. Please keep an eye on your inbox",
    "Tier": "Tier",
    "Tier rules": "Tier rules",
    "Tier Rules Apply": "Tier Rules Apply",
    "Tier wait time": "Tier wait time",
    "Time": "Time",
    "Time allocation": "Time allocation",
    "Time base score": "Time base score",
    "Time condition": "Business Hours",
    "Time Condition": "Business Hours",
    "Time condition name": "Business Hours name",
    "Time conditions": "Business Hours",
    "Time Conditions": "Business Hours",
    "Time Format": "Time Format",
    "Time from": "Time from",
    "Time group": "Time group",
    "Time Group": "Time Group",
    "Time groups": "Time groups",
    "Time Groups": "Time Groups",
    "Time Interval": "Time Interval",
    "Time interval in which no option has been pressed": "Time interval in which no option has been pressed",
    "Time left": "Time left",
    "Time limit": "Time limit",
    "Time Settings": "Time Settings",
    "Time spent in calls": "Time spent in calls",
    "time stats": "time stats",
    "Time to": "Time to",
    "time zone": "time zone",
    "Time zone": "Time zone",
    "Timegroup": "Timegroup",
    "Timeout": "Timeout",
    "timeout calls": "timeout calls",
    "timeout calls tooltip kpi": "The percentage of calls that timed out before reaching an agent. High values could indicate issues with routing or insufficient agent availability.",
    "Timeout destination": "Timeout destination",
    "Timeout Destination": "Timeout Destination",
    "Timeouts": "Timeouts",
    "Times": "Times",
    "Timezone": "Timezone",
    "Title": "Title",
    "TLS certificate regenerated": "TLS certificate regenerated",
    "to": "to",
    "To": "To",
    "To be implemented": "To be implemented",
    "To check-in to the dialer select the device type and follow the prompts.": "To check-in to the dialer select the device type and follow the prompts.",
    "To continue, remove or complete those drafts, or purchase additional numbers": "To continue, remove or complete those drafts, or purchase additional numbers: <links>Call Routing > Phone Numbers</links>",
    "to manage your WhatsApp messaging": "to manage your WhatsApp messaging.",
    "To No": "To No",
    "To opt out of future messages, reply STOP.": "To opt out of future messages, reply STOP.",
    "to receive SMS or calls for verification. It should not be linked to any existing WhatsApp profile": "to receive SMS or calls for verification. It should not be linked to any existing WhatsApp profile.",
    "To send SMS messages to the US and Canada with this number, you must complete a one‑time A2P 10DLC registration": "To send SMS messages to the US and Canada with this number, you must complete a one‑time A2P 10DLC registration",
    "To send SMS to the US and Canada with this number, you need to complete a one-time A2P 10DLC registration after purchase": "To send SMS to the US and Canada with this number, you need to complete a one-time A2P 10DLC registration after purchase",
    "To start monitoring, your current call will be ended.": "To start monitoring, your current call will be ended.",
    "To:": "To:",
    "Today": "Today",
    "Toggle": "Toggle",
    "TOKENS": "TOKENS",
    "TOLL_FREE": "Toll Free",
    "Too many attempts": "Too many attempts",
    "Too many attempts. Please try again in {minutes} minutes": "Too many attempts. Please try again in {minutes} minutes",
    "top background": "top background",
    "Top Down": "Top Down",
    "Top up amount": "Top up amount",
    "top up info": "Automatically top up company balance with <amount>{upTo}</amount> when it falls below <amount>{below}</amount>.",
    "Top-up": "Top-up",
    "Top-up now": "Top-up now",
    "Top-up successful": "Top-up successful",
    "Total": "Total",
    "Total agents": "Total agents",
    "Total calls": "Total calls",
    "Total contacts": "Total contacts",
    "Total Cost": "Total Cost",
    "Total daily activity time, encompassing all active, idle and pause periods": "Total daily activity time, encompassing all active, idle and pause periods.",
    "Total daily pause duration, including both billable and non-billable pauses": "Total daily pause duration, including both billable and non-billable pauses",
    "Total duration of ring time while attempting to contact customers": "Total duration of ring time while attempting to contact customers",
    "Total file size must be under": "Total file size must be under {count}.",
    "Total file size must be under 15MB": "Total file size must be under 15MB.",
    "Total file size must be under 4MB": "Total file size must be under 4MB.",
    "Total file size exceeds the 4MB limit.": "Total file size exceeds the 4MB limit.",
    "Total Live Calls": "Total Live Calls",
    "Total number of calls": "Total number of calls",
    "total rows": "{rows, plural, =0 {no rows} =1 {1 row} other {# rows}}",
    "Total Talk": "Total Talk",
    "Total talk time": "Total talk time",
    "total time": "total time",
    "Total time": "Total time",
    "Total time the user was neither on the phone nor paused": "Total time the user was neither on the phone nor paused",
    "Total wait time": "Total wait time",
    "Total: {value}": "Total: {value}",
    "transcript": "transcript",
    "Transcription generation has started.": "Transcription generation has started.",
    "Transcription in progress": "Transcription in progress",
    "Transcription is not available": "Transcription is not available",
    "Transcription request Submitted": "Transcription request Submitted",
    "Transcription unavailable": "Transcription unavailable",
    "Transcription Unavailable": "Transcription Unavailable",
    "transcriptions": "transcriptions",
    "Transcriptions": "Transcriptions",
    "Transfer": "Transfer",
    "Transfer to inbox": "Transfer to inbox",
    "Transfer to user": "Transfer to user",
    "transferred chat to": "transferred chat to",
    "Transport": "Transport",
    "Travel and Hospitality": "Travel and Hospitality",
    "Trigger": "Trigger",
    "Try PBX free": "Try PBX.IM free – no commitment required:",
    "Try using different keywords.": "Try using different keywords.",
    "TSX": "TSX",
    "TTL": "TTL",
    "Tue": "Tue",
    "Two factor authentication": "Two-factor authentication",
    "two-Factor Authentication": "two-Factor Authentication",
    "Two-Factor Authentication": "Two-Factor Authentication",
    "Two-Factor Authentication Required": "Two-Factor Authentication Required",
    "Two-Factor Authentication updated": "Two-Factor Authentication updated",
    "TWSE": "TWSE",
    "TXT record added": "TXT record added",
    "TXT Value": "TXT Value",
    "Type": "Type",
    "Type a phone number or select from contacts": "Type a phone number or select from contacts",
    "Type city": "Type city",
    "Type email": "Type email",
    "Type Email": "Type Email",
    "Type name": "Type name",
    "Type notes": "Type notes",
    "Type placeholder": "Enter {what}",
    "Type to search contacts...": "Type to search contacts...",
    "UAN": "UAN",
    "UI inactivity": "UI inactivity",
    "Unable to create A2P campaign": "Unable to create A2P campaign",
    "Unable to create campaign": "Unable to create campaign",
    "Unable to process your request": "Unable to process your request",
    "Unable to submit campaign": "Unable to submit campaign",
    "Unable to update A2P campaign": "Unable to update A2P campaign",
    "Unable to update campaign": "Unable to update campaign",
    "Unanswered": "Unanswered",
    "unanswered calls": "unanswered calls",
    "Unanswered calls": "Unanswered calls",
    "unanswered calls tooltip calls report kpi": "The percentage of calls that did not get connected or answered. Lower percentages are often better.",
    "Unassigned": "Unassigned",
    "Unavailable while account is under review": "Unavailable while account is under review",
    "Unblock": "Unblock",
    "Unblock User": "Unblock User",
    "unique calls": "unique calls",
    "Unique calls": "Unique calls",
    "unique calls tooltip kpi": "Measures the percentage of calls made or received by the agent to unique numbers. Higher percentages indicate a greater frequency of calls to different numbers.",
    "Unit Cost": "Unit Cost",
    "United States": "United States",
    "Unknown": "Unknown",
    "Unknown error": "Unknown error",
    "Unlimited": "Unlimited",
    "Unlimited Max Wait time": "Unlimited Max Wait Time",
    "Unlimited Max Wait time - no agents": "Unlimited Max Wait Time - No Agents",
    "Unlimited Users": "Unlimited Users",
    "Unmute": "Unmute",
    "Unpin": "Unpin",
    "unread": "unread",
    "Unreachable": "Unreachable",
    "Unsaved changes": "Unsaved changes",
    "Unsupported file format": "Unsupported file format",
    "Unsupported script type": "Unsupported script type",
    "Untitled Flow": "Untitled Flow",
    "UNVERIFIED": "UNVERIFIED",
    "Up": "Up",
    "Up To Users": "Up To {count} Users",
    "Update": "Update",
    "Update media file": "Update media file",
    "UPDATE SEATS IN PLAN": "UPDATE SEATS IN PLAN",
    "upgrade plan": "upgrade plan",
    "Upgrade plan": "Upgrade plan",
    "Upgrade your plan to add more seats.": "Upgrade your plan to add more seats.",
    "Upload": "Upload",
    "Upload a CSV file with the numbers the auto dialer will call": "Upload a CSV file with the numbers the auto dialer will call",
    "Upload a CSV file with the numbers the auto dialer will not call": "Upload a CSV file with the numbers the auto dialer will not call",
    "upload a local file": "upload a local file",
    "Upload CSV": "Upload CSV",
    "upload csv confirmation": "Uploading a new CSV will remove all added numbers. <br></br> Are you sure you want to proceed?",
    "Upload failed due to a network error, please try again.": "Upload failed due to a network error, please try again.",
    "upload list default country tooltip": "Used to validate and convert phone numbers from local format to international E.164 format. Applies to numbers without a country code in the uploaded list.",
    "Upload logo": "Upload logo",
    "Uploaded logo": "Uploaded logo",
    "Upon call answer, a voice recording is played to the agent before connecting to the caller": "Upon call answer, a voice recording is played to the agent before connecting to the caller",
    "Uppercase letters (A-Z)": "Uppercase letters (A-Z)",
    "URL": "URL",
    "URL:": "URL: {url}",
    "URLs cannot contain spaces": "URLs cannot contain spaces",
    "Use Authentication app to generate code": "Use Authentication app to generate code",
    "Use Google Authenticator or another app": "Use Google Authenticator or another app",
    "Use Google Authentificator": "Use Google Authentificator",
    "Use Google authentificator to generate code": "Use Google authentificator to generate code",
    "Use the code sent to your email address {email}": "Use the code sent to your email address {email}",
    "Use this domain": "Use this domain",
    "Used by": "Used by",
    "User": "User",
    "User agent": "User agent",
    "User created": "User created",
    "User Defined": "User Defined",
    "User has been successfully logged out": "User has been successfully logged out",
    "user has been successfully unblocked": "{user} has been successfully unblocked.",
    "User Login": "User Login",
    "User Name": "User Name",
    "User password will be invalidated and a link to set a new password will be sent to the verified user Email and/or Phone": "User password will be invalidated and a link to set a new password will be sent to the verified user Email and/or Phone",
    "User Pin": "User Pin",
    "User profile added successfully.": "User profile added successfully.",
    "User Profile Edit": "User Profile Edit",
    "User type": "User type",
    "username": "username",
    "Username": "Username",
    "Username *": "Username *",
    "Username was copied": "Username was copied",
    "Users": "Users",
    "Users / Endpoints": "Users / Endpoints",
    "Users & Roles": "Users & Roles",
    "users count": "+ {users} users",
    "Users has been successfully logged out": "Users has been successfully logged out",
    "Users override": "Users override",
    "Usually contains a welcome message and instructions": "Usually contains a welcome message and instructions",
    "Usually, it repeats instructions, but without the welcome message": "Usually, it repeats instructions, but without the welcome message",
    "Utility": "Utility",
    "Uuid": "Uuid",
    "UUID": "UUID",
    "UUID Copied": "UUID Copied",
    "Validation Error": "Validation Error",
    "Validation Rule": "Validation Rule",
    "Value": "Value",
    "Value is required": "Value is required",
    "Value should start with": "Value should start with $",
    "var": "$var",
    "Variable": "Variable",
    "Variable '{name}' already in use": "Variable '{name}' already in use",
    "Variable name cannot be longer than 50 characters.": "Variable name cannot be longer than 50 characters.",
    "Variable name must consist of English letters and numbers, and cannot begin with a number.": "Variable name must consist of English letters and numbers, and cannot begin with a number.",
    "VAT number": "VAT number",
    "VAT number (optional)": "VAT number (optional)",
    "Verification code": "Verification code",
    "Verification Code": "Verification Code",
    "Verification code expired": "Verification code expired. Please request a new code.",
    "Verified": "Verified",
    "VERIFIED": "VERIFIED",
    "Verify": "Verify",
    "Verify email": "Verify email",
    "Verify Email": "Verify Email",
    "Verify Mobile": "Verify Mobile",
    "Verify phone number": "Verify phone number",
    "Verify the DNS record before continuing": "Verify the DNS record before continuing",
    "Verify the gateway and test a call": "Verify the gateway and test a call",
    "Verify your ID": "Verify your ID",
    "Verifying domain": "Verifying domain",
    "Verifying user": "We're setting up your account...",
    "Vertical": "Vertical",
    "Vertical type": "Vertical type",
    "Victor joined the conversation": "Victor joined the conversation",
    "Video": "Video",
    "Videos": "Videos",
    "View Invoices": "View Invoices",
    "Virtual": "Virtual",
    "Visa": "Visa",
    "Voice": "Voice",
    "Voice → Direct Routing": "Voice → Direct Routing",
    "Voice is required": "Voice is required",
    "Voice Only Destinations": "Voice Only Destinations",
    "Voice recording": "Voice recording",
    "Voice routing": "Voice routing",
    "Voice with Fax Detection": "Voice with Fax Detection",
    "Voicemail": "Voicemail",
    "VOICEMAIL": "Voicemail",
    "Voicemail description": "Manage the list of voice messages.",
    "VOIP": "VoIP",
    "VSE": "VSE",
    "Wait": "Wait",
    "wait ~30s": "wait ~30s",
    "Wait moderator": "Wait moderator",
    "waiting": "waiting",
    "Waiting calls": "Waiting calls",
    "Waiting music": "Waiting music",
    "Wallboard": "Wallboard",
    "Wallboard not found": "Wallboard not found",
    "Wallboard saved successfully": "Wallboard saved successfully",
    "Wallboard Validation Failed": "Wallboard Validation Failed",
    "Wallboards": "Wallboards",
    "Warning": "Warning",
    "was unsupported": "was unsupported",
    "We manage DNS for you. Choose sip.io, pbx.im and more.": "We manage DNS for you. Choose sip.io, pbx.im and more.",
    "We manage the DNS record for you, no setup required.": "We manage the DNS record for you, no setup required.",
    "We need a few details to set up your account": "We need a few details to set up your account.",
    "We need to verify your personal information in order to avoid fraud and scams": "We need to verify your personal information in order to avoid fraud and scams",
    "We support the following transport types: UDP, TCP, TLS": "We support the following transport types: UDP, TCP, TLS",
    "We use encryption to make sure your calls stay private": "We use encryption to make sure your calls stay private.",
    "We value your interest and are eager to share it with you!": "We value your interest and are eager to share it with you!",
    "We will soon be rolling out PBX, which is currently in its final stages of development": "We will soon be rolling out PBX, which is currently in its final stages of development",
    "We’ll send financial notifications to the email below": "We’ll send financial notifications to the email below.",
    "We've automatically logged you out due to inactivity to safeguard your account": "We've automatically logged you out due to inactivity to safeguard your account",
    "We've sent you an email with a verification code": "We've sent you an email with a verification code.",
    "We've sent you an email with further instructions": "We've sent you an email with further instructions",
    "We've sent you an SMS with a verification code": "We've sent you an SMS with a verification code.",
    "web domain": "web domain",
    "Web Domain": "Web Domain",
    "Web phone": "Web phone",
    "Web Phone": "Web Phone",
    "Web Widget": "Web Widget",
    "Web Widget Builder": "Web Widget Builder",
    "Web Widget Preview": "Web Widget Preview",
    "web widgets": "web widgets",
    "WebDialer is not properly initialized": "WebDialer is not properly initialized",
    "Webhook notifications": "Webhook notifications",
    "Webphone": "Webphone",
    "webphone-tour-step-1": "Click here to open your Webphone!",
    "webphone-tour-step-2": "Make sure your microphone is connected.",
    "webphone-tour-step-3": "Please enter the phone number you’d like to call.",
    "webphone-tour-step-4": "Press call.",
    "webphone-tour-step-5": "Awesome! Now you've learned how to make a call! If you'd like to learn more about other features, please refer to the {documentation}.",
    "webphone-tour-step-agent-1": "You can select your status here before activating the phone.",
    "webphone-tour-step-agent-2": "Click here to activate and check-in.",
    "webphone-tour-step-agent-3": "You have successfully checked in. Now, click 'Dialpad' to navigate and make your first call.",
    "webphone-tour-step-welcome": "Welcome to PBX.IM. Let's quickly make your first call!",
    "website": "website",
    "Website": "Website",
    "Wed": "Wed",
    "Week count": "{count} Week",
    "Weeks": "{value} Weeks",
    "Welcome Message": "Welcome Message",
    "Welcome,": "Welcome",
    "Welcome!": "Welcome!",
    "were unsupported": "were unsupported",
    "What  is an Auto Attendant?": "What  is an Auto Attendant?",
    "What are announcements, and how can they help me communicate with my callers?": "What are announcements, and how can they help me communicate with my callers?",
    "What are contacts?": "What are contacts?",
    "What are KPIs, and how can I set them for my call reports?": "What are KPIs, and how can I set them for my call reports?",
    "What are phone numbers used for?": "What are phone numbers used for?",
    "What are statuses and how do I add one?": "What are statuses and how do I add one?",
    "What are teams, and why should I create one?": "What are teams, and why should I create one?",
    "What are the available time intervals for creating a report?": "What are the available time intervals for creating a report?",
    "What are the benefits and use cases of voicemail?": "What are the benefits and use cases of voicemail?",
    "What are the costs associated with phone numbers?": "What are the costs associated with phone numbers?",
    "What are the Matched and Not Matched routing options in Time Conditions?": "What are the Open Hours and Closed Hours routing options in Business Hours?",
    "What are the presets in call logs?": "What are the presets in call logs?",
    "What are the responsibilities of a supervisor?": "What are the responsibilities of a supervisor?",
    "What are the use cases of Announcements?": "What are the use cases of Announcements?",
    "What can I help you with?": "What can I help you with?",
    "What can we help you with?": "What can we help you with?",
    "What details can I find in the call logs?": "What details can I find in the call logs?",
    "What does BLF mean, and how can I use it?": "What does BLF mean, and how can I use it?",
    "What exactly are dial rules, and why would I need to use them?": "What exactly are dial rules, and why would I need to use them?",
    "What exactly is an extension, and why would I use one?": "What exactly is an extension, and why would I use one?",
    "What features are typically included with a phone number?": "What features are typically included with a phone number?",
    "What filters can be applied to call logs?": "What filters can be applied to call logs?",
    "What happens if a number doesn't match any of my dial rules?": "What happens if a number doesn't match any of my dial rules?",
    "What happens if a user is deactivated?": "What happens if a user is deactivated?",
    "What happens if I change my subscription plan while one is active?": "What happens if I change my subscription plan while one is active?",
    "What happens if I delete a Time Condition?": "What happens if I delete a Business Hours rule?",
    "What happens if I delete a Time Group?": "What happens if I delete a Time Group?",
    "What happens if I delete a voicemail?": "What happens if I delete a voicemail?",
    "What happens if I delete an Auto Attendant?": "What happens if I delete an Auto Attendant?",
    "What happens if I delete an endpoint?": "What happens if I delete an endpoint?",
    "What happens if I delete an intercept group?": "What happens if I delete an intercept group?",
    "What happens if I need to edit or delete an existing announcement?": "What happens if I need to edit or delete an existing announcement?",
    "What happens if I no longer need a phone number?": "What happens if I no longer need a phone number?",
    "What happens if no one in the Ring Group picks up the call?": "What happens if no one in the Ring Group picks up the call?",
    "What happens if someone joins the conference while others are already talking?": "What happens if someone joins the conference while others are already talking?",
    "What happens if the balance is low?": "What happens if the balance is low?",
    "What happens if the forwarded number doesn't answer?": "What happens if the forwarded number doesn't answer?",
    "What happens when I delete media used in the app? Is there a fallback?": "What happens when I delete media used in the app? Is there a fallback?",
    "What if my team works remotely or in different time zones – how can extensions help?": "What if my team works remotely or in different time zones – how can extensions help?",
    "What is a call report and what does it contain?": "What is a call report and what does it contain?",
    "What is a Caller ID?": "What is a Caller ID?",
    "What is a KPI and how to set it?": "What is a KPI and how to set it?",
    "What is a queue report and what does it contain?": "What is a queue report and what does it contain?",
    "What is a Ring Group, and how does it help my team answer calls faster?": "What is a Ring Group, and how does it help my team answer calls faster?",
    "What is a ring strategy and how to set one?": "What is a ring strategy and how to set one?",
    "What is a Time Condition, and how does it affect call routing?": "What are Business Hours, and how do they affect call routing?",
    "What is an endpoint, and how does it work in PBX?": "What is an endpoint, and how does it work in PBX?",
    "What is Call Distribution?": "What is Call Distribution?",
    "What is the balance used for?": "What is the balance used for?",
    "What is the difference between 'Record Stereo' and standard call recording?": "What is the difference between 'Record Stereo' and standard call recording?",
    "What is the difference between standard call rates and premium rates?": "What is the difference between standard call rates and premium rates?",
    "What is the purpose of Time Groups and how do I create one?": "What is the purpose of Time Groups and how do I create one?",
    "What is the Text-to-Speech option, and how do I use it?": "What is the Text-to-Speech option, and how do I use it?",
    "What metrics are used to determine call efficiency?": "What metrics are used to determine call efficiency?",
    "What security measures are available for my account?": "What security measures are available for my account?",
    "What statuses are allowed for a team?": "What statuses are allowed for a team?",
    "What types of users are available in PBX?": "What types of users are available in PBX?",
    "What's a call queue?": "What's a call queue?",
    "What's the difference between a ring group and an intercept group?": "What's the difference between a ring group and an intercept group?",
    "WhatsApp": "WhatsApp",
    "WhatsApp Account": "WhatsApp Account",
    "WhatsApp account connected successfully": "WhatsApp account connected successfully",
    "WhatsApp Business account connected successfully": "WhatsApp Business account connected successfully",
    "WhatsApp Business account disconnected successfully": "WhatsApp Business account disconnected successfully",
    "WhatsApp business numbers": "WhatsApp business numbers",
    "WhatsApp connection was cancelled": "WhatsApp connection was cancelled",
    "WhatsApp connection was cancelled or failed": "WhatsApp connection was cancelled or failed",
    "WhatsApp numbers synchronized successfully": "WhatsApp numbers synchronized successfully",
    "WhatsApp Templates": "WhatsApp Templates",
    "When an inbound message arrives, this greeting is sent as the generic first reply. After that, an agent can assign the conversation to themselves.": "When an inbound message arrives, this greeting is sent as the generic first reply. After that, an agent can assign the conversation to themselves.",
    "When an inbound message arrives, this greeting is sent as the generic first reply. After that, an user can assign the conversation to themselves.": "When an inbound message arrives, this greeting is sent as the generic first reply. After that, an user can assign the conversation to themselves.",
    "When checked, the audio will play more than once": "When checked, the audio will play more than once",
    "when it falls below a specified threshold": "when it falls below a specified threshold",
    "When the balance falls below the threshold, top up to a target balance, example: top up until the balance is $50": "When the balance falls below the threshold, top up to a target balance. example: top up until the balance is $50",
    "When the balance falls below the threshold, top-up with specified amount": "When the balance falls below the threshold, top-up with specified amount",
    "Where do calls go when someone dials an extension? Can I change that?": "Where do calls go when someone dials an extension? Can I change that?",
    "Where is the media I uploaded used?": "Where is the media I uploaded used?",
    "Whisper": "Whisper",
    "Whispering": "Whispering",
    "Why are labels necessary for time groups?": "Why are labels necessary for time groups?",
    "Why are statuses useful?": "Why are statuses useful?",
    "Why is tracking calls important?": "Why is tracking calls important?",
    "Why should I use media?": "Why should I use media?",
    "Widget name is required": "Widget name is required",
    "Widget name must be less than 100 characters": "Widget name must be less than 100 characters",
    "Will the campaign include any age gated content as defined by carrier and CTIA guidelines?": "Will the campaign include any age gated content as defined by carrier and CTIA guidelines?",
    "Will the campaign include content related to direct lending or other loan arrangements?": "Will the campaign include content related to direct lending or other loan arrangements?",
    "Work": "Work",
    "Work Email": "Work Email",
    "Work Email *": "Work Email *",
    "Work time": "Work time",
    "Work Time": "Work Time",
    "Wrap up time (outbound)": "Wrap up time (outbound)",
    "Wrap Up Time (Outbound)": "Wrap Up Time (Outbound)",
    "Wrap up time (queue)": "Wrap up time (queue)",
    "Wrap Up Time (Queue)": "Wrap Up Time (Queue)",
    "Write a message": "Write a message",
    "X-XXXXXXX or XX-XXXXXXX": "X-XXXXXXX or XX-XXXXXXX",
    "year": "year",
    "Year count": "{count} Year",
    "yearly": "yearly",
    "Yearly invoice": "Yearly invoice",
    "Yes": "Yes",
    "Yes, delete": "Yes, delete",
    "Yes, discard": "Yes, discard",
    "Yes, I'm here": "Yes, I'm here",
    "yesterday": "yesterday",
    "Yesterday": "Yesterday",
    "You": "You",
    "You are about to add <b>{amount}</b> seats for a prorated total of <b>{total}</b>": "You are about to add <b>{amount}</b> seats for a prorated total of <b>{total}</b>.",
    "You are about to cancel": "You are about to cancel",
    "You are about to invite as a team member": "You are about to invite {email} as a team member",
    "You are about to purchase": "You are about to purchase <amount>{quantity}</amount> phone numbers for a total of <amount>{total}</amount>.",
    "You are about to remove <b>{amount}</b> seats from your plan": "You are about to remove <b>{amount}</b> seats from your plan.",
    "You are about to restore": "You are about to restore",
    "You are about to send a password reset link to": "You are about to send a password reset link to {email}",
    "you are about to submit numbers for port-in": "you are about to submit numbers for port-in",
    "You are already in the call": "You are already in the call",
    "You are listening": "You are listening",
    "You are not checked-in": "You are not checked-in",
    "You are now checked into the web dialer": "You are now checked into the web dialer",
    "You are whispering": "You are whispering",
    "You barged into the call": "You barged into the call",
    "You can connect a WhatsApp business profile without this, but you won't be able to use its phone number": "You can connect a WhatsApp business profile without this, but you won't be able to use its phone number.",
    "You can send it later using the Send Invite option": "You can send it later using the \"Send Invite\" option",
    "You cannot delete the last payment method because you have an active subscription plan": "You cannot delete the last payment method because you have an active subscription plan",
    "You do not have permission to send SMS.": "You do not have permission to send SMS.",
    "You have been logged out due to inactivity": "You have been logged out due to inactivity",
    "You have new chats in queue:": "You have new chats in queue:",
    "You have unimported records": "You have unimported records.",
    "You may enter multiple Emails, separated by Comma": "You may enter multiple Emails, separated by Comma",
    "You need to check-in before listening to a call": "You need to check-in before listening to a call",
    "Active and invited users. Each one holds a seat on your plan.": "Active and invited users. Each one holds a seat on your plan.",
    "You will automatically be logged out in <b>{seconds}s</b> due to inactivity": "You will automatically be logged out in <b>{seconds}s</b> due to inactivity",
    "You will be redirected to WhatsApp Business Manager to continue setup.": "You will be redirected to WhatsApp Business Manager to continue setup.",
    "You'll be among the first to receive a personal call from our team with all the details about our rollout": "You'll be among the first to receive a personal call from our team with all the details about our rollout",
    "You've reached the limit of three custom plans. Please remove one to add a new plan": "You've reached the limit of three custom plans. Please remove one to add a new plan",
    "Your account doesn't have phone numbers with SMS capabilities": "Your account doesn't have phone numbers with SMS capabilities",
    "Your application will be sent to our support team for processing We’ll review your submission and contact you with the next steps and any additional requirements": "Your application will be sent to our support team for processing. We’ll review your submission and contact you with the next steps and any additional requirements.",
    "Your changes will be lost.": "Your changes will be lost.",
    "Your current balance is below the set threshold": "Your current balance is below the set threshold.",
    "Your new business number is live. Call, text, and connect instantly.": "Your new business number is live. Call, text, and connect instantly.",
    "your password again": "your password again",
    "Your PBX email has been verified successfully": "Your PBX email has been verified successfully!",
    "Your Profile": "Your Profile",
    "Your session expired. Please login in again to use the application": "Your session expired. Please login in again to use the application",
    "Your subscription has been canceled.": "Your subscription has been canceled.",
    "zip / postal code": "zip / postal code",
    "Zip / Postal code": "Zip / Postal code",
    "Zip / Postal Code": "Zip / Postal Code",
    "ZIP / Postal code": "ZIP / Postal code",
    "ZIP Code": "ZIP Code",
    "ZIP Code *": "ZIP Code *",
    "Number of abandoned calls": "Number of abandoned calls",
    "Calls Within SLA": "Calls Within SLA",
    "Timeout Calls": "Timeout Calls",
    "Answered on time": "Answered on time",
    "Not answered in time": "Not answered in time",
    "Create Contact Us Web Widget": "Create Contact Us Web Widget",
    "Invalid credentials": "Invalid credentials",
    "hours label": "hours",
    "minutes label": "minutes",
    "Add Business Hours": "Add Business Hours",
    "Edit Business Hours": "Edit Business Hours",
    "Account was created on {date}. Start date has been adjusted.": "Account was created on {date}. Start date has been adjusted.",
    "Your current integration script will no longer work after regeneration. All existing integrations must be updated with the new script to continue working. Do you want to continue?": "Your current integration script will no longer work after regeneration. All existing integrations must be updated with the new script to continue working. Do you want to continue?",
    "Maximum date range is 3 months. End date has been adjusted.": "Maximum date range is 3 months. End date has been adjusted.",
    "Maximum date range is 90 days. End date has been adjusted.": "Maximum date range is 90 days. End date has been adjusted.",
    "Please fix the date range before exporting": "Please fix the date range before exporting",
    "Segments / SMS": "Segments / SMS",
    "Segments SMS format": "{segments} ({charCount} characters)",
    "Segments per message": "Segments per message",
    "Segment cost": "Segment cost",
    "Total cost": "Total cost",
    "Balance below estimated cost — top up to launch": "Balance below estimated cost — top up to launch",
    "Unable to pause campaign": "Unable to pause campaign",
    "Unable to resume campaign": "Unable to resume campaign",
    "Edit SMS Campaign": "Edit SMS Campaign",
    "Approved": "Approved",
    "Sign in securely with your Reshetcall identity.": "Sign in securely with your Reshetcall identity.",
    "These filters are not yet available in the new reports engine.": "These filters are not yet available in the new reports engine.",
    "The selected destination is no longer available": "The selected destination is no longer available",
    "The selected media file is no longer available": "The selected media file is no longer available",
    "One of the selected labels is no longer available": "One of the selected labels is no longer available",
    "One of the selected teams is no longer available": "One of the selected teams is no longer available",
    "Showing data for your teams only": "Showing data for your teams only",
    "Template created": "Template created",
    "A template needs a body": "A template needs a body",
    "Template name must be lowercase letters, digits and underscores": "Template name must be lowercase letters, digits and underscores",
    "Failed to create template": "Failed to create template",
    "Nothing to update": "Nothing to update",
    "Meta rejected the template change": "Meta rejected the template change",
    "Template submitted to Meta for approval": "Template submitted to Meta for approval",
    "This template was already submitted": "This template was already submitted",
    "Meta rejected the template": "Meta rejected the template",
    "Failed to submit template": "Failed to submit template",
    "That template no longer exists": "That template no longer exists",
    "Synced {count} number(s) from Meta": "Synced {count} number(s) from Meta",
    "Only one WhatsApp Business Account can be connected per account. Not connected: {ids}.": "Only one WhatsApp Business Account can be connected per account. Not connected: {ids}.",
    "A sync is already running. Try again in a moment.": "A sync is already running. Try again in a moment.",
    "Number updated successfully": "Number updated successfully",
    "That number no longer exists": "That number no longer exists",
    "Failed to update number": "Failed to update number",
    "You do not have permission to view WhatsApp settings": "You do not have permission to view WhatsApp settings",
    "Could not load WhatsApp settings": "Could not load WhatsApp settings",
    "Try again": "Try again",
    "Inbox assignment becomes available once inboxes are set up": "Inbox assignment becomes available once inboxes are set up",
    "Removed at Meta": "Removed at Meta",
    "Not available yet": "Not available yet",
    "Assignment updated": "Assignment updated",
    "Phone number in use named": "This phone number already belongs to {name}.",
    "Phone number in use": "This phone number already belongs to another contact.",
    "Permissions": "Permissions",
    "That invitation no longer exists": "That invitation no longer exists",
    "This invitation was already accepted": "This invitation was already accepted",
    "This invitation was revoked": "This invitation was revoked",
    "Rings {count} devices": "Rings {count} devices",
    "Ring group created": "Ring group created",
    "Ring group updated": "Ring group updated",
    "Sequential": "Sequential",
    "One of the selected users is no longer available": "One of the selected users is no longer available",
    "Failed to load options": "Failed to load options",
    "invalid_verification_code": "Invalid verification code",
    "verification_code_expired": "Verification code expired",
    "too_many_attempts": "Too many incorrect attempts. That code is no longer valid — use Resend to get a new one.",
    "Time group created": "Time group created",
    "Time group updated": "Time group updated",
    "Business hours created": "Business hours created",
    "Business hours updated": "Business hours updated",
    "One of the selected time groups is no longer available": "One of the selected time groups is no longer available",
    "The selected time group is no longer available": "The selected time group is no longer available",
    "Business hours cannot route to themselves": "Business hours cannot route to themselves",
    "You do not have permission to view time groups": "You do not have permission to view time groups",
    "Cannot delete, still in use by {items}": "Cannot delete, still in use by {items}",
    "PIN must be 4 to 6 digits": "PIN must be 4 to 6 digits",
    "{count} days trial period": "{count} days trial period",
    "{count} seats": "{count} seats",
    "{plan} Plan": "{plan} Plan",
    "${total}/mo": "${total}/mo",
    "${total}/mo after trial, on {date}": "${total}/mo after trial, on {date}",
    "${total}/yr": "${total}/yr",
    "${total}/yr after trial, on {date}": "${total}/yr after trial, on {date}",
    "Add your credit card details.": "Add your credit card details.",
    "Billed today": "Billed today",
    "Business location": "Business location",
    "Cancel before trial ends to avoid getting charged": "Cancel before trial ends to avoid getting charged",
    "Card Name": "Card Name",
    "Card Number": "Card Number",
    "Charge after trial": "Charge after trial",
    "Choose your post-trial plan": "Choose your post-trial plan",
    "Continue To Plans": "Continue To Plans",
    "Credit Card": "Credit Card",
    "CVC": "CVC",
    "Expiry date": "Expiry date",
    "mo/seat": "mo/seat",
    "Monthly Recurring (billed on {date})": "Monthly Recurring (billed on {date})",
    "Pick the plan your trial runs on. You won't be charged until your free trial ends on {date}.": "Pick the plan your trial runs on. You won't be charged until your free trial ends on {date}.",
    "Recommended": "Recommended",
    "seat": "seat",
    "We couldn't load the plans right now. Please try again shortly.": "We couldn't load the plans right now. Please try again shortly.",
    "Yearly": "Yearly",
    "Yearly Recurring (billed on {date})": "Yearly Recurring (billed on {date})",
    "yr/seat": "yr/seat",
    "You won't be charged today.": "You won't be charged today.",
    "Add your card": "Add your card",
    "We couldn't finish creating your account. Please try again.": "We couldn't finish creating your account. Please try again.",
    "Card saved. Finishing up…": "Card saved. Finishing up…",
    "Loading…": "Loading…",
    "Add a payment method": "Add a payment method",
    "We couldn't open the payment form. Please try again.": "We couldn't open the payment form. Please try again.",
    "Invalid value": "Invalid value",
    "The start and end times cannot be the same": "The start and end times cannot be the same",
    "Current": "Current",
    "Plan updated": "Plan updated",
    "Your new plan starts on": "Your new plan starts on {date}",
    "We couldn't change your plan. Please try again.": "We couldn't change your plan. Please try again.",
    "Review your change": "Review your change",
    "New plan": "New plan",
    "We couldn't price that change. Please try again.": "We couldn't price that change. Please try again.",
    "Charged today": "Charged today",
    "Next invoice": "Next invoice",
    "Starts on": "Starts on",
    "Effective": "Effective",
    "You keep your current plan until then.": "You keep your current plan until then.",
    "You are about to add seats": "You are about to add {count} seats to your plan.",
    "You are about to remove seats": "You are about to remove {count} seats from your plan.",
    "Your password has been changed. Sign in to continue.": "Your password has been changed. Sign in to continue.",
    "This password reset link is no longer valid. Request a new one.": "This password reset link is no longer valid. Request a new one.",
    "skipped team members": "{count, plural, one {# selected user is no longer available and was not added} other {# selected users are no longer available and were not added}}",
    "skipped team statuses": "{count, plural, one {# selected status is no longer available and was not added} other {# selected statuses are no longer available and were not added}}",
    "An error occurred while saving the team.": "An error occurred while saving the team.",
    "This password reset link has already been used. Request a new one.": "This password reset link has already been used. Request a new one.",
    "This password reset link has expired. Request a new one.": "This password reset link has expired. Request a new one.",
    "Request a new link": "Request a new link",
    "Too many requests. Please try again in a moment.": "Too many requests. Please try again in a moment.",
    "Announcement created": "Announcement created",
    "Announcement updated": "Announcement updated",
    "Media file not found": "Media file not found",
    "Label not found": "Label not found",
    "The file is too large": "The file is too large. The maximum size is {size}.",
    "Text to speech is unavailable right now": "Text to speech is unavailable right now. Please try again later.",
    "Account settings are unavailable right now. Please try again shortly.": "Account settings are unavailable right now. Please try again shortly.",
    "No longer available": "No longer available",
    "Extensions longer than Max digits cannot be dialed": "Extensions {digits} are longer than Max digits and cannot be dialed",
    "Longer than Max digits": "Cannot be longer than Max digits ({max})",
    "An auto attendant cannot point at itself": "An auto attendant cannot point at itself",
    "One of the selected extensions is no longer available": "One of the selected extensions is no longer available",
    "Too many items": "Too many items",
    "You do not have permission to view users": "You do not have permission to view users",
    "This audio is too long": "This audio is too long. The maximum is about {minutes} minutes once converted.",
    "Call queue created": "Call queue created",
    "Call queue updated": "Call queue updated",
    "Dynamic - Position in Queue": "Dynamic - Position in Queue",
    "Dynamic - Estimated Wait Time in Queue": "Dynamic - Estimated Wait Time in Queue",
    "Plays the selected audio in the order defined below to callers waiting in the queue": "Plays the selected audio in the order defined below to callers waiting in the queue",
    "Invalid value in field": "Invalid value: {field}",
    "Currently routes to": "Currently routes to {name}",
    "Too many requests. Please try again in {seconds} seconds.": "Too many requests. Please try again in {seconds, plural, one {# second} other {# seconds}}.",
    "Too many requests. Please try again in {minutes} minutes.": "Too many requests. Please try again in {minutes, plural, one {# minute} other {# minutes}}.",
    "Connecting your WhatsApp Business account and syncing numbers and templates…": "Connecting your WhatsApp Business account and syncing numbers and templates…",
    "Waiting for Meta to finish registering — this can take a moment": "Waiting for Meta to finish registering — this can take a moment",
    "These prices have expired. Please search again.": "These prices have expired. Please search again.",
    "That selection is no longer valid. Please search again.": "That selection is no longer valid. Please search again.",
    "That number sold out while ordering. Please search again.": "That number sold out while ordering. Please search again.",
    "That number is no longer available. Please search again.": "That number is no longer available. Please search again.",
    "Your card would not authorize this purchase.": "Your card would not authorize this purchase.",
    "Your balance does not cover this purchase.": "Your balance does not cover this purchase.",
    "Some numbers could not be bought": "Some numbers could not be bought",
    "We could not complete that purchase. Please try again shortly.": "We could not complete that purchase. Please try again shortly.",
    "Please buy at most {max} numbers at a time": "Please buy at most {max} numbers at a time",
    "That sign-in was cancelled. Please try again.": "That sign-in was cancelled. Please try again.",
    "Your sign-in with that provider has expired. Please start again.": "Your sign-in with that provider has expired. Please start again.",
    "{domain} is already taken. Please choose another.": "{domain} is already taken. Please choose another.",
    "{domain} is not available. Please choose another.": "{domain} is not available. Please choose another.",
    "{domain} was just taken. Go back to Business details and pick another web domain.": "{domain} was just taken. Go back to Business details and pick another web domain.",
    "14 days free. Full-access, no risk.": "14 days free. Full-access, no risk.",
    "Full-access to every feature on your plan": "Full-access to every feature on your plan",
    "No charge until day 15 - cancel before, pay $0": "No charge until day 15 - cancel before, pay $0",
    "A free trial phone number to test calling": "A free trial phone number to test calling",
    "Conversation history": "Conversation history",
    "No earlier conversations.": "No earlier conversations.",
    "Supervisors": "Supervisors",
    "Mine": "Mine",
    "Unread": "Unread",
    "Pick a conversation": "Pick a conversation",
    "New group": "New group",
    "Create group": "Create group",
    "Add people": "Add people",
    "Leave group": "Leave group",
    "Leave this group?": "Leave this group?",
    "You will stop receiving its messages.": "You will stop receiving its messages.",
    "Direct message": "Direct message",
    "Internal chat": "Internal chat",
    "Search people": "Search people",
    "No colleagues found": "No colleagues found",
    "New message": "New message",
    "Start a conversation from one of your numbers.": "Start a conversation from one of your numbers.",
    "No numbers can send messages": "No numbers can send messages",
    "Choose a number": "Choose a number",
    "Type a message": "Type a message",
    "The message could not be sent. Check the number and try again.": "The message could not be sent. Check the number and try again.",
    "What would you like to start?": "What would you like to start?",
    "Messaging": "Messaging",
    "An inbox is a shared pool. Its staff see every unclaimed conversation in it.": "An inbox is a shared pool. Its staff see every unclaimed conversation in it.",
    "New inbox": "New inbox",
    "No inboxes yet. Create one and add the people who will work it.": "No inboxes yet. Create one and add the people who will work it.",
    "Archived": "Archived",
    "Nobody is staffing this inbox": "Nobody is staffing this inbox",
    "Unarchive": "Unarchive",
    "Archive": "Archive",
    "Rename inbox": "Rename inbox",
    "A supervisor also sees what the inbox's agents have claimed.": "A supervisor also sees what the inbox's agents have claimed.",
    "Create inbox": "Create inbox",
    "Any number": "Any number",
    "Move up": "Move up",
    "Move down": "Move down",
    "Channel": "Channel",
    "Use this number": "Use this number",
    "New conversation": "New conversation",
    "Choose who to message, then write below.": "Choose who to message, then write below.",
    "Who works which conversations": "Who works which conversations",
    "Messaging route": "Messaging route",
    "Messages to this number reach nobody": "Messages to this number reach nobody",
    "The route could not be saved.": "The route could not be saved.",
    "No numbers yet": "No numbers yet",
    "Move to inbox": "Move to inbox",
    "Reopen": "Reopen",
    "Show details": "Show details",
    "Hide details": "Hide details",
    "Join this conversation to reply.": "Join this conversation to reply.",
    "Alphabetical": "Alphabetical",
    "Date Created": "Date Created",
    "Date Updated": "Date Updated",
    "These numbers still feed this inbox": "These numbers still feed this inbox",
    "The inbox could not be archived.": "The inbox could not be archived.",
    "Manage inboxes assigned to users and teams": "Manage inboxes assigned to users and teams",
    "The inbox is archived, not erased: its conversations stay, and nobody sees them until it is restored.": "The inbox is archived, not erased: its conversations stay, and nobody sees them until it is restored.",
    "The inbox could not be saved.": "The inbox could not be saved.",
    "The name and greeting were saved, but the staff could not be updated.": "The name and greeting were saved, but the staff could not be updated.",
    "{cleared} numbers were cleared; {remaining} still feed this inbox. Try again to clear the rest.": "{cleared} numbers were cleared; {remaining} still feed this inbox. Try again to clear the rest.",
    "{cleared} of them were already cleared.": "{cleared} of them were already cleared.",
    "chat system created": "{actor} created the chat.",
    "chat system claimed": "{actor} joined the chat.",
    "chat system assigned": "{actor} transferred chat to {target}.",
    "chat system released": "{actor} left the chat.",
    "chat system moved": "{actor} transferred chat to {target}.",
    "chat system closed": "{actor} ended the chat.",
    "chat system reopened": "{actor} reopened the chat.",
    "chat system member added": "{actor} added {target} to the chat.",
    "chat system member removed": "{actor} removed {target} from the chat.",
    "chat system member left": "{actor} left the chat.",
    "chat system renamed": "{actor} renamed the chat to {target}.",
    "chat system announcement": "Announcement\n{body}",
    "chat system more": "{count} more",
    "A template with no inboxes is offered to nobody": "A template with no inboxes is offered to nobody",
    "Could not load inboxes": "Could not load inboxes",
    "A ring group cannot route to itself": "A ring group cannot route to itself",
    "An announcement cannot route to itself": "An announcement cannot route to itself",
    "A forward cannot route to itself": "A forward cannot route to itself",
    "Invitation resent automatically": "Invitation resent automatically",
    "invitation_resent_to_new_email": "A new invitation was sent to {email}. There is no need to resend it.",
    "The inbox stopped working. Your messages are safe.": "The inbox stopped working. Your messages are safe.",
    "Remove {name} from this group?": "Remove {name} from this group?",
    "Callback pending": "Callback pending",
    "Wallboard not available": "Wallboard not available",
    "That wallboard link is already in use. Reload the page and try again.": "That wallboard link is already in use. Reload the page and try again.",
    "Live updates paused": "Live updates paused",
    "Totals may be incomplete": "Totals may be incomplete",
    "Name is too long": "Name is too long",
    "The board is too large to save. Use a smaller logo image.": "The board is too large to save. Use a smaller logo image.",
    "Failed to change status": "Failed to change status",
    "Reference data may be out of date": "Reference data may be out of date",
    "Could not start the campaign": "Could not start the campaign",
    "Could not stop the campaign": "Could not stop the campaign",
    "Could not save the campaign": "Could not save the campaign",
    "Campaign created": "Campaign created",
    "Campaign updated": "Campaign updated",
    "A campaign with this name already exists": "A campaign with this name already exists",
    "Uploading call list": "Uploading call list",
    "Uploading Do Not Call list": "Uploading Do Not Call list",
    "An earlier upload did not finish": "An earlier upload did not finish: {count} rows were received and were not applied.",
    "An earlier upload did not finish and was not applied": "An earlier upload did not finish and was not applied.",
    "Your previous list is still in use. Upload the file again": "Your previous list is still in use. Upload the file again.",
    "Upload the file again": "Upload the file again.",
    "An upload to this campaign did not finish": "An upload to this campaign did not finish",
    "The list will be deleted when you save the campaign": "The list will be deleted when you save the campaign.",
    "Keep the list": "Keep the list",
    "Delete list": "Delete list",
    "Back to the current list": "Back to the current list",
    "numbers": "numbers",
    "To call": "To call",
    "Resolved": "Resolved",
    "No agents available": "No agents available",
    "No leads to call right now": "No leads to call right now",
    "Outside the leads' local calling hours": "Outside the leads' local calling hours",
    "All lines are in use": "All lines are in use",
    "Stop the campaign before changing its lists or routing": "Stop the campaign before changing its lists or routing",
    "Another upload to this campaign is still in progress. Try again in two minutes": "Another upload to this campaign is still in progress. Try again in two minutes.",
    "The uploaded list changed while saving. Upload the file again": "The uploaded list changed while saving. Upload the file again.",
    "The call list upload did not finish. Upload the file again": "The call list upload did not finish. Upload the file again.",
    "The Do Not Call upload did not finish. Upload the file again": "The Do Not Call upload did not finish. Upload the file again.",
    "The call list upload was not found. Upload the file again": "The call list upload was not found. Upload the file again.",
    "The Do Not Call upload was not found. Upload the file again": "The Do Not Call upload was not found. Upload the file again.",
    "The list has rows that are too large to upload": "The list has rows that are too large to upload",
    "Choose a caller ID for the campaign, or set an account default, before starting it": "Choose a caller ID for the campaign, or set an account default, before starting it",
    "Another running campaign already uses this queue": "Another running campaign already uses this queue",
    "Choose the maximum simultaneous calls for this destination": "Choose the maximum simultaneous calls for this destination",
    "One of the caller IDs does not belong to this account": "One of the caller IDs does not belong to this account",
    "Calls are still in progress. Try again in a minute": "Calls are still in progress. Try again in a minute.",
    "The uploaded list has no valid numbers": "The uploaded list has no valid numbers. Check the phone column and the default country.",
    "The list is too large to upload": "The list is too large to upload",
    "The selected queue no longer exists": "The selected queue no longer exists",
    "The selected timegroup no longer exists": "The selected timegroup no longer exists",
    "The selected destination no longer exists": "The selected destination no longer exists",
    "One of the labels no longer exists": "One of the labels no longer exists",
    "Some values are not valid. Check the highlighted fields": "Some values are not valid. Check the fields and try again.",
    "Too many requests. Wait a minute and save again": "Too many requests. Wait a minute and save again.",
    "Could not refresh. Showing the last loaded data": "Could not refresh. Showing the last loaded data.",
    "This number is already in the list": "This number is already in the list",
    "Too many changes for one save. Upload the list as a file instead": "Too many changes for one save. Upload the list as a file instead",
    "unsaved changes": "{count} unsaved changes",
    "Some edited numbers are not valid or are already in the list. Check the highlighted rows": "Some edited numbers are not valid or are already in the list. Check the highlighted rows",
    "A number you entered is already in the list. Check your changes and save again": "A number you entered is already in the list. Check your changes and save again",
    "Stop upload": "Stop upload",
    "Step of": "Step {step} of {steps}",
    "Keep this tab open until the upload finishes": "Keep this tab open until the upload finishes",
    "Campaign saved with skipped numbers": "Campaign saved. {saved} numbers uploaded, {invalid} skipped as invalid, {duplicates} as repeated.",
    "Download skipped numbers": "Download skipped numbers",
    "Upload stopped. Nothing was changed. Save again to continue": "Upload stopped at {sent} of {total} rows. Nothing was changed. Save again to continue.",
    "The extra columns of this row are too long": "The extra columns of this row are too long",
    "The call list is still being prepared. Try again in a moment": "The call list is still being prepared. Try again in a moment.",
    "The changes are too large to save at once. Upload the list as a file instead": "The changes are too large to save at once. Upload the list as a file instead.",
    "Preparing the call list": "Preparing the call list: numbers you already called keep their history. You can start the campaign when this is done.",
    "From and To must be different times": "From and To must be different times",
    "Part of the campaign was deleted. Delete it again to finish": "Part of the campaign was deleted. Delete it again to finish.",
    "This campaign no longer exists": "This campaign no longer exists",
    "We've sent you a WhatsApp message with a verification code": "We've sent you a WhatsApp message with a verification code.",
    "This verification method is not available for your country.": "This verification method is not available for your country.",
    "This phone number is already in use by another account.": "This phone number is already in use by another account.",
    "This is already your verified number.": "This is already your verified number.",
    "Not verified": "Not verified",
    "Or enter this key": "Or enter this key",
    "Scan the QR code with your authenticator app": "Scan the QR code with your authenticator app",
    "That code is not valid. Check the code and try again": "That code is not valid. Check the code and try again",
    "This setup has expired. Start again": "This setup has expired. Start again",
    "Verify your email to use it for 2FA": "Verify your email to use it for 2FA",
    "Receive a sign-in code by email": "Receive a sign-in code by email",
    "We couldn't load your invoices.": "We couldn't load your invoices.",
    "No invoices yet": "No invoices yet",
    "Paid": "Paid",
    "Unpaid": "Unpaid",
    "Void": "Void",
    "Wallet top-up": "Wallet top-up",
    "+{count} more": "+{count} more",
    "PDF": "PDF",
    "Complete the card verification to finish your top-up": "Complete the card verification to finish your top-up",
    "The card was declined.": "The card was declined.",
    "This country is already used": "This country is already used",
    "You do not have permission to view phone numbers": "You do not have permission to view phone numbers",
    "Upgrade": "Upgrade",
    "You have {used} queues; {plan} allows {allowed}. Delete {delete} to continue.": "You have {used} queues; {plan} allows {allowed}. Delete {delete} to continue.",
    "Changes to {plan} on {date}": "Changes to {plan} on {date}",
    "Keep current plan": "Keep current plan",
    "Remove users before reducing seats": "{used} users are active — remove users before reducing seats.",
    "All seats are in use. Add seats to your plan to invite more users.": "All seats are in use. Add seats to your plan to invite more users.",
    "All seats are in use. Add seats to your plan to reactivate this user.": "All seats are in use. Add seats to your plan to reactivate this user.",
    "Could not load your 2FA settings": "Could not load your 2FA settings",
    "Some changes were saved. Check your settings and try again": "Some changes were saved. Check your settings and try again",
    "We couldn't save your number right now. Please try again.": "We couldn't save your number right now. Please try again.",
    "We couldn't send the code by SMS. Please try another method.": "We couldn't send the code by SMS. Please try another method.",
    "We couldn't send the code over WhatsApp. Please try SMS instead.": "We couldn't send the code over WhatsApp. Please try SMS instead.",
    "We can't send the code right now. Please try again shortly.": "We can't send the code right now. Please try again shortly.",
    "Too many incorrect attempts. That code is no longer valid. Send a new code.": "Too many incorrect attempts. That code is no longer valid. Send a new code.",
    "We couldn't load your account": "We couldn't load your account",
    "Try again, or log out and sign in again if the problem continues": "Try again, or log out and sign in again if the problem continues",
    "You can't sign in from this location ({ip}). Please contact your administrator.": "You can't sign in from this location ({ip}). Please contact your administrator.",
    "You can't sign in from this location. Please contact your administrator.": "You can't sign in from this location. Please contact your administrator.",
    "Your password has been changed, but you can't sign in from this location. Please contact your administrator.": "Your password has been changed, but you can't sign in from this location. Please contact your administrator.",
    "Allowed IP addresses": "Allowed IP addresses",
    "You do not have permission to view queues": "You do not have permission to view queues",
    "The role was saved, but the agent status did not update": "The role was saved, but the agent status did not update",
    "$0.00 today, cancel anytime before your trial ends on {date}": "$0.00 today, cancel anytime before your trial ends on {date}",
    "You have {used} web widgets; {plan} allows {allowed}. Delete {delete} to continue.": "You have {used} web widgets; {plan} allows {allowed}. Delete {delete} to continue.",
    "{plan} allows up to {max} seats.": "{plan} allows up to {max} seats.",
    "Card added, but it could not be kept as non-default": "Card added, but it could not be kept as non-default",
    "Enter a valid ZIP code": "Enter a valid ZIP code",
    "Card verification failed. Try again or use another card.": "Card verification failed. Try again or use another card.",
    "Payment received. Your balance will update shortly.": "Payment received. Your balance will update shortly.",
    "Up to {count} email addresses": "You can add up to {count} email addresses",
    "Test email not sent to {emails}": "The test email was not sent to {emails}",
    "Voicemail saved, but where its recordings are delivered was not changed": "Voicemail saved, but where its recordings are delivered was not changed",
    "Withheld number": "Withheld number",
    "Not delivered": "Not delivered",
    "Transcript": "Transcript",
    "This conversation is closed. Reopen it to reply.": "This conversation is closed. Reopen it to reply.",
    "Voicemails can't be answered here. Call the caller back.": "Voicemails can't be answered here. Call the caller back.",
    "Voicemails can't be answered here, and this caller's number was withheld.": "Voicemails can't be answered here, and this caller's number was withheld.",
    "Confirmation link sent to {email}": "Confirmation link sent to {email}",
    "The new email is pending, but the confirmation link could not be sent. Use Resend Verification Link in a minute.": "The new email is pending, but the confirmation link could not be sent. Use Resend Verification Link in a minute.",
    "There is no pending email change for this user.": "There is no pending email change for this user.",
    "Confirm new email": "Confirm new email",
    "Click the button below to confirm your new email address.": "Click the button below to confirm your new email address.",
    "Your email has been changed. You can now sign in with {email}.": "Your email has been changed. You can now sign in with {email}.",
    "This email was already confirmed. You can sign in with {email}.": "This email was already confirmed. You can sign in with {email}.",
    "This confirmation link has expired. Ask your administrator to send a new one.": "This confirmation link has expired. Ask your administrator to send a new one.",
    "This confirmation link has already been used.": "This confirmation link has already been used.",
    "This confirmation link is no longer valid.": "This confirmation link is no longer valid.",
    "A confirmation email was sent recently. Save the new email again in a minute.": "A confirmation email was sent recently. Save the new email again in a minute.",
    "The pending email change was cancelled.": "The pending email change was cancelled.",
    "We could not confirm your email right now. Your link may still work, so try again.": "We could not confirm your email right now. Your link may still work, so try again.",
    "Time-based (TOTP), SHA1, 6 digits, 30 seconds": "Time-based (TOTP), SHA1, 6 digits, 30 seconds",
    "Available once the invitation is accepted": "Available once the invitation is accepted",
    "The user's email is not verified, so it cannot be used for 2FA": "The user's email is not verified, so it cannot be used for 2FA",
    "2FA cannot be turned on: the user has no verified method": "2FA cannot be turned on: the user has no verified method",
    "We couldn't send the code by email. Please try again.": "We couldn't send the code by email. Please try again.",
    "Always sent to the account owner: {email}": "Always sent to the account owner: {email}",
    "The following numbers are already registered under another campaign: {numbers}": "The following numbers are already registered under another campaign: {numbers}",
    "Some of the selected numbers are no longer available. Please pick again.": "Some of the selected numbers are no longer available. Please pick again.",
    "In review": "In review",
    "Deactivate": "Deactivate",
    "Choose how many messages you expect to send": "Choose how many messages you expect to send",
    "{price} per month": "{price} per month",
    "Low volume": "Low volume",
    "High volume": "High volume",
    "How many messages do you expect to send?": "How many messages do you expect to send?",
    "A2P registration is not part of your current plan. Contact sales to add it.": "A2P registration is not part of your current plan. Contact sales to add it.",
    "This campaign can no longer be edited": "This campaign can no longer be edited",
    "Your brand is registered with the carriers. Contact support to change it.": "Your brand is registered with the carriers. Contact support to change it.",
    "Your payment was declined. Update your payment method and try again.": "Your payment was declined. Update your payment method and try again.",
    "A2P registration needs an active subscription.": "A2P registration needs an active subscription.",
    "A2P registration is not enabled for this account yet. Contact support.": "A2P registration is not enabled for this account yet. Contact support.",
    "Campaign deactivated": "Campaign deactivated",
    "Failed to deactivate campaign": "Failed to deactivate campaign",
    "{count} waiting for assignment": "{count} waiting for assignment",
    "waiting for assignment": "waiting for assignment",
    "Deactivate campaign": "Deactivate campaign",
    "Billing stops and its numbers can no longer text US recipients. This cannot be undone: you would have to register again.": "Billing stops and its numbers can no longer text US recipients. This cannot be undone: you would have to register again.",
    "Submitted": "Submitted",
    "Stopped because of a billing problem on our side. Contact support.": "Stopped because of a billing problem on our side. Contact support.",
    "Stopped because the account was closed.": "Stopped because the account was closed.",
    "Stopped because your subscription ended.": "Stopped because your subscription ended.",
    "Stopped by you.": "Stopped by you.",
    "Manage numbers": "Manage numbers",
    "Numbers updated": "Numbers updated",
    "Added numbers wait for support to assign them before they can text US recipients. Removed numbers stop sending at once.": "Added numbers wait for support to assign them before they can text US recipients. Removed numbers stop sending at once.",
    "This number isn't available for registration yet. Contact support to add it to your account.": "This number isn't available for registration yet. Contact support to add it to your account.",
    "The volume tier is fixed after the first submit. Contact support to change it.": "The volume tier is fixed after the first submit. Contact support to change it.",
    "{price} per year": "{price} per year",
    "Not available on your plan": "Not available on your plan",
    "We couldn't load the prices. Retry to see them before you submit.": "We couldn't load the prices. Retry to see them before you submit.",
    "Note from support": "Note from support",
    "This registration is already being submitted. Try again in a few minutes.": "This registration is already being submitted. Try again in a few minutes.",
    "SMS registration is unavailable while your account is restricted. Contact support.": "SMS registration is unavailable while your account is restricted. Contact support.",
    "Billing refused this registration. Contact support.": "Billing refused this registration. Contact support.",
    "The volume tier changed since the price was shown. Check the price and submit again.": "The volume tier changed since the price was shown. Check the price and submit again.",
    "Campaign actions": "Campaign actions",
    "Your account's billing country isn't confirmed yet. Contact support to confirm it.": "Your account's billing country isn't confirmed yet. Contact support to confirm it.",
    "Up to 15,000 messages a month": "Up to 15,000 messages a month",
    "More than 15,000 messages a month": "More than 15,000 messages a month",
    "Due when you submit": "Due when you submit",
    "Brand registration {brand} and vetting {vetting}": "Brand registration {brand} and vetting {vetting}",
    "Vetting {vetting}. Your brand is already registered.": "Vetting {vetting}. Your brand is already registered.",
    "When approved, the first {months} months up front": "When approved, the first {months} months up front",
    "After that, renewed with your plan": "After that, renewed with your plan",
    "These are the carrier's fees and are not refunded, even when a registration is rejected. Resubmitting pays the vetting again.": "These are the carrier's fees and are not refunded, even when a registration is rejected. Resubmitting pays the vetting again.",
    "Your balance doesn't cover the submission fees. Top up and submit again.": "Your balance doesn't cover the submission fees. Top up and submit again.",
    "Add a payment method to your plan, then submit again.": "Add a payment method to your plan, then submit again.",
    "Charged to your plan's payment method, plus tax where it applies.": "Charged to your plan's payment method, plus tax where it applies.",
    "The submission fees changed since they were shown. Check them and submit again.": "The submission fees changed since they were shown. Check them and submit again.",
    "{numbers} can no longer stay on this registration and will be removed when you save.": "{numbers} can no longer stay on this registration and will be removed when you save.",
    "This account signs in with a different provider. Use that one, or choose Forgot Password to set a password.": "This account signs in with a different provider. Use that one, or choose Forgot Password to set a password.",
    "SSO authentication is disabled.": "SSO authentication is disabled.",
    "Connect your {provider} account": "Connect your {provider} account",
    "This email already has an account. Enter your password to connect": "This email already has an account. Enter your password to connect",
    "Incorrect password. Please try again.": "Incorrect password. Please try again.",
    "Connect and log in": "Connect and log in",
    "Call Details": "Call Details",
    "Call ended": "Call ended",
    "Call flow started": "Call flow started",
    "Call rejected": "Call rejected",
    "Could not load the call steps": "Could not load the call steps",
    "Flow finished": "Flow finished",
    "Hung up": "Hung up",
    "Joined conference": "Joined conference",
    "No steps were recorded for this call": "No steps were recorded for this call",
    "Played announcement": "Played announcement",
    "Queue option": "Queue option",
    "Recording": "Recording",
    "Routed": "Routed",
    "Routed to call flow": "Routed to call flow",
    "Sent to device": "Sent to device",
    "Sent to queue": "Sent to queue",
    "Step": "Step",
    "Virtual hold": "Virtual hold",
    "Waited for keypad input": "Waited for keypad input",
    "Keypad input": "Keypad input",
    "Caller hung up": "Caller hung up",
    "The user has been signed out": "The user has been signed out",
    "Users will be signed out": "{count, plural, one {# user was signed out} other {# users were signed out}}.",
    "Users could not be signed out": "{count, plural, one {# user} other {# users}} could not be signed out. Try again.",
    "An administrator signed you out": "An administrator signed you out",
    "The email was not changed because the user was deactivated.": "The email was not changed because the user was deactivated.",
    "Open the confirmation link from your email again.": "Open the confirmation link from your email again.",
    "Your password has expired": "Your password has expired",
    "Sign in to choose a new one": "Sign in to choose a new one",
    "Choose a new password to continue": "Choose a new password to continue.",
    "Sign in with the account for {email}.": "Sign in with the account for {email}.",
    "Your organization has no free seats. Contact your administrator.": "Your organization has no free seats. Contact your administrator.",
    "This email already has an account. Please log in.": "This email already has an account. Please log in.",
    "Something went wrong. Please try again.": "Something went wrong. Please try again.",
    "Your organization has no active subscription. Contact your administrator.": "Your organization has no active subscription. Contact your administrator.",
    "We couldn't check your organization's seats. Please try again in a few minutes.": "We couldn't check your organization's seats. Please try again in a few minutes.",
    "Delete this integration? Its API keys stop working at once.": "Delete this integration? Its API keys stop working at once.",
    "On save the API key is revoked and requests using it are refused.": "On save the API key is revoked and requests using it are refused.",
    "Show key": "Show key",
    "Hide key": "Hide key",
    "Regenerate API key": "Regenerate API key",
    "Refuse": "Refuse",
    "The browser session dials phone numbers only.": "The browser session dials phone numbers only.",
    "This key can't be shown. Regenerate to get a new one.": "This key can't be shown. Regenerate to get a new one.",
    "A new key replaces this integration's keys, which keep working until you save.": "A new key replaces this integration's keys, which keep working until you save.",
    "The new key could not be saved, so a new one is shown. Copy it again, then save.": "The new key could not be saved, so a new one is shown. Copy it again, then save.",
    "Agent keys made through the API are revoked too when a new key is saved or the API is turned off.": "Agent keys made through the API are revoked too when a new key is saved or the API is turned off.",
    "Recommended: allow only the IP addresses your clicks come from, so a leaked key cannot be used elsewhere. A link the CRM opens in the agent's browser comes from your office's public IP.": "Recommended: allow only the IP addresses your clicks come from, so a leaked key cannot be used elsewhere. A link the CRM opens in the agent's browser comes from your office's public IP.",
    "Select users to remove": "Select users to remove",
    "Pick {count} users to remove. They are deactivated on the next billing date.": "Pick {count} users to remove. They are deactivated on the next billing date.",
    "Remove {name}": "Remove {name}",
    "Account Owner": "Account Owner",
    "Loading users…": "Loading users…",
    "{picked} of {count} selected": "{picked} of {count} selected",
    "Your card was declined. The seat count has not changed.": "Your card was declined. The seat count has not changed.",
    "Trial seat limit reached. Start your paid plan to add more users.": "Trial seat limit reached. Start your paid plan to add more users.",
    "Another plan change is still being processed. Please try again in a moment.": "Another plan change is still being processed. Please try again in a moment.",
    "Pick which users to remove before lowering the seats.": "Pick which users to remove before lowering the seats.",
    "Seat change scheduled": "Seat change scheduled",
    "Seat change scheduled for {date}.": "Seat change scheduled for {date}.",
    "Review seat change": "Review seat change",
    "Users removed on the billing date": "Users removed on the billing date",
    "{plan} requires at least {min} seats.": "{plan} requires at least {min} seats.",
    "You have {count} users. Next, you'll choose who to remove.": "You have {count} users. Next, you'll choose who to remove.",
    "{plan} includes a minimum of {min} seats. You're using {used}, so {free} are free to assign.": "{plan} includes a minimum of {min} seats. You're using {used}, so {free} are free to assign.",
    "Cancel the scheduled seat change?": "Cancel the scheduled seat change?",
    "You keep your {count} seats and nobody is removed.": "You keep your {count} seats and nobody is removed.",
    "Undo change": "Undo change",
    "Seat change cancelled. You keep {count} seats.": "Seat change cancelled. You keep {count} seats.",
    "Scheduled changes": "Scheduled changes",
    "Seats {from} → {to}": "Seats {from} → {to}",
    "{count} seats scheduled for removal on {date}": "{count} seats scheduled for removal on {date}",
    "Leaving": "Leaving",
    "Undo": "Undo",
    "Your {plan} plan has started": "Your {plan} plan has started",
    "You can now add more users.": "You can now add more users.",
    "We couldn't start your paid plan. Your trial is unchanged.": "We couldn't start your paid plan. Your trial is unchanged.",
    "Not now": "Not now",
    "Start {plan} plan": "Start {plan} plan",
    "Start your {plan} plan": "Start your {plan} plan",
    "Plan": "Plan",
    "Trial seat limit reached. Free trials include up to {cap} users.": "Trial seat limit reached. Free trials include up to {cap} users.",
    "Start paid plan now": "Start paid plan now",
    "Trial": "Trial",
    "Trial ends on {date}": "Trial ends on {date}",
    "Free trial": "Free trial",
    "{count} trial seats left after this invite": "{count} trial seats left after this invite",
    "This invitation has expired. Ask your administrator to send a new one.": "This invitation has expired. Ask your administrator to send a new one.",
    "This invitation was already accepted. Log in with your email and password instead.": "This invitation was already accepted. Log in with your email and password instead.",
    "This invitation was revoked. Ask your administrator to send a new one.": "This invitation was revoked. Ask your administrator to send a new one.",
    "That invitation no longer exists. Ask your administrator to send a new one.": "That invitation no longer exists. Ask your administrator to send a new one.",
    "This billing cycle is being charged right now. Please try again in a few minutes.": "This billing cycle is being charged right now. Please try again in a few minutes.",
    "Your wallet balance is too low for this change. Top up and try again.": "Your wallet balance is too low for this change. Top up and try again.",
    "That is below your plan's minimum number of seats.": "That is below your plan's minimum number of seats.",
    "One of the picked users can't be removed. Close this window and pick again.": "One of the picked users can't be removed. Close this window and pick again.",
    "Users removed now": "Users removed now",
    "Your card was declined. Your trial is unchanged.": "Your card was declined. Your trial is unchanged.",
    "Your paid plan has already started.": "Your paid plan has already started.",
    "Your paid plan has already started. Check your seats in Manage Seats.": "Your paid plan has already started. Check your seats in Manage Seats.",
    "We couldn't confirm your payment. Check your plan in a few minutes before you try again.": "We couldn't confirm your payment. Check your plan in a few minutes before you try again.",
    "Plus tax and any one-time fees.": "Plus tax and any one-time fees.",
    "Your organization has reached its free trial user limit. Contact your administrator.": "Your organization has reached its free trial user limit. Contact your administrator.",
    "Every node must be connected to the phone number": "Every node must be connected to the phone number",
    "This destination is not allowed here": "This destination is not allowed here",
    "An output can only go to one destination": "An output can only go to one destination",
    "Choose a destination": "Choose a destination",
    "A node cannot point to itself": "A node cannot point to itself",
    "Too many outputs on this node": "Too many outputs on this node",
    "A phone number or extension can only start a flow, not be a step in it": "A phone number or extension can only start a flow, not be a step in it",
    "This output does not exist on this node": "This output does not exist on this node",
    "A connection starts from a node that is not in the flow": "A connection starts from a node that is not in the flow",
    "A node could not be identified. Reload and try again.": "A node could not be identified. Reload and try again.",
    "A destination no longer exists. Pick another one.": "A destination no longer exists. Pick another one.",
    "This flow was changed elsewhere since you opened it. Reload to get the latest version.": "This flow was changed elsewhere since you opened it. Reload to get the latest version.",
    "This number/extension already starts another flow": "This number/extension already starts another flow",
    "These extension digits are already in use": "These extension digits are already in use",
    "This item is in use elsewhere, so this change is not allowed": "This item is in use elsewhere, so this change is not allowed",
    "This change conflicts with the current routing. Reload and try again.": "This change conflicts with the current routing. Reload and try again.",
    "You don't have permission to change this flow": "You don't have permission to change this flow",
    "This node could not be loaded, so saving could change its routing. Reload and try again.": "This node could not be loaded, so saving could change its routing. Reload and try again.",
    "Choose a phone number or extension to start the flow": "Choose a phone number or extension to start the flow",
    "This flow already starts at another number or extension. Put it back to save.": "This flow already starts at another number or extension. Put it back to save.",
    "The flow could not be saved. Try again.": "The flow could not be saved. Try again.",
    "The flow is saved, but its new name is not. Try again.": "The flow is saved, but its new name is not. Try again.",
    "{node} could not be saved: {detail}": "{node} could not be saved: {detail}",
    "The flow could not be saved: {detail}": "The flow could not be saved: {detail}",
    "You don't have permission to change {node}": "You don't have permission to change {node}",
    "This could not be loaded. Try again.": "This could not be loaded. Try again.",
    "Regenerate password": "Regenerate password",
    "Choose Existing Queue": "Choose Existing Queue",
    "How long a caller waits before the Timeout destination": "How long a caller waits before the Timeout destination",
    "When this many callers are waiting, the next one goes to the Queue full destination": "When this many callers are waiting, the next one goes to the Queue full destination",
    "A caller whose estimated wait is longer goes to the Wait too long destination instead of waiting": "A caller whose estimated wait is longer goes to the Wait too long destination instead of waiting",
    "Keys used by other queue options: {keys}": "Keys used by other queue options: {keys}",
    "This key is used by another queue option": "This key is used by another queue option",
    "A queue key can only hang up without a reason": "A queue key can only hang up without a reason",
    "Could not load the inputs from other flows": "Could not load the inputs from other flows",
    "DND ON": "DND ON",
    "An unset Busy/DND or No Answer goes to the user's voicemail.": "An unset Busy/DND or No Answer goes to the user's voicemail.",
    "An unset Busy/DND or No Answer hangs up.": "An unset Busy/DND or No Answer hangs up.",
    "Queue full needs a caller limit, set on the Call queue screen": "Queue full needs a caller limit, set on the Call queue screen",
    "Wait too long needs an estimated-wait limit, set on the Call queue screen": "Wait too long needs an estimated-wait limit, set on the Call queue screen",
    "The flow is saved, but this user's settings were not: the user has no account in the app": "The flow is saved, but this user's settings were not: the user has no account in the app",
    "The flow is saved, but the user's settings did not reach the phone system. Try again.": "The flow is saved, but the user's settings did not reach the phone system. Try again.",
    "{name} on {date}": "{name} on {date}",
    "Annual invoice": "Annual invoice",
    "Cancel the scheduled plan change?": "Cancel the scheduled plan change?",
    "Confirm change": "Confirm change",
    "Confirm changes": "Confirm changes",
    "Confirm plan change": "Confirm plan change",
    "Contact sales": "Contact sales",
    "Current plan": "Current plan",
    "Downgrade": "Downgrade",
    "Downgrade cancelled. You stay on {plan}.": "Downgrade cancelled. You stay on {plan}.",
    "Downgrade to {plan}": "Downgrade to {plan}",
    "Free during your trial · You'll be charged {amount} on {date}": "Free during your trial · You'll be charged {amount} on {date}",
    "Free trials include up to {cap} users.": "Free trials include up to {cap} users.",
    "No refund": "No refund",
    "Plan changed to {plan} · {seats} seats · {total} / {period}.": "Plan changed to {plan} · {seats} seats · {total} / {period}.",
    "Seats drop to {count} on your next billing date": "Seats drop to {count} on your next billing date",
    "Switch to monthly": "Switch to monthly",
    "Switch to yearly": "Switch to yearly",
    "Takes effect on {date}": "Takes effect on {date}",
    "Takes effect today": "Takes effect today",
    "These changes take effect on {date}, your next billing date.": "These changes take effect on {date}, your next billing date.",
    "Year": "Year",
    "You stay on {plan}.": "You stay on {plan}.",
    "You're now on {plan}. Your trial continues until {date}.": "You're now on {plan}. Your trial continues until {date}.",
    "You're using {count} seats. Deactivate users to go lower.": "You're using {count} seats. Deactivate users to go lower.",
    "Your plan changed, but the seat count could not be lowered. Try Manage Seats.": "Your plan changed, but the seat count could not be lowered. Try Manage Seats.",
    "Your plan changes to {plan} on {date}.": "Your plan changes to {plan} on {date}.",
    "{amount} charged now (prorated)": "{amount} charged now (prorated)",
    "{count} seats ({plan} minimum)": "{count} seats ({plan} minimum)",
    "{plan} includes a minimum of {min} seats. You'll be billed for {seats} seats; you're using {used}, so {free} are free to assign.": "{plan} includes a minimum of {min} seats. You'll be billed for {seats} seats; you're using {used}, so {free} are free to assign.",
    "{price} / user / {period}": "{price} / user / {period}",
    "To upgrade, stay on yearly billing. You can switch to monthly at the end of your term.": "To upgrade, stay on yearly billing. You can switch to monthly at the end of your term.",
    "Your billing period can't change while phone numbers are billed on this plan. Contact support.": "Your billing period can't change while phone numbers are billed on this plan. Contact support.",
    "ticket created without number": "Great! I’ve created your support ticket. Our team will get back to you as soon as we have an update. Please keep an eye on your inbox",
    "Locked": "Locked",
    "Resume subscription": "Resume subscription",
    "We couldn't resume your subscription. Please try again.": "We couldn't resume your subscription. Please try again.",
    "WhatsApp needs an active subscription": "WhatsApp needs an active subscription",
    "{plan} has no WhatsApp. These numbers are disconnected on the change date: {numbers}": "{plan} has no WhatsApp. These numbers are disconnected on the change date: {numbers}",
    "WhatsApp switched off": "WhatsApp switched off",
    "Plan change cancelled. You stay on your current plan.": "Plan change cancelled. You stay on your current plan.",
    "WhatsApp isn't on your next plan": "WhatsApp isn't on your next plan",
    "Your plan is set to change to one without WhatsApp. Keep your current plan to connect WhatsApp.": "Your plan is set to change to one without WhatsApp. Keep your current plan to connect WhatsApp.",
    "Your scheduled plan has no WhatsApp. Undo the plan change to connect WhatsApp.": "Your scheduled plan has no WhatsApp. Undo the plan change to connect WhatsApp.",
    "Your subscription is set to cancel. Resume it to connect WhatsApp.": "Your subscription is set to cancel. Resume it to connect WhatsApp.",
    "Your subscription will continue.": "Your subscription will continue.",
    "Cancellation scheduled. Your plan ends on {date}.": "Cancellation scheduled. Your plan ends on {date}.",
    "Go back": "Go back",
    "Keep subscription": "Keep subscription",
    "Keep your subscription?": "Keep your subscription?",
    "Minimum {count} characters.": "Minimum {count} characters.",
    "Please tell us more": "Please tell us more",
    "Select a reason": "Select a reason",
    "Type CANCEL to confirm": "Type CANCEL to confirm",
    "Undo cancellation": "Undo cancellation",
    "We couldn't cancel your subscription. Please try again.": "We couldn't cancel your subscription. Please try again.",
    "What's the main reason for cancelling?": "What's the main reason for cancelling?",
    "Your cancellation is scheduled for {date}.": "Your cancellation is scheduled for {date}.",
    "Your plan stays active until {date}. No refunds are given for the current billing period.": "Your plan stays active until {date}. No refunds are given for the current billing period.",
    "Your team loses access to calls, messages and the app.": "Your team loses access to calls, messages and the app.",
    "Your {plan} plan will continue and renew on {date}. Scheduled changes you had before cancelling are not restored.": "Your {plan} plan will continue and renew on {date}. Scheduled changes you had before cancelling are not restored.",
    "Too expensive": "Too expensive",
    "Missing a feature we need": "Missing a feature we need",
    "Call quality or reliability issues": "Call quality or reliability issues",
    "Switching to another provider": "Switching to another provider",
    "Too difficult to set up or use": "Too difficult to set up or use",
    "We no longer need a phone system": "We no longer need a phone system",
    "No contacts left to call. Every number in the call list was already dialed or skipped": "No contacts left to call. Every number in the call list was already dialed or skipped",
    "Wrong number": "Wrong number",
    "Network error": "Network error",
    "On the Do Not Call list": "On the Do Not Call list",
    "The flow is saved, but you don't have permission to change this user's settings": "The flow is saved, but you don't have permission to change this user's settings",
    "The flow is saved, but the user's settings could not be saved. Try again.": "The flow is saved, but the user's settings could not be saved. Try again.",
    "Your account closes now. You won't be charged.": "Your account closes now. You won't be charged.",
    "Users can't sign in. Calls and messages stop.": "Users can't sign in. Calls and messages stop.",
    "Numbers are held for 30 days, then released.": "Numbers are held for 30 days, then released.",
    "Data is deleted after 30 days.": "Data is deleted after 30 days.",
    "Your trial has already ended.": "Your trial has already ended.",
    "We couldn't end your trial. Please try again.": "We couldn't end your trial. Please try again.",
    "This account is closed. Ask the account owner to reactivate it.": "This account is closed. Ask the account owner to reactivate it.",
    "Your account is still closing. Please try again in a minute.": "Your account is still closing. Please try again in a minute.",
    "Your card was declined. Try another card. Your account is still closed.": "Your card was declined. Try another card. Your account is still closed.",
    "There's no card on file. Add a card to reactivate your account.": "There's no card on file. Add a card to reactivate your account.",
    "We couldn't reactivate your account. Please try again.": "We couldn't reactivate your account. Please try again.",
    "Account reactivated. Your {plan} plan has started.": "Account reactivated. Your {plan} plan has started.",
    "Cancelled": "Cancelled",
    "Reactivate account": "Reactivate account",
    "Account closed {closed} · Number held until {held}": "Account closed {closed} · Number held until {held}",
    "No upcoming invoice": "No upcoming invoice",
    "Reactivating starts your plan today and charges your saved card.": "Reactivating starts your plan today and charges your saved card.",
    "This account is closed. The account owner can sign in to reactivate it.": "This account is closed. The account owner can sign in to reactivate it.",
    "Not started": "Not started",
    "These changes take effect today.": "These changes take effect today.",
    "IVRs": "IVRs",
    "Call flows": "Call flows",
    "Web widgets": "Web widgets",
    "AI hours": "AI hours",
    "Choose what to keep": "Choose what to keep",
    "Turned off automatically": "Turned off automatically",
    "Settings that are turned off are kept, and come back on when you upgrade.": "Settings that are turned off are kept, and come back on when you upgrade.",
    "A wallboard can have at most {max} stats resets.": "A wallboard can have at most {max} stats resets.",
    "The server rejected these wallboard settings: {fields}": "The server rejected these wallboard settings: {fields}",
    "Texting campaigns": "Texting campaigns",
    "{plan} includes {count} texting campaigns. Choose what happens to each one.": "{plan} includes {count, plural, one {# texting campaign} other {# texting campaigns}}. Choose what happens to each one.",
    "What happens to {name}": "What happens to {name}",
    "Keep · included": "Keep · included",
    "Keep · {price}/mo": "Keep · {price}/mo",
    "Keep · paid": "Keep · paid",
    "Deregister": "Deregister",
    "WhatsApp numbers": "WhatsApp numbers",
    "Data at risk": "Data at risk",
    "These WhatsApp numbers stop receiving messages on the change date: {numbers}": "These WhatsApp numbers stop receiving messages on the change date: {numbers}",
    "Texting campaigns kept free: {count}": "Texting campaigns kept free: {count}",
    "Texting campaigns kept and paid: {count}": "Texting campaigns kept and paid: {count}",
    "Texting campaigns deregistered: {count}": "Texting campaigns deregistered: {count}",
    "WhatsApp numbers kept: {count}": "WhatsApp numbers kept: {count}",
    "WhatsApp numbers disconnected: {count}": "WhatsApp numbers disconnected: {count}",
    "Keep · {price}/yr": "Keep · {price}/yr",
    "We couldn't load your texting campaigns and WhatsApp numbers. Close this window and try again.": "We couldn't load your texting campaigns and WhatsApp numbers. Close this window and try again.",
    "Your texting campaigns or WhatsApp numbers changed. Close this window and try again.": "Your texting campaigns or WhatsApp numbers changed. Close this window and try again.",
    "Call flows {list} use this queue. Edit them before {when}.": "Call flows {list} use this queue. Edit them before {when}.",
    "Call queues are not available on the new plan.": "Call queues are not available on the new plan.",
    "Call queues redirected: {count}": "Call queues redirected: {count}",
    "Call recording becomes manual": "Call recording becomes manual",
    "Convert queues to ring groups": "Convert queues to ring groups",
    "Dialer campaigns are paused": "Dialer campaigns are paused",
    "Download recordings": "Download recordings",
    "I understand these routes will stop working": "I understand these routes will stop working",
    "IVR": "IVR",
    "Inbound · {route} → {trunk}": "Inbound · {route} → {trunk}",
    "Live wallboards turn off": "Live wallboards turn off",
    "New destination for {name}": "New destination for {name}",
    "Outbound · {route} → {trunk}": "Outbound · {route} → {trunk}",
    "Recordings kept for {months} months": "Recordings kept for {months} months",
    "Recordings older than {months} months become read-only on {when} and are deleted 30 days later.": "Recordings older than {months} months become read-only on {when} and are deleted 30 days later.",
    "Redirect calls": "Redirect calls",
    "Ring group": "Ring group",
    "Ring group with the same agents": "Ring group with the same agents",
    "SIP trunks stop working on {when}.": "SIP trunks stop working on {when}.",
    "SIP trunks switched off": "SIP trunks switched off",
    "SMS to email turns off": "SMS to email turns off",
    "Sticky agent, skill-based routing and call barging turn off": "Sticky agent, skill-based routing and call barging turn off",
    "Used by {list}": "Used by {list}",
    "Web widget is removed": "Web widget is removed",
    "Web widget: chat is removed, calls only": "Web widget: chat is removed, calls only",
    "WhatsApp inbox turns off": "WhatsApp inbox turns off",
    "Whisper turns off": "Whisper turns off",
    "today": "today",
    "Auto Top-up saved. Your card was charged {amount}.": "Auto Top-up saved. Your card was charged {amount}.",
    "Your balance is below {threshold}, so your card will be charged {amount} now. Then it tops up whenever the balance falls below {threshold}.": "Your balance is below {threshold}, so your card will be charged {amount} now. Then it tops up whenever the balance falls below {threshold}.",
    "Save and top up": "Save and top up",
    "The card was not charged, so auto top-up was not saved. Check your card and try again.": "The card was not charged, so auto top-up was not saved. Check your card and try again.",
    "We couldn't confirm whether your card was charged. Check your balance before trying again.": "We couldn't confirm whether your card was charged. Check your balance before trying again.",
    "Complete the card verification, then save auto top-up again.": "Complete the card verification, then save auto top-up again.",
    "Payment received. Once your balance updates, save auto top-up again.": "Payment received. Once your balance updates, save auto top-up again.",
    "Your card was charged {amount}, but auto top-up was not saved. Save it again.": "Your card was charged {amount}, but auto top-up was not saved. Save it again.",
    "Your balance could not be loaded. Try again in a moment.": "Your balance could not be loaded. Try again in a moment.",
    "Only someone who can manage call queues can make this change.": "Only someone who can manage call queues can make this change.",
    "We couldn't load your call queues and SIP trunks.": "We couldn't load your call queues and SIP trunks.",
    "We couldn't check which call flows use this queue.": "We couldn't check which call flows use this queue.",
    "Your call queues or SIP trunks changed. Close this window and try again.": "Your call queues or SIP trunks changed. Close this window and try again.",
    "Back to your account": "Back to your account",
    "Your account's data was deleted 30 days after it closed. Sign up again to start over.": "Your account's data was deleted 30 days after it closed. Sign up again to start over.",
    "Your data was deleted": "Your data was deleted",
    "Your data": "Your data",
    "You can view and download your call logs, recordings and reports until {date}. After that they are deleted for good.": "You can view and download your call logs, recordings and reports until {date}. After that they are deleted for good.",
    "Logging out in {seconds}s": "Logging out in {seconds}s",
    "Your account signs in with Google or Microsoft. Set a password to also log in with your email.": "Your account signs in with Google or Microsoft. Set a password to also log in with your email.",
    "Set a password": "Set a password",
    "Check your email": "Check your email",
    "We've emailed you a link to set your password.": "We've emailed you a link to set your password.",
    "Link sent": "Link sent",
    "Download your invoices before then too. After that, email support@pbx.im for a copy.": "Download your invoices before then too. After that, email support@pbx.im for a copy.",
    "Need an invoice? Email support@pbx.im for a copy.": "Need an invoice? Email support@pbx.im for a copy.",
    "Could not change the password": "Could not change the password",
    "Change your own password from your Profile page": "Change your own password from your Profile page",
    "This user is deactivated": "This user is deactivated",
    "Set user password intro": "Choose a new password for {name} and share it with them securely. Their current password stops working.",
    "This Google or Microsoft account is already connected to a PBX account. Sign in instead.": "This Google or Microsoft account is already connected to a PBX account. Sign in instead.",
    "Your account was created. Please sign in.": "Your account was created. Please sign in.",
    "This node is deactivated. Calls routed to it won't go through.": "This node is deactivated. Calls routed to it won't go through.",
    "SMS isn't active on this number yet": "SMS isn't active on this number yet",
    "You don't have permission to change the linked inbox": "You don't have permission to change the linked inbox",
    "You're not allowed to send from this number": "You're not allowed to send from this number",
    "You're not a member of this inbox": "You're not a member of this inbox",
    "This number is no longer available for messaging": "This number is no longer available for messaging",
    "This number is routed to another inbox": "This number is routed to another inbox",
    "Could not load SMS settings": "Could not load SMS settings",
    "This message is too long to send": "This message is too long to send",
    "Attempted": "Attempted",
    "Could not load your numbers": "Could not load your numbers",
    "Busy/DND": "Busy/DND",
    "A number changed while syncing. Run Sync Numbers again.": "A number changed while syncing. Run Sync Numbers again.",
    "Could not import the message templates. Run Sync Templates to try again.": "Could not import the message templates. Run Sync Templates to try again.",
    "Could not read the WhatsApp Business Account details from Meta: {reason}": "Could not read the WhatsApp Business Account details from Meta: {reason}",
    "Could not read the phone numbers from Meta. Run Sync Numbers to try again.": "Could not read the phone numbers from Meta. Run Sync Numbers to try again.",
    "Could not refresh the number status from Meta. Run Sync Numbers to update it.": "Could not refresh the number status from Meta. Run Sync Numbers to update it.",
    "Could not subscribe to Meta webhooks, so template status updates will not arrive. Disconnect and connect again to retry.": "Could not subscribe to Meta webhooks, so template status updates will not arrive. Disconnect and connect again to retry.",
    "Could not unsubscribe from Meta webhooks: {reason}": "Could not unsubscribe from Meta webhooks: {reason}",
    "Failed to complete WhatsApp connection.": "Failed to complete WhatsApp connection.",
    "Failed to disconnect the WhatsApp Business Account. Please try again.": "Failed to disconnect the WhatsApp Business Account. Please try again.",
    "Failed to start the WhatsApp connection. Please try again.": "Failed to start the WhatsApp connection. Please try again.",
    "Failed to sync WhatsApp numbers. Please try again.": "Failed to sync WhatsApp numbers. Please try again.",
    "Failed to sync WhatsApp templates. Please try again.": "Failed to sync WhatsApp templates. Please try again.",
    "Failed to update the assignment. Please try again.": "Failed to update the assignment. Please try again.",
    "Meta could not complete the sign-in. Please try again.": "Meta could not complete the sign-in. Please try again.",
    "Meta could not complete the sign-in: {reason}": "Meta could not complete the sign-in: {reason}",
    "Meta is limiting requests right now. Try again in a few minutes.": "Meta is limiting requests right now. Try again in a few minutes.",
    "Meta is not responding right now. Try again later.": "Meta is not responding right now. Try again later.",
    "Meta rejected the request.": "Meta rejected the request.",
    "Meta rejected the request: {reason}": "Meta rejected the request: {reason}",
    "No WhatsApp Business Account is connected. Connect one first.": "No WhatsApp Business Account is connected. Connect one first.",
    "No WhatsApp Business Account was shared. In the Meta window, select a WhatsApp Business Account and try again.": "No WhatsApp Business Account was shared. In the Meta window, select a WhatsApp Business Account and try again.",
    "Not all numbers could be read from Meta, so some may be out of date. Run Sync Numbers again.": "Not all numbers could be read from Meta, so some may be out of date. Run Sync Numbers again.",
    "Not all templates could be read from Meta. Run Sync Templates to finish importing them.": "Not all templates could be read from Meta. Run Sync Templates to finish importing them.",
    "Number {number} cannot send messages yet because its ownership is not verified. Verify it in WhatsApp Manager, then run Sync Numbers.": "Number {number} cannot send messages yet because its ownership is not verified. Verify it in WhatsApp Manager, then run Sync Numbers.",
    "Number {number} cannot send messages yet because its ownership verification has expired. Verify it again in WhatsApp Manager, then run Sync Numbers.": "Number {number} cannot send messages yet because its ownership verification has expired. Verify it again in WhatsApp Manager, then run Sync Numbers.",
    "Number {number} could not be registered for sending because Meta blocked it after too many attempts. Try again in 72 hours.": "Number {number} could not be registered for sending because Meta blocked it after too many attempts. Try again in 72 hours.",
    "Number {number} could not be registered for sending because its two-step verification PIN does not match. Contact support.": "Number {number} could not be registered for sending because its two-step verification PIN does not match. Contact support.",
    "Number {number} isn't ready to send messages yet. Check it in WhatsApp Manager, wait a few minutes, then run Sync Numbers.": "Number {number} isn't ready to send messages yet. Check it in WhatsApp Manager, wait a few minutes, then run Sync Numbers.",
    "Number {number} could not be synced: {reason}": "Number {number} could not be synced: {reason}",
    "Number {number} is already connected to another PBX.IM account. Disconnect it there first, then run Sync Numbers.": "Number {number} is already connected to another PBX.IM account. Disconnect it there first, then run Sync Numbers.",
    "Numbers were not registered for sending because the registration PIN is not configured. Contact support.": "Numbers were not registered for sending because the registration PIN is not configured. Contact support.",
    "One of the selected users no longer exists.": "One of the selected users no longer exists.",
    "The WhatsApp sign-in expired or was already used. Please try again.": "The WhatsApp sign-in expired or was already used. Please try again.",
    "The connection to WhatsApp has expired. Disconnect and connect again.": "The connection to WhatsApp has expired. Disconnect and connect again.",
    "The sign-in window was blocked. Allow pop-ups for this site and try again.": "The sign-in window was blocked. Allow pop-ups for this site and try again.",
    "This WhatsApp Business Account is already being connected. Wait a moment, then refresh the page.": "This WhatsApp Business Account is already being connected. Wait a moment, then refresh the page.",
    "This WhatsApp Business Account is already connected to another PBX.IM account. Disconnect it there first, then try again.": "This WhatsApp Business Account is already connected to another PBX.IM account. Disconnect it there first, then try again.",
    "This WhatsApp sign-in was started from a different account. Please try again from this account.": "This WhatsApp sign-in was started from a different account. Please try again from this account.",
    "This account already has a different WhatsApp Business Account connected. Disconnect it first, then try again.": "This account already has a different WhatsApp Business Account connected. Disconnect it first, then try again.",
    "WhatsApp Business Account {ids} is already connected to another PBX.IM account, so it was not connected here.": "WhatsApp Business Account {ids} is already connected to another PBX.IM account, so it was not connected here.",
    "WhatsApp is not configured on this environment.": "WhatsApp is not configured on this environment.",
    "{count} number(s) are no longer on this WhatsApp Business Account and were removed.": "{count} number(s) are no longer on this WhatsApp Business Account and were removed.",
    "Voicemail delete timeout exit hint": "Calls to {names} forward here. To change this, go to Settings > Users > Edit User > Call Handling.",
    "Voicemail delete kept missed-call hint": "{names} still use this as their old missed-call voicemail, and no screen clears that yet. Contact support to remove it.",
    "Archiving this inbox unroutes": "Archiving this inbox unroutes {items}. They deliver to nobody until you route them again, and unarchiving does not restore them.",
    "Name deactivated": "{name} (deactivated)",
    "Where this voicemail delivers could not be loaded.": "Where this voicemail delivers could not be loaded.",
    "Where these voicemails deliver could not be loaded, so Type and Destination read Unknown.": "Where these voicemails deliver could not be loaded, so Type and Destination read Unknown.",
    "Missed-call voicemail": "Missed-call voicemail",
    "The selected voicemail no longer exists": "The selected voicemail no longer exists",
    "This user has no phone account": "This user has no phone account",
    "Too many changes at once. Try again in a minute": "Too many changes at once. Try again in a minute",
    "Name archived": "{name} (archived)",
    "Unrecognised route": "Unrecognised route",
    "This account has too many inboxes to show where voicemails deliver, so Type and Destination read Unknown.": "This account has too many inboxes to show where voicemails deliver, so Type and Destination read Unknown.",
    "Destinations were not searched, only names and emails.": "Destinations were not searched, only names and emails.",
    "Filtering by Type is unavailable right now, so all voicemails are shown.": "Filtering by Type is unavailable right now, so all voicemails are shown.",
    "People's names are not searched without permission to view users.": "People's names are not searched without permission to view users.",
    "You are about to leave this group.": "You are about to leave this group.",
    "The flow is saved, but the voicemail's owner was not changed. Try again.": "The flow is saved, but the voicemail's owner was not changed. Try again.",
    "Account balance too low — contact your administrator": "Account balance too low — contact your administrator",
    "This person opted out of your messages.": "This person opted out of your messages.",
    "This number can't receive texts. Check the number.": "This number can't receive texts. Check the number.",
    "Texts from this number can't carry attachments.": "Texts from this number can't carry attachments.",
    "This message could not be sent.": "This message could not be sent.",
    "Change Plan": "Change Plan",
    "{count} seats have been added to your account.": "{count, plural, one {# seat has been added to your account.} other {# seats have been added to your account.}}",
    "{count} seats will be removed on {date}.": "{count, plural, one {# seat will be removed on {date}.} other {# seats will be removed on {date}.}}",
    "{count} seats have been removed from your account.": "{count, plural, one {# seat has been removed from your account.} other {# seats have been removed from your account.}}",
    "Seats Changed Successfully": "Seats Changed Successfully",
    "Remove Users To Decrease Seats": "Remove Users To Decrease Seats",
    "More than {cap} seats starts your paid plan.": "More than {cap} seats starts your paid plan.",
    "To decrease the seats <b>{count}</b> users need to be removed.": "{count, plural, one {To decrease the seats <b>#</b> user needs to be removed.} other {To decrease the seats <b>#</b> users need to be removed.}}",
    "Yearly invoice after trial": "Yearly invoice after trial",
    "Monthly invoice after trial": "Monthly invoice after trial",
    "Trial Seats": "Trial Seats",
    "Change Seats": "Change Seats",
    "Trial includes {cap} seats.": "Trial includes {cap} seats.",
    "Seats used": "Seats used",
    "{used} of {total}": "{used} of {total}",
    "Price / Seat after trial": "Price / Seat after trial",
    "scheduled for deactivation": "scheduled for deactivation",
    "Max Number Of Users": "Max Number Of Users",
    "ACD, Auto Attendant, Skill-Based Routing": "ACD, Auto Attendant, Skill-Based Routing",
    "MP3 Call Recordings Storage": "MP3 Call Recordings Storage",
    "Support Channels": "Support Channels",
    "Support Availability": "Support Availability",
    "Available Seats": "Available Seats",
    "Trial limit: {cap}": "Trial limit: {cap}",
    "Plan Max Users": "Plan Max Users",
    "Trial • {days, plural, one {# day} other {# days}} left": "Trial • {days, plural, one {# day} other {# days}} left",
    "Plan Successfully Changed": "Plan Successfully Changed",
    "The new plan has been added to your account.": "The new plan has been added to your account.",
    "Transaction didn’t go through": "Transaction didn’t go through",
    "Please update your payment method or add funds to complete your purchase.": "Please update your payment method or add funds to complete your purchase.",
    "Start Plan": "Start Plan",
    "Need More Than {cap} Users?": "Need More Than {cap} Users?",
    "Trial includes {cap} seats. Start your {plan} plan to add more users, buy numbers and send business SMS.": "Trial includes {cap} seats. Start your {plan} plan to add more users, buy numbers and send business SMS.",
    "Your trial ends today.": "Your trial ends today.",
    "Plan Max Seats": "Plan Max Seats",
    "Plus tax, numbers, add-ons and any one-time fees.": "Plus tax, numbers, add-ons and any one-time fees.",
    "Your price list: {name}": "Your price list: {name}",
    "Contact support to change your prices.": "Contact support to change your prices.",
    "Your price list is being updated": "Your price list is being updated",
    "Check back in a few minutes.": "Check back in a few minutes.",
    "Your price list is being updated. Your prices will show here when it is ready.": "Your price list is being updated. Your prices will show here when it is ready.",
    "This account has its own price list. Contact support to change it.": "This account has its own price list. Contact support to change it.",
    "Your own price list": "Your own price list",
    "Available on paid plans.": "Available on paid plans.",
    "Upgrade To Continue": "Upgrade To Continue",
    "This feature is included in {plan}, a paid plan.": "This feature is included in {plan}, a paid plan.",
    "Before You Downgrade": "Before You Downgrade",
    "Remove these features": "Remove these features",
    "Not available in new plan": "Not available in new plan",
    "Upon switching you will lose access to these features.": "Upon switching you will lose access to these features.",
    "Some features will have to be removed before you can downgrade the plan.": "Some features will have to be removed before you can downgrade the plan.",
    "Plan change scheduled": "Plan change scheduled",
    "Prorated Charges": "Prorated Charges",
    "/ user / {period}": "/ user / {period}",
    "Nevermind": "Nevermind",
    "After {date}": "After {date}",
    "Tell us what we can improve": "Tell us what we can improve",
    "Optional answer": "Optional answer",
    "Cancel your free plan?": "Cancel your free plan?",
    "End Trial": "End Trial",
    "What happens next": "What happens next",
    "Extend Trial": "Extend Trial",
    "Need more time to decide?": "Need more time to decide?",
    "We'll add {days} free days to your trial so you can finish evaluating.": "We'll add {days} free days to your trial so you can finish evaluating.",
    "Your trial now ends on {date}.": "Your trial now ends on {date}.",
    "Your trial was already extended.": "Your trial was already extended.",
    "We couldn't extend your trial. Please try again.": "We couldn't extend your trial. Please try again.",
    "Verification attempts": "Verification attempts",
    "Attempt {current} of {max}": "Attempt {current} of {max}",
    "We couldn't place the holds on your card. Please try again.": "We couldn't place the holds on your card. Please try again.",
    "Your bank didn't confirm the hold. Try again to finish the check.": "Your bank didn't confirm the hold. Try again to finish the check.",
    "These holds have expired. Place new ones to verify your card.": "These holds have expired. Place new ones to verify your card.",
    "Your card is verified.": "Your card is verified.",
    "Place new holds": "Place new holds",
    "Verify Your Card": "Verify Your Card",
    "Placing two small holds on your card…": "Placing two small holds on your card…",
    "We've placed two temporary holds under $1.00 each on your card. Check your bank app or statement, then enter both exact amounts to verify your card.": "We've placed two temporary holds under $1.00 each on your card. Check your bank app or statement, then enter both exact amounts to verify your card.",
    "They show as {descriptor} on your statement.": "They show as {descriptor} on your statement.",
    "First Transaction Amount": "First Transaction Amount",
    "Second Transaction Amount": "Second Transaction Amount",
    "Card verification failed": "Card verification failed",
    "I couldn't verify my card ending in {last4}. Please help me verify it.": "I couldn't verify my card ending in {last4}. Please help me verify it.",
    "I couldn't verify my card. Please help me verify it.": "I couldn't verify my card. Please help me verify it.",
    "You've reached the limit of card verifications for now. Please contact support to verify your card.": "You've reached the limit of card verifications for now. Please contact support to verify your card.",
    "Your card ending in {last4} was removed and its authorization holds were released. Please add a card to continue.": "Your card ending in {last4} was removed and its authorization holds were released. Please add a card to continue.",
    "Your card was removed and its authorization holds were released. Please add a card to continue.": "Your card was removed and its authorization holds were released. Please add a card to continue.",
    "Add Card": "Add Card",
    "We Couldn't Verify This Card": "We Couldn't Verify This Card",
    "Verify Card": "Verify Card",
    "Verify your card first": "Verify your card first",
    "Your card can't be charged until it's verified. Enter the two small hold amounts from your bank app to finish.": "Your card can't be charged until it's verified. Enter the two small hold amounts from your bank app to finish.",
    "Verify your card. Confirm the two small holds on your card to activate billing.": "Verify your card. Confirm the two small holds on your card to activate billing.",
    "You can finish buying your numbers now.": "You can finish buying your numbers now.",
    "We couldn't verify your card ending in {last4}. Add another card, or contact support for help.": "We couldn't verify your card ending in {last4}. Add another card, or contact support for help.",
    "We couldn't verify your card. Add another card, or contact support for help.": "We couldn't verify your card. Add another card, or contact support for help.",
    "Forwarded": "Forwarded",
    "This user is deactivated or removed. Choose another user.": "This user is deactivated or removed. Choose another user.",
    "This device is disabled, removed, or has no active user. Choose another device.": "This device is disabled, removed, or has no active user. Choose another device.",
    "This extension is removed, or no longer rings an active user. Choose another extension.": "This extension is removed, or no longer rings an active user. Choose another extension.",
    "Click 2 Call integration created": "Click 2 Call integration created",
    "Click 2 Call integration updated": "Click 2 Call integration updated",
    "Forwarded to": "Forwarded to",
    "No numbers available for this country or these filters right now.": "No numbers available for this country or these filters right now.",
    "Phone numbers can't be purchased during a trial. Upgrade your plan to buy numbers.": "Phone numbers can't be purchased during a trial. Upgrade your plan to buy numbers.",
    "Reconnect": "Reconnect",
    "Disconnect WhatsApp number": "Disconnect WhatsApp number",
    "{number} stops sending and receiving messages. Any monthly charge for it stops at the end of the billing period. Your other numbers stay connected.": "{number} stops sending and receiving messages. Any monthly charge for it stops at the end of the billing period. Your other numbers stay connected.",
    "Failed to disconnect the WhatsApp number. Please try again.": "Failed to disconnect the WhatsApp number. Please try again.",
    "Failed to reconnect the WhatsApp number. Please try again.": "Failed to reconnect the WhatsApp number. Please try again.",
    "WhatsApp is available on the Core and Advanced plans.": "WhatsApp is available on the Core and Advanced plans.",
    "Reconnect WhatsApp number": "Reconnect WhatsApp number",
    "{number} starts sending and receiving messages again. If your plan charges per WhatsApp number, a new charge for the rest of this billing period starts today.": "{number} starts sending and receiving messages again. If your plan charges per WhatsApp number, a new charge for the rest of this billing period starts today.",
    "Rang": "Rang",
    "Callee hung up": "Callee hung up",
    "Ended by the system": "Ended by the system",
    "Holiday": "Holiday",
    "Transfer hold": "Transfer hold",
    "Pressed {digit}": "Pressed {digit}",
    "Rang: {names}": "Rang: {names}",
    "Rang: {names} +{more} more": "Rang: {names} +{more} more",
    "Could not load the call details": "Could not load the call details",
    "No details were recorded for this call": "No details were recorded for this call",
    "Device": "Device",
    "Trunk": "Trunk",
    "Feature code": "Feature code",
    "Queue full": "Queue full",
    "Wait time too long": "Wait time too long",
    "This person already accepted the invitation. Open them again from the refreshed list to edit.": "This person already accepted the invitation. Open them again from the refreshed list to edit.",
    "Due now (each)": "Due now (each)",
    "You haven't accepted your invitation yet. Open the invitation email to set up your account.": "You haven't accepted your invitation yet. Open the invitation email to set up your account.",
    "A new invitation was sent to {name}. There is no need to resend it.": "A new invitation was sent to {name}. There is no need to resend it.",
    "{name} has been notified by email.": "{name} has been notified by email.",
    "You are about to invite {name} as a team member": "You are about to invite {name} as a team member",
    "This person still receives calls from a phone number, extension, IVR, queue, flow or another user. Change those first, then delete the invitation.": "This person still receives calls from a phone number, extension, IVR, queue, flow or another user. Change those first, then delete the invitation.",
    "Deleting the invitation did not finish. Please try again.": "Deleting the invitation did not finish. Please try again.",
    "We couldn't load this flow. Check your connection and try again.": "We couldn't load this flow. Check your connection and try again.",
    "The embed code is not available in this environment.": "The embed code is not available in this environment.",
    "This widget moved from the previous platform. Its old embed code still works for now: replace it with the code below on every site that uses it.": "This widget moved from the previous platform. Its old embed code still works for now: replace it with the code below on every site that uses it.",
    "This widget was changed elsewhere. Reload the page and try again.": "This widget was changed elsewhere. Reload the page and try again.",
    "Your plan allows no more web widgets.": "Your plan allows no more web widgets.",
    "This widget no longer exists.": "This widget no longer exists.",
    "Back to integrations": "Back to integrations",
    "Delete this widget? Every site that embeds it stops showing it.": "Delete this widget? Every site that embeds it stops showing it.",
    "Switched off, the widget shows on no website.": "Switched off, the widget shows on no website.",
    "Remove “{label}” from the question library? Routes that already ask it keep their copy.": "Remove “{label}” from the question library? Routes that already ask it keep their copy.",
    "Visitors are not offered chat until you pick who answers it": "Visitors are not offered chat until you pick who answers it",
    "The widget was saved, but some chats are not routed yet.": "The widget was saved, but some chats are not routed yet.",
    "This person can no longer answer chats": "This person can no longer answer chats",
    "This inbox is no longer available": "This inbox is no longer available",
    "Chat could not be routed here. Save again to retry.": "Chat could not be routed here. Save again to retry.",
    "Where chats go could not be loaded. Reload the page to change it.": "Where chats go could not be loaded. Reload the page to change it.",
    "This widget could not be loaded.": "This widget could not be loaded.",
    "Website chat": "Website chat",
    "Website visitor": "Website visitor",
    "This chat has ended.": "This chat has ended.",
    "chat system visitor left": "The visitor left the chat.",
    "chat system visitor ended": "The visitor ended the chat.",
    "chat system timed out": "The chat timed out.",
    "chat system route removed": "The chat ended because its route was removed.",
    "chat system route changed": "The chat ended because its route was changed.",
    "Visitors can send files": "Visitors can send files",
    "Files: images, PDF, Office documents, text, audio and MP4 video.": "Files: images, PDF, Office documents, text, audio and MP4 video.",
    "Show agent names to visitors": "Show agent names to visitors",
    "When off, visitors see \"Agent\" instead of names.": "When off, visitors see \"Agent\" instead of names.",
    "Send offline messages to": "Send offline messages to",
    "When this route is closed, visitors can leave a message that is emailed here.": "When this route is closed, visitors can leave a message that is emailed here.",
    "Name shown in website chats": "Name shown in website chats",
    "Website visitors see this name when you chat with them. Leave empty to use your first name.": "Website visitors see this name when you chat with them. Leave empty to use your first name.",
    "Website visitors see this name when this user chats with them. Leave empty to use their first name.": "Website visitors see this name when this user chats with them. Leave empty to use their first name.",
    "This name cannot contain @": "This name cannot contain @",
    "This name is reserved. Choose another one.": "This name is reserved. Choose another one.",
    "Allowed websites": "Allowed websites",
    "Only these websites can show the widget, one per line (example.com and www.example.com count as two). Leave empty to let any website show it.": "Only these websites can show the widget, one per line (example.com and www.example.com count as two). Leave empty to let any website show it.",
    "Enter a website address like https://example.com": "Enter a website address like https://example.com",
    "Up to {count} websites": "Up to {count} websites",
    "Privately held company": "Privately held company",
    "NYSE American (AMEX)": "NYSE American (AMEX)",
    "Euronext Amsterdam (AMX)": "Euronext Amsterdam (AMX)",
    "Gambling and Lottery": "Gambling and Lottery",
    "tax number": "tax number",
    "ZIP code": "ZIP code",
    "postal code": "postal code",
    "Your plan, or the one you're moving to, doesn't include WhatsApp. Update your plan to use it.": "Your plan, or the one you're moving to, doesn't include WhatsApp. Update your plan to use it.",
    "This card was removed, so there's nothing to verify.": "This card was removed, so there's nothing to verify.",
    "Enter both amounts.": "Enter both amounts.",
    "Enter each amount in dollars with up to 2 decimals, for example 0.57.": "Enter each amount in dollars with up to 2 decimals, for example 0.57.",
    "Each hold is between $0.01 and $0.99. Enter it in dollars, for example 0.57.": "Each hold is between $0.01 and $0.99. Enter it in dollars, for example 0.57.",
    "Outside calls start once the account's card is verified": "Outside calls start once the account's card is verified",
    "Some features are unavailable. Your account admin needs to finish billing setup.": "Some features are unavailable. Your account admin needs to finish billing setup.",
    "Invalid authorization amounts, please try again. You have {count} attempts left.": "Invalid authorization amounts, please try again. You have {count} attempts left.",
    "Invalid authorization amounts. You have 1 attempt left: a wrong answer removes this card.": "Invalid authorization amounts. You have 1 attempt left: a wrong answer removes this card.",
    "Partly saved": "Partly saved",
    "This person still receives calls from {routes}. Change those first, then delete the invitation.": "This person still receives calls from {routes}. Change those first, then delete the invitation.",
    "Searching by UUID finds that call on any date, ignoring the other filters": "Searching by UUID finds that call on any date, ignoring the other filters",
    "SIP Call-ID": "SIP Call-ID",
    "1 connected + 1 held/waiting call": "1 connected + 1 held/waiting call",
    "Auto attendants (IVR)": "Auto attendants (IVR)",
    "CRM connectors": "CRM connectors",
    "Email & chat support": "Email & chat support",
    "1 connected + up to 2 held/waiting calls": "1 connected + up to 2 held/waiting calls",
    "Call queues, up to 50 waiting calls": "Call queues, up to 50 waiting calls",
    "Progressive dialer": "Progressive dialer",
    "AI transcription & summaries, 40 hours": "AI transcription & summaries, 40 hours",
    "Priority email & chat": "Priority email & chat",
    "1 connected + up to 5 held/waiting calls": "1 connected + up to 5 held/waiting calls",
    "Queues with no hard limit": "Queues with no hard limit",
    "Skill-based routing": "Skill-based routing",
    "Predictive dialer": "Predictive dialer",
    "AI transcription & summaries, unlimited": "AI transcription & summaries, unlimited",
    "Priority email, chat & phone, SLA": "Priority email, chat & phone, SLA",
    "1 connected + 1 held/waiting": "1 connected + 1 held/waiting",
    "1 connected + up to 2 held/waiting": "1 connected + up to 2 held/waiting",
    "1 connected + up to 5 held/waiting": "1 connected + up to 5 held/waiting",
    "Auto Attendant, Call Queues": "Auto Attendant, Call Queues",
    "Hours count": "{count} Hours",
    "Priority Email / Chat": "Priority Email / Chat",
    "Calls Per User": "Calls Per User",
    "How many calls one user can handle at once: one connected, plus calls on hold or waiting": "How many calls one user can handle at once: one connected, plus calls on hold or waiting",
    "AI Transcription & Summaries": "AI Transcription & Summaries",
    "Automatic call transcripts and summaries": "Automatic call transcripts and summaries",
    "Priority Email / Chat / Phone, SLA": "Priority Email / Chat / Phone, SLA",
    "Your plan is set to cancel. Undo the cancellation to change it.": "Your plan is set to cancel. Undo the cancellation to change it."
}
